export const customItems = [
  { id: "customItems-1", label: "Analysis against Performance on GRI Standards Progress" },
  { id: "customItems-2", label: "Gap Analysis and Action Report (Table)" },
  { id: "customItems-3", label: "GRI Standards Cross-References" },
  { id: "customItems-4", label: "Industry Benchmark Score" },
  { id: "customItems-5", label: "Risk/Opportunity Heatmap" },
  { id: "customItems-6", label: "Full ESG GRI Progress Report" },
  { id: "customItems-7", label: "Any other relevant report", checked: false, customName: "" },
];
export const customItemssasb = [
  { id: "customItemssasb-1", label: "Analysis against Performance on SASB Standards Progress" },
  { id: "customItemssasb-2", label: "Gap Analysis and Action Report (Table)" },
  { id: "customItemssasb-3", label: "SASB Standards Cross-References" },
  { id: "customItemssasb-4", label: "Industry Benchmark Score" },
  { id: "customItemssasb-5", label: "Materiality Assessment (Risk Assessment)" },
  { id: "customItemssasb-6", label: "SASB Materiality Map Report" },
  { id: "customItemssasb-7", label: "Risk & Opportunity Matrix" },
  { id: "customItemssasb-8", label: "ISSB Alignment Preview (especially with IFRS S1/S2)" },
  { id: "customItemssasb-9", label: "Industrial ESG Matrix Sheet" },
  { id: "customItemssasb-10", label: "GHG Emissions & Climate Change" },
  { id: "customItemssasb-11", label: "Sustainability-related Risks and Opportunities Report" },
  { id: "customItemssasb-12", label: "Sector Peer Benchmark Report" },
  { id: "customItemssasb-13", label: "Sustainability-related Financial Disclosures Report" },
  { id: "customItemssasb-14", label: "Full SASB Progress Report" },
  { id: "customItemssasb-15", label: "Any other relevant report", checked: false, customName: "" },
];
export const customItemsScenarioAnalysis = [
  { id: "customItemsScenarioAnalysis-1", label: "TCFD Gap Analysis & Readiness Report" },
  { id: "customItemsScenarioAnalysis-2", label: "Climate Scenario Impact Assessment" },
  { id: "customItemsScenarioAnalysis-3", label: "Climate Risk & Opportunity Matrix" },
  { id: "customItemsScenarioAnalysis-4", label: "Materiality Scoring" },
  { id: "customItemsScenarioAnalysis-5", label: "Climate Metrics & Targets Tracker" },
  { id: "customItemsScenarioAnalysis-6", label: "Performance tracking against TCFD" },
  { id: "customItemsScenarioAnalysis-7", label: "Decarbonization Roadmap" },
  { id: "customItemsScenarioAnalysis-8", label: "Audit-Ready Disclosure Package" },
  { id: "customItemsScenarioAnalysis-9", label: "TCFD Cross references table" },
  { id: "customItemsScenarioAnalysis-10", label: "Board Climate Governance Report" },
  { id: "customItemsScenarioAnalysis-11", label: "TCFD Full Climate Disclosure Report" },
  { id: "customItemsScenarioAnalysis-12", label: "Any other relevant report", checked: false, customName: "" },
];
export const customItemsIFRS = [
  { id: "customItemsIFRS-1", label: "Performance Tracking Report (against IFRS S1 pillars)" },
  { id: "customItemsIFRS-2", label: "Metrics & Targets Dashboard" },
  { id: "customItemsIFRS-3", label: "Materiality Heat Map & Assessment Report" },
  { id: "customItemsIFRS-4", label: "Emissions Profile & Reduction Progress Report" },
  { id: "customItemsIFRS-5", label: "Climate Scenario Impact Assessment" },
  { id: "customItemsIFRS-6", label: "Sustainability Risk & Opportunity Register" },
  { id: "customItemsIFRS-7", label: "IFRS S1 Gap Analysis Report" },
  { id: "customItemsIFRS-8", label: "Framework Cross-Reference Report (IFRS S1 vs. ISSB, SASB, GRI)" },
  { id: "customItemsIFRS-9", label: "Full IFRS-Aligned Disclosure Report" },
  { id: "customItemsIFRS-10", label: "Any other relevant report", checked: false, customName: "" },
];

export const customItemsIFRS2 = [
  { id: "customItemsIFRS2-1", label: "Performance Tracking Report (against IFRS S1 pillars)" },
  { id: "customItemsIFRS2-2", label: "Metrics & Targets Dashboard" },
  { id: "customItemsIFRS2-3", label: "Materiality Heat Map & Assessment Report" },
  { id: "customItemsIFRS2-4", label: "Emissions Profile & Reduction Progress Report" },
  { id: "customItemsIFRS2-5", label: "Climate Scenario Impact Assessment" },
  { id: "customItemsIFRS2-6", label: "Sustainability Risk & Opportunity Register" },
  { id: "customItemsIFRS2-7", label: "IFRS S2 Gap Analysis Report" },
  { id: "customItemsIFRS2-8", label: "Framework Cross-Reference Report (IFRS S1 vs. ISSB, SASB, GRI)" },
  { id: "customItemsIFRS2-9", label: "Full IFRS-Aligned Disclosure Report" },
  { id: "customItemsIFRS2-10", label: "Any other relevant report", checked: false, customName: "" },
];
export const customItemsESRS = [
  { id: "customItemsESRS-1", label: "Full ESRS-Aligned Sustainability Report" },
  { id: "customItemsESRS-2", label: "Double Materiality Assessment Report" },
  { id: "customItemsESRS-3", label: "Materiality Matrix Analysis" },
  { id: "customItemsESRS-4", label: "Stakeholder Engagement Summary Report" },
  { id: "customItemsESRS-5", label: "Value Chain Impact Report" },
  { id: "customItemsESRS-6", label: "Sustainability Action Plan" },
  { id: "customItemsESRS-7", label: "Risk & Opportunity Register (IRO)" },
  { id: "customItemsESRS-8", label: "Climate Transition Plan Tracker (E1)" },
  { id: "customItemsESRS-9", label: "GHG Emissions Inventory Report (E1-6)" },
  { id: "customItemsESRS-10", label: "Pollution Impact & Emissions Report (E2)" },
  { id: "customItemsESRS-11", label: "Water and Marine Dependency Report (E3)" },
  { id: "customItemsESRS-12", label: "Biodiversity and Ecosystem Risk Report (E4)" },
  { id: "customItemsESRS-13", label: "Circular Economy & Resource Efficiency Tracker (E5)" },
  { id: "customItemsESRS-14", label: "Own Workforce Social Metrics Report (S1)" },
  { id: "customItemsESRS-15", label: "Supply Chain Labor Risk Assessment (S2)" },
  { id: "customItemsESRS-16", label: "Community Impact and Mitigation Report (S3)" },
  { id: "customItemsESRS-17", label: "Product Safety Report (S4)" },
  { id: "customItemsESRS-18", label: "Disclosure Gap Analysis Report" },
  { id: "customItemsESRS-19", label: "Sustainability Data Completeness Tracker" },
  { id: "customItemsESRS-20", label: "Crosswalk Mapping Report (ESRS ↔ GRI / TCFD / ISSB)" },
  { id: "customItemsESRS-21", label: "Sustainability Statement (AR 1 Format)" },
  { id: "customItemsESRS-22", label: "Integrated Management Report for CSRD" },
  { id: "customItemsESRS-23", label: "Sector-Specific Disclosure Tracker (Future ESRS)" },
  { id: "customItemsESRS-24", label: "Sustainability Performance Target Tracker" },
  { id: "customItemsESRS-25", label: "Any other relevant report", checked: false, customName: "" },
];
export const ungcReportItems = [
  { id: "ungcReportItems-1", label: "UNGC Self-Assessment Report" },
  { id: "ungcReportItems-2", label: "UNGC–SDG Alignment Report" },
  { id: "ungcReportItems-3", label: "UNGC Principle Gap Analysis" },
  { id: "ungcReportItems-4", label: "UNGC Framework Crosswalk Report" },
  { id: "ungcReportItems-5", label: "Human Rights & Labour Risk Assessment" },
  { id: "ungcReportItems-6", label: "Environmental Responsibility & Performance Tracker" },
  { id: "ungcReportItems-7", label: "Anti-Corruption Controls Review" },
  { id: "ungcReportItems-8", label: "UNGC Implementation Timeline Tracker" },
  { id: "ungcReportItems-9", label: "Full UNGC Compliance Report" },
  { id: "ungcReportItems-10", label: "Any other relevant report", checked: false, customName: "" },
];
export const sdgReportItems = [
  { id: "sdgReportItems-1", label: "Vulnerable Group Impact Assessment" },
  { id: "sdgReportItems-2", label: "SDG Gap Report" },
  { id: "sdgReportItems-3", label: "SDG Materiality Assessment" },
  { id: "sdgReportItems-4", label: "Health & Safety Metrics" },
  { id: "sdgReportItems-5", label: "SDG Impact Monitoring Report" },
  { id: "sdgReportItems-6", label: "SDG Progress Report" },
  { id: "sdgReportItems-7", label: "Training & Capacity Building Tracker" },
  { id: "sdgReportItems-8", label: "Stakeholder SDG Summary" },
  { id: "sdgReportItems-9", label: "Gender Equity Analysis" },
  { id: "sdgReportItems-10", label: "SDG KPI Report (Gender Indicators)" },
  { id: "sdgReportItems-11", label: "Water Risk Assessment" },
  { id: "sdgReportItems-12", label: "Labor Rights Compliance Report" },
  { id: "sdgReportItems-13", label: "Alternative Energy Initiatives Alignment with SDG" },
  { id: "sdgReportItems-14", label: "ESG–SDG Crosswalk Analysis (Tech Focus)" },
  { id: "sdgReportItems-15", label: "Equity & Inclusion Report" },
  { id: "sdgReportItems-16", label: "Risk Mapping Including Climate Resilient Infrastructure Report" },
  { id: "sdgReportItems-17", label: "Circular Economy Aligned Report" },
  { id: "sdgReportItems-18", label: "Resource Efficiency Report" },
  { id: "sdgReportItems-19", label: "GHG Inventory Report, SDG 13 Tracker" },
  { id: "sdgReportItems-20", label: "Climate Risk Heatmap" },
  { id: "sdgReportItems-21", label: "Marine Impact Report" },
  { id: "sdgReportItems-22", label: "Water Pollution Assessment" },
  { id: "sdgReportItems-23", label: "Biodiversity Risk Analysis" },
  { id: "sdgReportItems-24", label: "Deforestation-Free Supply Chain Report" },
  { id: "sdgReportItems-25", label: "Governance Compliance Report" },
  { id: "sdgReportItems-26", label: "Anti-Corruption and Compliance Report" },
  { id: "sdgReportItems-27", label: "Stakeholder Engagement Report" },
  { id: "sdgReportItems-28", label: "Public–Private SDG Cooperation Report" },
  { id: "sdgReportItems-29", label: "Full SDG Alignment Report" },
  { id: "sdgReportItems-30", label: "Any other relevant report", checked: false, customName: "" },
];
export const cdpReportItems = [
  { id: "cdpReportItems-1", label: "GHG Emissions Inventory (Scope 1, 2, 3)" },
  { id: "cdpReportItems-2", label: "Emissions Reduction Performance Report" },
  { id: "cdpReportItems-3", label: "Internal Carbon Pricing Analysis" },
  { id: "cdpReportItems-4", label: "Science-Based Targets (SBTi) Alignment Report" },
  { id: "cdpReportItems-5", label: "Climate Risk & Opportunity Assessment (Physical & Transition)" },
  { id: "cdpReportItems-6", label: "Climate Scenario Analysis (e.g., IEA, IPCC pathways)" },
  { id: "cdpReportItems-7", label: "Climate Impact on Financial Planning Report" },
  { id: "cdpReportItems-8", label: "CDP Climate Disclosure Readiness Scorecard" },
  { id: "cdpReportItems-9", label: "Water Risk Exposure" },
  { id: "cdpReportItems-10", label: "Water Use & Efficiency Performance Report" },
  { id: "cdpReportItems-11", label: "Water-Related Risk Mitigation Strategy Tracker" },
  { id: "cdpReportItems-12", label: "Water Stress and Resilience Scorecard" },
  { id: "cdpReportItems-13", label: "Wastewater Management & Compliance Report" },
  { id: "cdpReportItems-14", label: "Forest-Risk Commodity Sourcing Assessment" },
  { id: "cdpReportItems-15", label: "Forest Certification Compliance Report (FSC, RSPO, etc.)" },
  { id: "cdpReportItems-16", label: "Land Use Change Monitoring Report" },
  { id: "cdpReportItems-17", label: "Forest Risk Engagement with Suppliers Report" },
  { id: "cdpReportItems-18", label: "Forest Impact Risk Matrix (Regulatory & Reputational)" },
  { id: "cdpReportItems-19", label: "Supplier Traceability & Source Origin Report" },
  { id: "cdpReportItems-20", label: "Scope 3 (Upstream) Supplier Emissions Report" },
  { id: "cdpReportItems-21", label: "Supplier Climate Target Adoption Scorecard" },
  { id: "cdpReportItems-22", label: "Supplier Engagement & Capacity Building Report" },
  { id: "cdpReportItems-23", label: "Supplier Climate Performance Monitoring Tracker" },
  { id: "cdpReportItems-24", label: "CDP–TCFD Alignment Report" },
  { id: "cdpReportItems-25", label: "CDP–ESRS Climate Module Crosswalk" },
  { id: "cdpReportItems-26", label: "CDP–IFRS S2 Readiness Report" },
  { id: "cdpReportItems-27", label: "CDP Disclosure Completion Tracker" },
  { id: "cdpReportItems-28", label: "CDP Submission Readiness & Gap Analysis" },
  { id: "cdpReportItems-29", label: "Any other relevant report", checked: false, customName: "" },
];
export const wbReportItems = [
  { id: "wbReportItems-1", label: "Environmental and Social Risk Matrix" },
  { id: "wbReportItems-2", label: "Environmental and Social Due Diligence Assessment (ESDD)" },
  { id: "wbReportItems-3", label: "Impact Assessment Summary Report" },
  { id: "wbReportItems-4", label: "Labor & Working Conditions Compliance Report" },
  { id: "wbReportItems-5", label: "Resource Efficiency & Pollution Prevention Report" },
  { id: "wbReportItems-6", label: "Community Health & Safety Evaluation" },
  { id: "wbReportItems-7", label: "Resettlement & Compensation Tracker" },
  { id: "wbReportItems-8", label: "Biodiversity Risk Assessment" },
  { id: "wbReportItems-9", label: "Biodiversity Reports" },
  { id: "wbReportItems-10", label: "Indigenous Peoples Engagement Tracker" },
  { id: "wbReportItems-11", label: "Cultural Heritage Monitoring Report" },
  { id: "wbReportItems-12", label: "FI Subproject Compliance Review" },
  { id: "wbReportItems-13", label: "Stakeholder Engagement Effectiveness Report" },
  { id: "wbReportItems-14", label: "Gap Analysis & Corrective Action Report" },
  { id: "wbReportItems-15", label: "Grievance Redress System Tracker" },
  { id: "wbReportItems-16", label: "Stakeholder Mapping & Influence Matrix" },
  { id: "wbReportItems-17", label: "Cumulative Impact Tracker" },
  { id: "wbReportItems-18", label: "Audit-Ready Compliance Checklist" },
  { id: "wbReportItems-19", label: "Adaptive Management Performance Review" },
  { id: "wbReportItems-20", label: "Annual Environmental and Social Progress Report" },
  { id: "wbReportItems-21", label: "Full World Bank Safeguard Compliance Report" },
  { id: "wbReportItems-22", label: "Any other relevant report", checked: false, customName: "" },
];
export const ifcReportItems = [
  { id: "ifcReportItems-1", label: "Full IFC Performance Standards Compliance Report" },
  { id: "ifcReportItems-2", label: "Crosswalk Alignment Report" },
  {
    id: "ifcReportItems-3", label:
      "Environmental and Social Management System (ESMS) Implementation Report",
  },
  {
    id: "ifcReportItems-4", label: "ESAP (Environmental and Social Action Plan) Monitoring Action Plan",
  },
  { id: "ifcReportItems-5", label: "IFC-Aligned Gap Analysis Report" },
  { id: "ifcReportItems-6", label: "IFC Risk Categorization Matrix (High, Medium, Low)" },
  { id: "ifcReportItems-7", label: "Stakeholder Engagement & Disclosure Summary Report" },
  { id: "ifcReportItems-8", label: "IFC Audit-Ready Documentation Tracker" },
  { id: "ifcReportItems-9", label: "Monitoring & Evaluation Framework Status Report" },
  { id: "ifcReportItems-10", label: "Labor & Working Conditions Compliance Review" },
  { id: "ifcReportItems-11", label: "Occupational Health and Safety (OHS) Matrix" },
  { id: "ifcReportItems-12", label: "Worker Grievance Management Report" },
  { id: "ifcReportItems-13", label: "GHG Emissions & Intensity Reporting (Scope 1 & 2)" },
  { id: "ifcReportItems-14", label: "Energy & Water Use Efficiency Report" },
  { id: "ifcReportItems-15", label: "Community Risk & Safety Assessment Report" },
  { id: "ifcReportItems-16", label: "Resettlement Action Plan (RAP) Implementation Report" },
  { id: "ifcReportItems-17", label: "Compensation Disbursement Tracker" },
  { id: "ifcReportItems-18", label: "Livelihood Restoration Effectiveness Report" },
  { id: "ifcReportItems-19", label: "Biodiversity Risk & Impact Report" },
  { id: "ifcReportItems-20", label: "Biodiversity Monitoring Indicators Tracker" },
  { id: "ifcReportItems-21", label: "Indigenous Peoples Plan (IPP) Implementation Tracker" },
  { id: "ifcReportItems-22", label: "Cultural Heritage Management Plan (CHMP) Monitoring Report" },
  { id: "ifcReportItems-23", label: "Any other relevant report", checked: false, customName: "" },
];
export const epReportItems = [
  { id: "epReportItems-1", label: "Equator Principles Compliance Report" },
  { id: "epReportItems-2", label: "Project Risk Categorization Report" },
  { id: "epReportItems-3", label: "EP Action Plan Implementation Report (EPAP)" },
  { id: "epReportItems-4", label: "Environmental & Social Risk Matrix" },
  { id: "epReportItems-5", label: "Stakeholder Engagement & FPIC Report" },
  { id: "epReportItems-6", label: "GRM Performance Dashboard" },
  { id: "epReportItems-7", label: "Independent Review Validation Log" },
  { id: "epReportItems-8", label: "Action Plan & Monitoring Tracker" },
  { id: "epReportItems-9", label: "Annual Lender Compliance Submission Pack" },
  { id: "epReportItems-10", label: "Gap Analysis and Remediation Tracker" },
  { id: "epReportItems-11", label: "ESMS Operational Effectiveness Review" },
  { id: "epReportItems-12", label: "Public Transparency Disclosure Sheet" },
  { id: "epReportItems-13", label: "Cross-Framework Report" },
  { id: "epReportItems-14", label: "Any other relevant report", checked: false, customName: "" },
];
export const isoReportItems = [
  { id: "isoReportItems-1", label: "ISO Compliance Dashboard (By Standard)" },
  { id: "isoReportItems-2", label: "Internal Audit & Non-Conformance Report" },
  { id: "isoReportItems-3", label: "ISO Certification Tracker Report" },
  { id: "isoReportItems-4", label: "Non-Conformance Register (Multi-Standard)" },
  { id: "isoReportItems-5", label: "Corrective Action and Preventive Action (CAPA) Tracker" },
  { id: "isoReportItems-6", label: "ISO 31000 Risk Assessment Matrix" },
  { id: "isoReportItems-7", label: "ISO 9001 QMS Performance Review" },
  { id: "isoReportItems-8", label: "ISO 14001 Environmental Risk & Aspect Register" },
  { id: "isoReportItems-9", label: "ISO 45001 H&S Risk Analysis & Incident Log" },
  { id: "isoReportItems-10", label: "ISO 50001 Energy Efficiency & Usage Report" },
  { id: "isoReportItems-11", label: "GHG Emissions & Reduction Analysis (ISO 14064)" },
  { id: "isoReportItems-12", label: "Social Responsibility Implementation Report (ISO 26000)" },
  { id: "isoReportItems-13", label: "ISO Crosswalk Report" },
  { id: "isoReportItems-14", label: "ISO Policy Gap Analysis (Integrated Standards)" },
  { id: "isoReportItems-15", label: "ISO-Based ESG Maturity Index" },
  { id: "isoReportItems-16", label: "Anti-Bribery Compliance Report (ISO 37001:2025)" },
  { id: "isoReportItems-17", label: "Annual ISO Compliance Statement" },
  { id: "isoReportItems-18", label: "Any other relevant report", checked: false, customName: "" },
];
export const oecdReportItems = [
  { id: "oecdReportItems-1", label: "Full OECD Compliance & Readiness Reports" },
  { id: "oecdReportItems-2", label: "OECD Due Diligence Implementation Tracker" },
  { id: "oecdReportItems-3", label: "OECD Risk Categorization Matrix" },
  { id: "oecdReportItems-4", label: "Enterprise-Level ESG Risk Register (OECD-based)" },
  { id: "oecdReportItems-5", label: "Human Rights Due Diligence (HRDD) Report" },
  { id: "oecdReportItems-6", label: "Environmental Risk & Disclosure Matrix" },
  { id: "oecdReportItems-7", label: "Green Innovation & Technology Adoption Report" },
  { id: "oecdReportItems-8", label: "Resource Efficiency Analysis" },
  { id: "oecdReportItems-9", label: "Anti-Bribery Compliance Assessment Report" },
  { id: "oecdReportItems-10", label: "SEP Engagement Log & Complaint History" },
  { id: "oecdReportItems-11", label: "OECD Crosswalk Alignment Report" },
  { id: "oecdReportItems-12", label: "Any other relevant report", checked: false, customName: "" },
];
export const tnfdReportItems = [
  { id: "tnfdReportItems-1", label: "Nature-Related Risk Register (LEAP Output)" },
  { id: "tnfdReportItems-2", label: "Physical Risk Impact Analysis (Acute/Chronic)" },
  { id: "tnfdReportItems-3", label: "Ecosystem Dependency & Impact Report" },
  { id: "tnfdReportItems-4", label: "TNFD Metrics & Target Progress Tracker" },
  { id: "tnfdReportItems-5", label: "Nature Positive Transition Plan" },
  { id: "tnfdReportItems-6", label: "Sector-Location Nature Risk Heatmap" },
  { id: "tnfdReportItems-7", label: "GHG Emissions Inventory Report (Scope 1–3)" },
  { id: "tnfdReportItems-8", label: "Biodiversity Impact Disclosure Report" },
  { id: "tnfdReportItems-9", label: "TNFD Readiness & Gap Assessment Report" },
  { id: "tnfdReportItems-10", label: "TNFD Crosswalk Report" },
  { id: "tnfdReportItems-11", label: "Geospatial Nature Risk Report" },
  { id: "tnfdReportItems-12", label: "Full TNFD-Aligned Disclosure Report" },
  { id: "tnfdReportItems-13", label: "Any other relevant report", checked: false, customName: "" },
];
export const aaSeriesReportItems = [
  { id: "aaSeriesReportItems-1", label: "Stakeholder Engagement Report" },
  { id: "aaSeriesReportItems-2", label: "Materiality Determination Report" },
  { id: "aaSeriesReportItems-3", label: "GHG Assurance Report" },
  { id: "aaSeriesReportItems-4", label: "Inclusivity and Responsiveness Report" },
  { id: "aaSeriesReportItems-5", label: "Stakeholder Influence and Engagement Level Matrix" },
  { id: "aaSeriesReportItems-6", label: "Engagement Effectiveness Assessment" },
  { id: "aaSeriesReportItems-7", label: "Materiality Assessment (Internal + Stakeholder)" },
  { id: "aaSeriesReportItems-8", label: "Risk and Opportunity Assessment" },
  { id: "aaSeriesReportItems-9", label: "Stakeholder Grievance and Issue Log Analysis" },
  { id: "aaSeriesReportItems-10", label: "Stakeholder Dialogue Feedback Loop Analysis" },
  { id: "aaSeriesReportItems-11", label: "Cross-Standard Assurance Mapping" },
  { id: "aaSeriesReportItems-12", label: "Inclusivity Gap Analysis" },
  { id: "aaSeriesReportItems-13", label: "KPI Assurance Consistency Check" },
  { id: "aaSeriesReportItems-14", label: "Any other relevant report", checked: false, customName: "" },
];
export const priPrincipleReportItems = [
  { id: "priPrincipleReportItems-1", label: "Full PRI Compliance Report" },
  { id: "priPrincipleReportItems-2", label: "PRI Transparency Report" },
  { id: "priPrincipleReportItems-3", label: "ESG Integration Practices Report" },
  { id: "priPrincipleReportItems-4", label: "ESG Target Monitoring Report" },
  { id: "priPrincipleReportItems-5", label: "ESG Disclosure Advocacy Report" },
  { id: "priPrincipleReportItems-6", label: "Active Ownership & Engagement Report" },
  { id: "priPrincipleReportItems-7", label: "SDG-Aligned Investment Report" },
  { id: "priPrincipleReportItems-8", label: "Net-Zero and Climate-Aligned Investment Report" },
  { id: "priPrincipleReportItems-9", label: "ESG Disclosure Advocacy Report" }, // This appears twice — want me to dedupe or keep?
  { id: "priPrincipleReportItems-10", label: "Transition & Social Investment Report" },
  { id: "priPrincipleReportItems-11", label: "PRI Principle-by-Principle Maturity Assessment" },
  { id: "priPrincipleReportItems-12", label: "Responsible Investment Readiness Assessment" },
  { id: "priPrincipleReportItems-13", label: "ESG Materiality Assessment for Investment Strategy" },
  { id: "priPrincipleReportItems-14", label: "Gap Assessment on PRI Compliances" },
  { id: "priPrincipleReportItems-15", label: "Collaborative Engagement Readiness Assessment" },
  { id: "priPrincipleReportItems-16", label: "Portfolio ESG Exposure Analysis" },
  { id: "priPrincipleReportItems-17", label: "PRI Reporting Progress Tracker" },
  { id: "priPrincipleReportItems-18", label: "PRI Cross walk Analysis" },
  { id: "priPrincipleReportItems-19", label: "Any other relevant report", checked: false, customName: "" },
];

export const industrailIdentification = [
  {
    id: "industrailIdentification-1", label: "Construction & Infrastructure",
  },
  {
    id: "industrailIdentification-2", label: "Manufacturing (Food, Industrial Goods, Chemicals)",
  },
  {
    id: "industrailIdentification-3", label: "Energy (Renewable, Fossil, Transmission, Distribution)",
  },
  {
    id: "industrailIdentification-4", label: "IT & Data Centers",
  },
  {
    id: "industrailIdentification-5", label: "Warehousing & Logistics",
  },
  {
    id: "industrailIdentification-6", label: "Transportation & Mobility Services",
  },
  {
    id: "industrailIdentification-7", label: "Agriculture & Food Processing",
  },
  {
    id: "industrailIdentification-8", label: "Mining and Extractives",
  },
  {
    id: "industrailIdentification-9", label: "Retail and Consumer Goods",
  },
  {
    id: "industrailIdentification-10", label: "Healthcare and Pharmaceuticals",
  },
  {
    id: "industrailIdentification-11", label: "Financial and Insurance Services",
  },
  {
    id: "industrailIdentification-12", label: "Public Services / Government Projects",
  },
  {
    id: "industrailIdentification-13", label: "Consulting and Professional Services",
  },
  {
    id: "industrailIdentification-14", label: "Telecommunications and Media",
  },
  { id: "industrailIdentification-15", label: "Any other relevant report", checked: false, customName: "" },
];

export const natureOfActivities = [
  {
    id: "natureOfActivities-1", label: "New Construction (Buildings, Roads, Infrastructure, Bridges)",
  },
  {
    id: "natureOfActivities-2", label: "Plant Operations (Industrial Production, Chemical Processing)",
  },
  {
    id: "natureOfActivities-3", label: "Equipment Installation, Commissioning, and Testing",
  },
  {
    id: "natureOfActivities-4", label: "Survey, Monitoring, Inspection Field Work",
  },
  {
    id: "natureOfActivities-5", label: "Logistics and Warehousing Operations",
  },
  {
    id: "natureOfActivities-6", label: "Procurement, Supplier, and Vendor Management",
  },
  {
    id: "natureOfActivities-7", label: "Vehicle Fleet and Corporate Office Operations",
  },
  {
    id: "natureOfActivities-8", label: "Maintenance and Repair Services",
  },
  {
    id: "natureOfActivities-9", label: "Renewable Energy Operations (Solar, Wind, Hydro, Hybrid)",
  },
  {
    id: "natureOfActivities-10", label: "Waste Collection, Management, Recycling, Disposal",
  },
  {
    id: "natureOfActivities-11", label: "Water Extraction, Supply, and Wastewater Treatment",
  },
  {
    id: "natureOfActivities-12", label: "Land Management Protection and Restoration Activities",
  },
  {
    id: "natureOfActivities-13", label: "Biodiversity Protection and Conservation Programs",
  },
  { id: "natureOfActivities-14", label: "Any other relevant report", checked: false, customName: "" },
];
export const irisPrincipleReportItems = [
  // 🧾 Reports
  { id: "irisPrincipleReportItems-1", label: "Impact Performance Report" },
  { id: "irisPrincipleReportItems-2", label: "Social Return on Investment Report" },
  { id: "irisPrincipleReportItems-3", label: "Environmental Performance Report" },
  { id: "irisPrincipleReportItems-4", label: "Gender Equity Impact Report" },
  { id: "irisPrincipleReportItems-5", label: "Client/Stakeholder Reach Report" },
  { id: "irisPrincipleReportItems-6", label: "Governance & Ownership Metrics Report" },
  { id: "irisPrincipleReportItems-7", label: "Job Creation and Labor Report" },
  { id: "irisPrincipleReportItems-8", label: "Health & Education Impact Report" },
  { id: "irisPrincipleReportItems-9", label: "Climate Risk Exposure Report" },
  { id: "irisPrincipleReportItems-10", label: "Supply Chain ESG Compliance Report" },
  { id: "irisPrincipleReportItems-11", label: "Land Use and Resource Management Report" },
  { id: "irisPrincipleReportItems-12", label: "Crosswalk Report" },
  { id: "irisPrincipleReportItems-13", label: "Transparency and Disclosure" },
  { id: "irisPrincipleReportItems-14", label: "Gap Assessment Report" },
  { id: "irisPrincipleReportItems-15", label: "Full IRIS+ Compliance Report for Decision Making" },

  // 🧾 Assessments
  { id: "irisPrincipleReportItems-16", label: "GHG Emissions Baseline Assessment" },
  { id: "irisPrincipleReportItems-17", label: "Water Use & Treatment Impact Assessment" },
  { id: "irisPrincipleReportItems-18", label: "SME Development Impact Assessment" },
  { id: "irisPrincipleReportItems-19", label: "Workforce Demographics Assessment" },
  { id: "irisPrincipleReportItems-20", label: "Environmental & Social Policy Compliance Review" },
  { id: "irisPrincipleReportItems-21", label: "Indigenous/Minority Inclusion Assessment" },
  { id: "irisPrincipleReportItems-22", label: "Gender Lens Investment Assessment" },
  { id: "irisPrincipleReportItems-23", label: "Governance Risk Assessment" },
  { id: "irisPrincipleReportItems-24", label: "GIIN-aligned Indicators" },

  // 🧾 Analysis
  { id: "irisPrincipleReportItems-25", label: "Impact Heat Map (Gender, Climate, Jobs)" },
  { id: "irisPrincipleReportItems-26", label: "Sectoral SDG Alignment Analysis" },
  { id: "irisPrincipleReportItems-27", label: "Investment Impact Trajectory Analysis" },
  { id: "irisPrincipleReportItems-28", label: "Baseline vs Actual Outcome Analysis" },
  { id: "irisPrincipleReportItems-29", label: "Impact Forecast and Scenario Modeling" },
  { id: "irisPrincipleReportItems-30", label: "Depth & Duration of Impact Visualization" },
  { id: "irisPrincipleReportItems-31", label: "Geographic Disaggregation Analysis" },
  { id: "irisPrincipleReportItems-32", label: "IRIS Metrics Trendline Comparison" },
  { id: "irisPrincipleReportItems-33", label: "Any other relevant report", checked: false, customName: "" },
];
export const emissionsTracking = [
  {
    id: "emissionsTracking-1", label: "🔘 Click: “Track Emissions”",
    type: "heading",
  },
  {
    id: "emissionsTracking-2", label: "Prompt: “What would you like to calculate?”",
    type: "note",
  },
  {
    id: "emissionsTracking-3", label: "Scope 1 (Direct emissions)",
    type: "checkbox",
  },
  {
    id: "emissionsTracking-4", label: "Scope 2 (Purchased energy)",
    type: "checkbox",
  },
  {
    id: "emissionsTracking-5", label: "Scope 3 (Upstream/Downstream)",
    type: "checkbox",
  },
  {
    id: "emissionsTracking-6", label: "Scope 4 (Avoided emissions)",
    type: "checkbox",
  },
];
export const emissionsMethodologyChecklist = [
  {
    id: "emissionsMethodologyChecklist-1", type: "heading",
    label: "Select Emission Factors and Methodology",
  },
  {
    id: "emissionsMethodologyChecklist-2", type: "note",
    label: "Click: “Select Calculation Method”",
  },
  {
    id: "emissionsMethodologyChecklist-3", type: "checkbox",
    label: "GHG Protocol: CARS, Project Accounting, Product Life Cycle",
  },
  {
    id: "emissionsMethodologyChecklist-4", type: "checkbox",
    label: "ISO 14064-compatible calculation",
  },
  {
    id: "emissionsMethodologyChecklist-5", type: "checkbox",
    label: "AFOLU Sector Guidance (for agri/land use companies)",
  },
  {
    id: "emissionsMethodologyChecklist-6", type: "checkbox",
    label: "🇨🇦 Canadian GHGRP, BC’s Act, Alberta Climate Plan triggers",
  },
  {
    id: "emissionsMethodologyChecklist-7", type: "heading",
    label: "Scope 4 (Avoided Emissions) Estimator",
  },
  {
    id: "emissionsMethodologyChecklist-8", type: "note",
    label: "Click: “Add Avoided Emissions Scenario”",
  },
  {
    id: "emissionsMethodologyChecklist-9", type: "checkbox",
    label: "Simulate GHG savings by switching to renewables",
  },
  {
    id: "emissionsMethodologyChecklist-10", type: "checkbox",
    label: "Estimate reduction from energy efficiency upgrades",
  },
  {
    id: "emissionsMethodologyChecklist-11", type: "checkbox",
    label: "Calculate circular economy impacts (reuse, recycling)",
  },
];
export const realTimeEmissionCalculation = [
  {
    id: "realTimeEmissionCalculation-1", type: "heading",
    label: "Real-Time Emission Calculation",
  },
  {
    id: "realTimeEmissionCalculation-2", type: "note",
    label: "Click: “Generate Emissions Report”",
  },
  {
    id: "realTimeEmissionCalculation-3", type: "heading",
    label: "Dashboard Output:",
  },
  {
    id: "realTimeEmissionCalculation-4", type: "checkbox",
    label: "Scope-wise emissions in tCO₂e",
  },
  {
    id: "realTimeEmissionCalculation-5", type: "checkbox",
    label: "Pie chart breakdown by scope",
  },
  {
    id: "realTimeEmissionCalculation-6", type: "checkbox",
    label: "Year-on-Year emissions trend",
  },
  {
    id: "realTimeEmissionCalculation-7", type: "checkbox",
    label: "🔴 GHG thresholds exceeded (e.g., 50,000 tCO₂e for GHGRP)",
  },
  {
    id: "realTimeEmissionCalculation-8", type: "checkbox",
    label: "GHG Inventory (by scope, site, and source)",
  },
  {
    id: "realTimeEmissionCalculation-9", type: "checkbox",
    label: "🏷️ Product Lifecycle Report (aligned with GHG Product Standard)",
  },
  {
    id: "realTimeEmissionCalculation-10", type: "checkbox",
    label: "🏛️ Regulatory Format Export",
  },
  {
    id: "realTimeEmissionCalculation-11", type: "checkbox",
    label: "Canadian GHGRP",
  },
  {
    id: "realTimeEmissionCalculation-12", type: "checkbox",
    label: "BC’s Industrial GHG Reporting",
  },
  {
    id: "realTimeEmissionCalculation-13", type: "checkbox",
    label: "Alberta Offset Reporting",
  },
  {
    id: "realTimeEmissionCalculation-14", type: "checkbox",
    label:
      "Audit trail included. Can be archived for MRV (Monitoring, Reporting & Verification)",
  },
  {
    id: "realTimeEmissionCalculation-15", type: "checkbox",
    label: "📊 Benchmark vs sector average (by NAICS/SIC code)",
  },
  {
    id: "realTimeEmissionCalculation-16", type: "checkbox",
    label: "🔄 Reduction targets & science-based alignment",
  },
  {
    id: "realTimeEmissionCalculation-17", type: "checkbox",
    label: "🔮 AI-powered emissions forecasting (Scope-wise)",
  },
];

export const frameWorkAndStandardMapping = [
  {
    id: "frameWorkAndStandardMapping-1", type: "heading",
    label: "Select Applicable Frameworks",
  },
  {
    id: "frameWorkAndStandardMapping-2", type: "checkbox",
    label: "IFC PS3 – Pollution Prevention & Resource Efficiency",
  },
  {
    id: "frameWorkAndStandardMapping-3", type: "checkbox",
    label: "TCFD – Task Force on Climate-Related Financial Disclosures",
  },
  {
    id: "frameWorkAndStandardMapping-4", type: "checkbox",
    label: "ISO 14064 – GHG Accounting",
  },
  {
    id: "frameWorkAndStandardMapping-5", type: "checkbox",
    label: "ISO 14091 – Climate Risk Assessment",
  },
  {
    id: "frameWorkAndStandardMapping-6", type: "checkbox",
    label: "GRI 302 – Energy",
  },
  {
    id: "frameWorkAndStandardMapping-7", type: "checkbox",
    label: "GRI 305 – Emissions",
  },
  {
    id: "frameWorkAndStandardMapping-8", type: "checkbox",
    label: "SBTi – Science-Based Targets",
  },
  {
    id: "frameWorkAndStandardMapping-9", type: "checkbox",
    label: "Nationally Determined Contributions (NDCs)",
  },
  {
    id: "frameWorkAndStandardMapping-10", type: "checkbox",
    label: "Sectoral Net Zero Pathways (IEA, IPCC, UNFCCC)",
  },
];
export const generatedReportsAssClimateImpact = [
  {
    id: "generatedReportsAssClimateImpact-1", type: "checkbox",
    label: "Climate Risk and Vulnerability Assessment",
  },
  {
    id: "generatedReportsAssClimateImpact-2", type: "checkbox",
    label: "GHG Emissions Inventory (Scope 1, 2, 3)",
  },
  {
    id: "generatedReportsAssClimateImpact-3", type: "checkbox",
    label: "Physical Climate Risk Profile (flood, heat, drought, cyclone)",
  },
  {
    id: "generatedReportsAssClimateImpact-4", type: "checkbox",
    label: "Transition Risk Exposure Report (policy, market, reputation)",
  },
  {
    id: "generatedReportsAssClimateImpact-5", type: "checkbox",
    label: "Climate Resilience and Adaptation Strategy",
  },
  {
    id: "generatedReportsAssClimateImpact-6", type: "checkbox",
    label: "Net Zero Alignment Progress Report",
  },
  {
    id: "generatedReportsAssClimateImpact-7", type: "checkbox",
    label: "Climate Action Plan (CAP) Tracker",
  },
  {
    id: "generatedReportsAssClimateImpact-8", type: "checkbox",
    label: "TCFD Disclosure Readiness Report",
  },
  {
    id: "generatedReportsAssClimateImpact-9", type: "checkbox",
    label: "Emissions Reduction Pathway Modeling (1.5°C, 2°C scenarios)",
  },
  {
    id: "generatedReportsAssClimateImpact-10", type: "checkbox",
    label: "Climate-Related Financial Risk Assessment",
  },
  {
    id: "generatedReportsAssClimateImpact-11", type: "checkbox",
    label: "Climate Transition and Physical Risk Heatmap Report",
  },
  {
    id: "generatedReportsAssClimateImpact-12", type: "checkbox",
    label: "Scenario-Based Climate Impact Modeling Summary",
  },
  {
    id: "generatedReportsAssClimateImpact-13", type: "checkbox",
    label: "Climate Risk Integration into Strategic Planning Report",
  },
  {
    id: "generatedReportsAssClimateImpact-14", type: "checkbox",
    label: "Business Continuity and Resilience Under Climate Stress Report",
  },
  {
    id: "generatedReportsAssClimateImpact-15", type: "checkbox",
    label: "Climate Opportunities and Co-Benefits Summary",
  },
];
export const frameWorkandStandardMapping = [
  {
    id: "frameWorkandStandardMapping-1", type: "heading",
    label: "Select Applicable Frameworks",
  },
  {
    id: "frameWorkandStandardMapping-2", type: "checkbox",
    label: "IFC PS3 – Pollution Prevention & Resource Efficiency",
  },
  {
    id: "frameWorkandStandardMapping-3", type: "checkbox",
    label: "TCFD – Task Force on Climate-Related Financial Disclosures",
  },
  {
    id: "frameWorkandStandardMapping-4", type: "checkbox",
    label: "ISO 14064 – GHG Accounting",
  },
  {
    id: "frameWorkandStandardMapping-5", type: "checkbox",
    label: "ISO 14091 – Climate Risk Assessment",
  },
  {
    id: "frameWorkandStandardMapping-6", type: "checkbox",
    label: "GRI 302 – Energy",
  },
  {
    id: "frameWorkandStandardMapping-7", type: "checkbox",
    label: "GRI 305 – Emissions",
  },
  {
    id: "frameWorkandStandardMapping-8", type: "checkbox",
    label: "SBTi – Science-Based Targets",
  },
  {
    id: "frameWorkandStandardMapping-9", type: "checkbox",
    label: "Nationally Determined Contributions (NDCs)",
  },
  {
    id: "frameWorkandStandardMapping-10", type: "checkbox",
    label: "Country-Specific Climate Disclosure Laws",
  },
  {
    id: "frameWorkandStandardMapping-11", type: "checkbox",
    label: "Sectoral Net Zero Pathways (IEA, IPCC, UNFCCC)",
  },
];
export const carbonOffsetCreditMang = [
  {
    id: "carbonOffsetCreditMang-1", label: "🔘 Click: “Manage Carbon Credits & Offsets”",
    type: "heading",
  },
  {
    id: "carbonOffsetCreditMang-2", label: "User prompted to choose:",
    type: "note",
  },
  {
    id: "carbonOffsetCreditMang-3", label: "🎯 Carbon Offsetting Strategy",
    type: "checkbox",
  },
  {
    id: "carbonOffsetCreditMang-4", label: "💳 Carbon Credit Transactions",
    type: "checkbox",
  },
  {
    id: "carbonOffsetCreditMang-5", label: "📜 Certification & Compliance Tracking",
    type: "checkbox",
  },
  {
    id: "carbonOffsetCreditMang-6", label: "📈 Market Instruments & Emission Trading",
    type: "checkbox",
  },
];
export const trackVerifyOffsetProj = [
  {
    id: "trackVerifyOffsetProj-1", type: "heading",
    label: "Track & Verify Offset Performance",
  },

  {
    id: "trackVerifyOffsetProj-2", type: "heading",
    label: "Real-time project dashboard:",
  },
  {
    id: "trackVerifyOffsetProj-3", type: "checkbox",
    label: "Offset volume (in tCO₂e)",
  },
  {
    id: "trackVerifyOffsetProj-4", type: "checkbox",
    label:
      "Verification stage (validation, monitoring, verification, issuance)",
  },
  {
    id: "trackVerifyOffsetProj-5", type: "checkbox",
    label: "Credit issuance ID and retirement logs",
  },
  {
    id: "trackVerifyOffsetProj-6", type: "checkbox",
    label: "Registry links (Verra, Gold Standard, etc.)",
  },

  {
    id: "trackVerifyOffsetProj-7", type: "heading",
    label: "Carbon Credit Transactions & Marketplace Link",
  },
  {
    id: "trackVerifyOffsetProj-8", type: "heading",
    label: "AI-integrated transaction support:",
  },
  {
    id: "trackVerifyOffsetProj-9", type: "checkbox",
    label:
      "Auto-match to Voluntary Carbon Markets (VCM) or compliance systems (EU ETS, OBPS, California Cap-and-Trade)",
  },
  {
    id: "trackVerifyOffsetProj-10", type: "checkbox",
    label: "📈 Track current market prices, demand, and trends",
  },
  {
    id: "trackVerifyOffsetProj-11", type: "checkbox",
    label: "💳 Record purchases, sales, retirements, and trading history",
  },
  {
    id: "trackVerifyOffsetProj-12", type: "checkbox",
    label: "Certification registry (e.g. Verra, ACR, Plan Vivo)",
  },

  {
    id: "trackVerifyOffsetProj-13", type: "heading",
    label: "Financial Standards & Green Finance Integration",
  },
  {
    id: "trackVerifyOffsetProj-14", type: "heading",
    label: "Enable Green Finance Reporting",
  },
  {
    id: "trackVerifyOffsetProj-15", type: "heading",
    label: "Linked with:",
  },
  {
    id: "trackVerifyOffsetProj-16", type: "checkbox",
    label: "ICMA (Green Bond Principles)",
  },
  {
    id: "trackVerifyOffsetProj-17", type: "checkbox",
    label: "Climate Bonds Initiative (CBI)",
  },
  {
    id: "trackVerifyOffsetProj-18", type: "checkbox",
    label: "Loan Market Association (LMA)",
  },
  {
    id: "trackVerifyOffsetProj-19", type: "checkbox",
    label: "Sustainability-Linked Loan Principles (SLLP)",
  },
  {
    id: "trackVerifyOffsetProj-20", type: "checkbox",
    label: "Canadian Green Bond Framework",
  },
  {
    id: "trackVerifyOffsetProj-21", type: "checkbox",
    label: "Canada Infrastructure Bank (CIB)",
  },
  {
    id: "trackVerifyOffsetProj-22", type: "checkbox",
    label: "EU Taxonomy & Green Deal compliance",
  },

  {
    id: "trackVerifyOffsetProj-23", type: "heading",
    label: "Generate Offset & Credit Reports",
  },
  {
    id: "trackVerifyOffsetProj-24", type: "heading",
    label: "Report options:",
  },
  {
    id: "trackVerifyOffsetProj-25", type: "checkbox",
    label: "Verified Carbon Credit Ledger",
  },
  {
    id: "trackVerifyOffsetProj-26", type: "checkbox",
    label: "Credit Usage & Trading Ledger",
  },
  {
    id: "trackVerifyOffsetProj-27", type: "checkbox",
    label: "Offset Performance & Retirement Report",
  },
  {
    id: "trackVerifyOffsetProj-28", type: "checkbox",
    label: "Green Bond Alignment Report",
  },
  {
    id: "trackVerifyOffsetProj-29", type: "checkbox",
    label: "Sector-specific Offset Alignment (REDD+, CORSIA, etc.)",
  },
  {
    id: "trackVerifyOffsetProj-30", type: "checkbox",
    label: "Net-Zero Path Forecast",
  },
  {
    id: "trackVerifyOffsetProj-31", type: "checkbox",
    label: "MRV Compliance Status",
  },

  {
    id: "trackVerifyOffsetProj-32", type: "heading",
    label: "Dashboard Insights & Alerts",
  },
  {
    id: "trackVerifyOffsetProj-33", type: "heading",
    label: "Insights and Forecasting",
  },
  {
    id: "trackVerifyOffsetProj-34", type: "heading",
    label: "Includes:",
  },
  {
    id: "trackVerifyOffsetProj-35", type: "checkbox",
    label: "Real-time offset-to-emission ratio",
  },
  {
    id: "trackVerifyOffsetProj-36", type: "checkbox",
    label: "Forecasted credit demand",
  },
  {
    id: "trackVerifyOffsetProj-37", type: "checkbox",
    label: "Expiry/reminder alerts for verification or issuance",
  },
  {
    id: "trackVerifyOffsetProj-38", type: "checkbox",
    label: "Offset gaps for net-zero alignment",
  },
  {
    id: "trackVerifyOffsetProj-39", type: "checkbox",
    label: "EU ETS, NZ ETS, California, Quebec, South Korea, Japan JCM",
  },
  {
    id: "trackVerifyOffsetProj-40", type: "checkbox",
    label: "🇨🇦 Canada OBPS, Alberta TIER, Ontario EPS",
  },
  {
    id: "trackVerifyOffsetProj-41", type: "checkbox",
    label: "CORSIA (aviation emissions offset)",
  },
  {
    id: "trackVerifyOffsetProj-42", type: "checkbox",
    label: "Emissions cap vs. actual",
  },
  {
    id: "trackVerifyOffsetProj-43", type: "checkbox",
    label: "Credit requirement",
  },
  {
    id: "trackVerifyOffsetProj-44", type: "checkbox",
    label: "Market eligibility",
  },
  {
    id: "trackVerifyOffsetProj-45", type: "checkbox",
    label: "Trading opportunity alerts (buy/sell recommendations)",
  },
];
export const financialInstrumentType = [
  {
    id: "financialInstrumentType-1", type: "heading",
    label: "Select Financing Instrument Type",
  },
  {
    id: "financialInstrumentType-2", type: "checkbox",
    label: "Green Bonds",
  },
  {
    id: "financialInstrumentType-3", type: "checkbox",
    label: "Social Bonds",
  },
  {
    id: "financialInstrumentType-4", type: "checkbox",
    label: "Sustainability Bonds",
  },
  {
    id: "financialInstrumentType-5", type: "checkbox",
    label: "Sustainability-Linked Bonds",
  },
  {
    id: "financialInstrumentType-6", type: "checkbox",
    label: "Green Loans",
  },
  {
    id: "financialInstrumentType-7", type: "checkbox",
    label: "Social Loans",
  },
  {
    id: "financialInstrumentType-8", type: "checkbox",
    label: "Sustainability-Linked Loans",
  },
  {
    id: "financialInstrumentType-9", type: "note",
    label: "Optional: Upload existing bond/loan term sheet or framework",
  },
];
export const eligibilityAndAlignment = [
  {
    id: "eligibilityAndAlignment-1", type: "heading",
    label: "Eligibility & Alignment",
  },
  {
    id: "eligibilityAndAlignment-2", type: "checkbox",
    label: "Project eligibility against green/social/sustainability criteria",
  },
  {
    id: "eligibilityAndAlignment-3", type: "checkbox",
    label: "Mapping to CBI taxonomy or ICMA categories",
  },
  {
    id: "eligibilityAndAlignment-4", type: "checkbox",
    label:
      "Impact performance indicators selected (quantitative & qualitative)",
  },
  {
    id: "eligibilityAndAlignment-5", type: "checkbox",
    label:
      "External review (Second-Party Opinion, Verification, Certification)",
  },
  {
    id: "eligibilityAndAlignment-6", type: "checkbox",
    label: "Annual reporting process established",
  },
  {
    id: "eligibilityAndAlignment-7", type: "checkbox",
    label: "Post-issuance tracking mechanisms defined",
  },
];
export const DisclosureESGIntegration = [
  {
    id: "DisclosureESGIntegration-1", type: "heading",
    label: "Disclosure & ESG Integration",
  },
  {
    id: "DisclosureESGIntegration-2", type: "checkbox",
    label: "ESG risk factors disclosed in offering documents",
  },
  {
    id: "DisclosureESGIntegration-3", type: "checkbox",
    label: "ESG governance over proceeds management",
  },
  {
    id: "DisclosureESGIntegration-4", type: "checkbox",
    label: "Climate-related financial disclosure (e.g. TCFD, IFRS S2)",
  },
  {
    id: "DisclosureESGIntegration-5", type: "checkbox",
    label: "SDG mapping of bond/loan portfolio",
  },
  {
    id: "DisclosureESGIntegration-6", type: "checkbox",
    label: "Ongoing ESG impact performance updates",
  },
];
export const generateReportsEsgBond = [
  {
    id: "generateReportsEsgBond-1", type: "heading",
    label: "Generate ESG-Bond Aligned Reports",
  },
  {
    id: "generateReportsEsgBond-2", type: "checkbox",
    label: "Environmental/Social Impact Report",
  },
  {
    id: "generateReportsEsgBond-3", type: "checkbox",
    label: "Eligible Project Category Breakdown",
  },
  {
    id: "generateReportsEsgBond-4", type: "checkbox",
    label: "Use-of-Proceeds Verification",
  },
  {
    id: "generateReportsEsgBond-5", type: "checkbox",
    label: "Renewable energy capacity added (MW)",
  },
  {
    id: "generateReportsEsgBond-6", type: "checkbox",
    label: "Beneficiaries of social impact projects",
  },
  {
    id: "generateReportsEsgBond-7", type: "checkbox",
    label: "SDG Alignment Tags",
  },
  {
    id: "generateReportsEsgBond-8", type: "checkbox",
    label: "Additionally & Materiality Assessment",
  },
  {
    id: "generateReportsEsgBond-9", type: "checkbox",
    label: "KPI Gap vs Commitments",
  },
  {
    id: "generateReportsEsgBond-10", type: "checkbox",
    label: "Unverified Impact Claims",
  },
  {
    id: "generateReportsEsgBond-11", type: "checkbox",
    label: "Investor Summary",
  },
  {
    id: "generateReportsEsgBond-12", type: "checkbox",
    label: "Green/Social/Sustainability Bond Impact Report",
  },
  {
    id: "generateReportsEsgBond-13", type: "checkbox",
    label: "SDG-Linked Bond Impact Map",
  },
  {
    id: "generateReportsEsgBond-14", type: "checkbox",
    label: "GHG Reduction Report (Green Finance)",
  },
  {
    id: "generateReportsEsgBond-15", type: "checkbox",
    label: "Canada Green Bond Alignment Matrix",
  },
  {
    id: "generateReportsEsgBond-16", type: "checkbox",
    label: "Bond Framework Gap Analysis",
  },
  {
    id: "generateReportsEsgBond-17", type: "checkbox",
    label: "ESG-Bond Compliance Alignment Sheet",
  },
  {
    id: "generateReportsEsgBond-18", type: "checkbox",
    label: "KPI Tracker for Sustainability-Linked Instruments",
  },
  {
    id: "generateReportsEsgBond-19", type: "checkbox",
    label: "Full ICMA-Compliant Report",
  },
];
export const proceedLinkageCriteria = [
  {
    id: "proceedLinkageCriteria-1", type: "heading",
    label: "Define Use of Proceeds / Linkage Criteria",
  },
  {
    id: "proceedLinkageCriteria-2", type: "checkbox",
    label: "Climate mitigation (e.g. renewable energy, energy efficiency)",
  },
  {
    id: "proceedLinkageCriteria-3", type: "checkbox",
    label: "Climate adaptation (e.g. flood resilience, water management)",
  },
  {
    id: "proceedLinkageCriteria-4", type: "checkbox",
    label: "Social inclusion (e.g. education, health, housing)",
  },
  {
    id: "proceedLinkageCriteria-5", type: "checkbox",
    label: "Green infrastructure",
  },
  {
    id: "proceedLinkageCriteria-6", type: "checkbox",
    label: "Sustainability performance targets (for SLBs/SLLPs)",
  },
];
export const legalAndFrameWorkMapping = [
  {
    id: "legalAndFrameWorkMapping-1", type: "heading",
    label:
      "Select Applicable Laws, Standards, and Frameworks (auto-filtered by country/sector)",
  },
  {
    id: "legalAndFrameWorkMapping-2", type: "checkbox",
    label: "IFC PS1 – Risk Assessment & Management",
  },
  {
    id: "legalAndFrameWorkMapping-3", type: "checkbox",
    label: "IFC PS3 – Resource Efficiency & Pollution Prevention",
  },
  {
    id: "legalAndFrameWorkMapping-4", type: "checkbox",
    label: "IFC PS6 – Biodiversity & Natural Habitat Protection",
  },
  {
    id: "legalAndFrameWorkMapping-5", type: "checkbox",
    label: "National EIA Laws (e.g., SEPA, CEPA, EPA, MoCCAE)",
  },
  {
    id: "legalAndFrameWorkMapping-6", type: "checkbox",
    label: "ISO 14001 – Environmental Management System",
  },
  {
    id: "legalAndFrameWorkMapping-7", type: "checkbox",
    label:
      "GRI Standards (301 – Materials, 302 – Energy, 303 – Water, 304 – Biodiversity, 306 – Waste, 307 – Compliance)",
  },
  {
    id: "legalAndFrameWorkMapping-8", type: "checkbox",
    label: "Basel Convention – Hazardous Waste",
  },
  {
    id: "legalAndFrameWorkMapping-9", type: "checkbox",
    label: "Stockholm Convention – POPs",
  },
  {
    id: "legalAndFrameWorkMapping-10", type: "checkbox",
    label: "IUCN Red List / Protected Species Framework",
  },
  {
    id: "legalAndFrameWorkMapping-11", type: "checkbox",
    label: "UN SDGs (6, 12, 13, 14, 15)",
  },
  {
    id: "legalAndFrameWorkMapping-12", type: "checkbox",
    label: "Local Climate Change & Water Use Policies",
  },
  {
    id: "legalAndFrameWorkMapping-13", type: "checkbox",
    label: "CITES / Ramsar / CMS (if applicable)",
  },
  { id: "legalAndFrameWorkMapping-14", label: "Any other relevant report", checked: false, customName: "" },
];
export const reportsAssesstmentOption = [
  {
    id: "reportsAssesstmentOption-1", type: "checkbox",
    label: "Environmental Compliance Due Diligence Report",
  },
  {
    id: "reportsAssesstmentOption-2", type: "checkbox",
    label: "Biodiversity Risk and Sensitivity Assessment",
  },
  {
    id: "reportsAssesstmentOption-3", type: "checkbox",
    label: "Air Emissions Inventory and Compliance Report",
  },
  {
    id: "reportsAssesstmentOption-4", type: "checkbox",
    label: "Water Use and Wastewater Discharge Assessment",
  },
  {
    id: "reportsAssesstmentOption-5", type: "checkbox",
    label: "Waste Management and Hazardous Materials Audit",
  },
  {
    id: "reportsAssesstmentOption-6", type: "checkbox",
    label: "Climate Risk and Resilience Assessment",
  },
  {
    id: "reportsAssesstmentOption-7", type: "checkbox",
    label: "Energy and Resource Efficiency Profile",
  },
  {
    id: "reportsAssesstmentOption-8", type: "checkbox",
    label: "Soil and Groundwater Contamination Risk Assessment",
  },
  {
    id: "reportsAssesstmentOption-9", type: "checkbox",
    label: "Noise and Vibration Monitoring Report",
  },
  {
    id: "reportsAssesstmentOption-10", type: "checkbox",
    label: "Environmental Management Plan (EMP) Tracker",
  },
  {
    id: "reportsAssesstmentOption-11", type: "checkbox",
    label: "Environmental Permitting and Regulatory Compliance Report",
  },
  {
    id: "reportsAssesstmentOption-12", type: "checkbox",
    label: "Protected Areas and Ecosystem Services Assessment",
  },
  {
    id: "reportsAssesstmentOption-13", type: "checkbox",
    label: "Cumulative Environmental Impact Analysis (CIA)",
  },
  {
    id: "reportsAssesstmentOption-14", type: "checkbox",
    label: "Environmental Grievance Monitoring Report",
  },
  {
    id: "reportsAssesstmentOption-15", type: "checkbox",
    label: "Natural Habitat & Critical Habitat Assessment",
  },
  {
    id: "reportsAssesstmentOption-16", type: "checkbox",
    label: "Environmental Incident & Spill Response Record",
  },
];

export const reportesDiligence = [
  {
    id: "reportesDiligence-1", type: "checkbox",
    label: "ESG Due Diligence Report – Short Version",
  },
  {
    id: "reportesDiligence-2", type: "checkbox",
    label: "ESG Due Diligence Report – Detailed Version",
  },
  {
    id: "reportesDiligence-3", type: "checkbox",
    label: "ESG Risk Register",
  },
  {
    id: "reportesDiligence-4", type: "checkbox",
    label: "ESG Compliance Matrix",
  },
  {
    id: "reportesDiligence-5", type: "checkbox",
    label: "Corrective Action Plan",
  },
  {
    id: "reportesDiligence-6", type: "checkbox",
    label: "Compliance Heat Map (Green/Yellow/Red Zones)",
  },
  {
    id: "reportesDiligence-7", type: "checkbox",
    label: "Stakeholder Engagement Summary Report",
  },
  {
    id: "reportesDiligence-8", type: "checkbox",
    label: "Climate Risk Exposure Assessment",
  },
  {
    id: "reportesDiligence-9", type: "checkbox",
    label: "Post-Review Gap Identification Report",
  },
  {
    id: "reportesDiligence-10", type: "checkbox",
    label: "Post-Review Compliance Summary Report",
  },
  {
    id: "reportesDiligence-11", type: "checkbox",
    label: "Audit & Evidence Compilation Log",
  },
  {
    id: "reportesDiligence-12", type: "checkbox",
    label: "Final ESG Compliance Scorecard",
  },
  {
    id: "reportesDiligence-13", type: "checkbox",
    label: "Sector-Specific ESG Risk Analysis Summary",
  },
  {
    id: "reportesDiligence-14", type: "checkbox",
    label: "Country-Specific ESG Legal Compliance Checklist",
  },
  {
    id: "reportesDiligence-15", type: "checkbox",
    label: "Environmental & Social Compliance Tracker",
  },
  {
    id: "reportesDiligence-16", type: "checkbox",
    label: "Regulatory Approvals & License Status Report",
  },
  {
    id: "reportesDiligence-17", type: "checkbox",
    label: "Grievance Redress Mechanism Effectiveness Summary",
  },
  {
    id: "reportesDiligence-18", type: "checkbox",
    label: "Worker Rights & Labor Compliance Overview",
  },
  {
    id: "reportesDiligence-19", type: "checkbox",
    label: "Carbon Emissions & GHG Monitoring Report",
  },
  {
    id: "reportesDiligence-20", type: "checkbox",
    label: "Biodiversity Risk and Impact Summary",
  },
];

export const socialComplianceReporting = [
  {
    id: "socialComplianceReporting-1", type: "checkbox",
    label: "Social Compliance Due Diligence Report",
  },
  {
    id: "socialComplianceReporting-2", type: "checkbox",
    label: "Worker Welfare Audit",
  },
  {
    id: "socialComplianceReporting-3", type: "checkbox",
    label: "Gender Impact Assessment (GIA)",
  },
  {
    id: "socialComplianceReporting-4", type: "checkbox",
    label: "Livelihood Impact Assessment (LIA)",
  },
  {
    id: "socialComplianceReporting-5", type: "checkbox",
    label: "Stakeholder Engagement Summary",
  },
  {
    id: "socialComplianceReporting-6", type: "checkbox",
    label: "Free, Prior and Informed Consent (FPIC) Report",
  },
  {
    id: "socialComplianceReporting-7", type: "checkbox",
    label: "Grievance Mechanism Evaluation",
  },
  {
    id: "socialComplianceReporting-8", type: "checkbox",
    label: "Community Health and Safety Risk Profile (CHSRP)",
  },
  {
    id: "socialComplianceReporting-9", type: "checkbox",
    label: "Labor Rights Compliance Report",
  },
  {
    id: "socialComplianceReporting-10", type: "checkbox",
    label: "GBV Screening Report",
  },
  {
    id: "socialComplianceReporting-11", type: "checkbox",
    label: "Cultural Heritage Risk Summary",
  },
  {
    id: "socialComplianceReporting-12", type: "checkbox",
    label: "Social Action Plan Progress Tracker",
  },
];
export const legalFrameWork_Social = [
  {
    id: "legalFrameWork_Social-1", type: "checkbox-group",
    label: "Select applicable standards & frameworks",
  },
  {
    id: "legalFrameWork_Social-2", type: "checkbox",
    label: "IFC PS2 – Labor & Working Conditions",
  },
  {
    id: "legalFrameWork_Social-3", type: "checkbox",
    label: "IFC PS4 – Community Health, Safety & Security",
  },
  {
    id: "legalFrameWork_Social-4", type: "checkbox",
    label: "IFC PS5 – Involuntary Resettlement",
  },
  {
    id: "legalFrameWork_Social-5", type: "checkbox",
    label: "IFC PS7 – Indigenous Peoples",
  },
  {
    id: "legalFrameWork_Social-6", type: "checkbox",
    label: "ILO Core Conventions",
  },
  {
    id: "legalFrameWork_Social-7", type: "checkbox",
    label: "GRI Standards 401–413",
  },
  {
    id: "legalFrameWork_Social-8", type: "checkbox",
    label: "UNGC Principles 1–6",
  },
  {
    id: "legalFrameWork_Social-9", type: "checkbox",
    label: "National Labor Code (based on country auto-fill)",
  },
  {
    id: "legalFrameWork_Social-10", type: "checkbox",
    label: "Local Land Acquisition Laws",
  },
  {
    id: "legalFrameWork_Social-11", type: "checkbox",
    label: "Gender Action Plans (donor-linked)",
  },
  {
    id: "legalFrameWork_Social-12", type: "checkbox",
    label: "SDGs 5, 8, 10, 16",
  },
  {
    id: "legalFrameWork_Social-13", type: "checkbox",
    label: "Custom Client ESG Requirements (Upload)",
  },
];
export const reportsAssesstmentOptionSocial = [
  { id: "reportsAssesstmentOptionSocial-1", type: "checkbox", label: "Social Compliance Due Diligence Report" },
  { id: "reportsAssesstmentOptionSocial-2", type: "checkbox", label: "Worker Welfare Audit Report" },
  { id: "reportsAssesstmentOptionSocial-3", type: "checkbox", label: "Gender Impact Assessment (GIA)" },
  { id: "reportsAssesstmentOptionSocial-4", type: "checkbox", label: "Livelihood Impact Assessment (LIA)" },
  { id: "reportsAssesstmentOptionSocial-5", type: "checkbox", label: "Stakeholder Engagement Summary Report" },
  {
    id: "reportsAssesstmentOptionSocial-6", type: "checkbox",
    label: "Free, Prior and Informed Consent (FPIC) Verification Report",
  },
  { id: "reportsAssesstmentOptionSocial-7", type: "checkbox", label: "Grievance Mechanism Performance Report" },
  { id: "reportsAssesstmentOptionSocial-8", type: "checkbox", label: "Community Health & Safety Risk Profile" },
  { id: "reportsAssesstmentOptionSocial-9", type: "checkbox", label: "Labor Rights Compliance Report" },
  { id: "reportsAssesstmentOptionSocial-10", type: "checkbox", label: "GBV Screening and Mitigation Report" },
  { id: "reportsAssesstmentOptionSocial-11", type: "checkbox", label: "Cultural Heritage Risk Assessment" },
  { id: "reportsAssesstmentOptionSocial-12", type: "checkbox", label: "Social Action Plan Progress Tracker" },
  { id: "reportsAssesstmentOptionSocial-13", type: "checkbox", label: "Vulnerable Groups Risk Assessment" },
  {
    id: "reportsAssesstmentOptionSocial-14", type: "checkbox",
    label: "Contractor and Supply Chain Social Compliance Report",
  },
  { id: "reportsAssesstmentOptionSocial-15", type: "checkbox", label: "Indigenous Peoples Engagement and Risk Report" },
  { id: "reportsAssesstmentOptionSocial-16", type: "checkbox", label: "Youth Employment and Inclusion Analysis" },
  { id: "reportsAssesstmentOptionSocial-17", type: "checkbox", label: "Social Baseline and Demographic Profile Report" },
  { id: "reportsAssesstmentOptionSocial-18", type: "checkbox", label: "Local Economic Development Contribution Report" },
  { id: "reportsAssesstmentOptionSocial-19", type: "checkbox", label: "Land Access and Use Impact Assessment" },
  {
    id: "reportsAssesstmentOptionSocial-20", type: "checkbox",
    label: "Community Feedback and Satisfaction Monitoring Report",
  },
];
export const identifyIndustryWorkEnviroment = [
  {
    id: "identifyIndustryWorkEnviroment-1", type: "checkbox-group",
    label: "Select applicable options:",
  },
  {
    id: "identifyIndustryWorkEnviroment-2", label: "A. Industry Sector:",
    type: "note",
  },
  { id: "identifyIndustryWorkEnviroment-3", type: "checkbox", label: "Construction & Infrastructure" },
  { id: "identifyIndustryWorkEnviroment-4", type: "checkbox", label: "Manufacturing / Industrial Operations" },
  { id: "identifyIndustryWorkEnviroment-5", type: "checkbox", label: "Power / Energy / Utilities" },
  { id: "identifyIndustryWorkEnviroment-6", type: "checkbox", label: "Mining / Extraction" },
  { id: "identifyIndustryWorkEnviroment-7", type: "checkbox", label: "Transport / Logistics" },
  { id: "identifyIndustryWorkEnviroment-8", type: "checkbox", label: "Warehousing / Material Handling" },
  { id: "identifyIndustryWorkEnviroment-9", type: "checkbox", label: "Environmental Services / Waste" },
  { id: "identifyIndustryWorkEnviroment-10", type: "checkbox", label: "Healthcare / Laboratory" },
  { id: "identifyIndustryWorkEnviroment-11", type: "checkbox", label: "Agriculture / Forestry" },
  { id: "identifyIndustryWorkEnviroment-12", type: "checkbox", label: "Telecom / Data Centers" },
  { id: "identifyIndustryWorkEnviroment-13", type: "checkbox", label: "Administrative / Office Operations" },
  { id: "identifyIndustryWorkEnviroment-14", type: "checkbox", label: "Other" },
  {
    id: "identifyIndustryWorkEnviroment-15", type: "text",
    label: "Please specify other industry sector:",
    placeholder: "Type here...",
  },
  {
    id: "identifyIndustryWorkEnviroment-16", label: "B. Work Setting:",
    type: "note",
  },
  { id: "identifyIndustryWorkEnviroment-17", type: "checkbox", label: "Greenfield (new site, undeveloped)" },
  { id: "identifyIndustryWorkEnviroment-18", type: "checkbox", label: "Brownfield (existing operations)" },
  { id: "identifyIndustryWorkEnviroment-19", type: "checkbox", label: "Urban / Community-Facing" },
  { id: "identifyIndustryWorkEnviroment-20", type: "checkbox", label: "Remote / Isolated / Offshore" },
  { id: "identifyIndustryWorkEnviroment-21", type: "checkbox", label: "Confined / Indoor Facility" },
  {
    id: "identifyIndustryWorkEnviroment-22", type: "checkbox",
    label: "Public-Access Zone (open roads, parks, buildings)",
  },
];

export const ESGVerificationModule_step_1 = [
  {
    id: "ESGVerificationModule_step_1-1", type: "checkbox-group",
    label: "",
  },

  {
    id: "ESGVerificationModule_step_1-2", type: "checkbox-with-input",
    label:
      "Upload Report – Verifier uploads the ESG / OHS / E&S report to be reviewed.",
    options: ["Required"],
    inputType: "file", // ← we will use this in rendering
    accept: ".pdf,.doc,.docx,.xls,.xlsx",
    multiple: false,
    required: true,
    helperText: "Upload the main ESG/OHS/E&S report to be reviewed",
  },

  // ──────────────────────────────────────────────────────────────
  // 2. Evidence Package (Optional – multiple files)
  // ──────────────────────────────────────────────────────────────
  {
    id: "ESGVerificationModule_step_1-3", type: "checkbox-with-input",
    label: "Upload Evidence Package – Supporting files (Optional)",
    options: ["Optional – multiple files allowed"],
    inputType: "file",
    accept: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.zip",
    multiple: true,
    required: false,
    helperText:
      "Permits, logs, inspection sheets, community records, photos, etc.",
  },
  {
    id: "ESGVerificationModule_step_1-4", type: "checkbox-with-input",
    label: "Free Text",
    options: ["(Verifier Notes)"],
    inputType: "textarea",
    rows: 5,
    placeholder:
      "Enter your observations, findings, discrepancies, recommendations...",
    requiredWhenChecked: true,
    helperText: "Detailed notes help support the verification outcome",
  },
];
export const typeOfRiskAssessment = [
  {
    id: "typeOfRiskAssessment-1", type: "checkbox-group",
    label: "Choose a task/activity from the categorized library",
  },
  {
    id: "typeOfRiskAssessment-2", label: "Construction & Site Works",
    type: "note",
  },
  { id: "typeOfRiskAssessment-3", type: "checkbox", label: "Excavation and Trenching" },
  { id: "typeOfRiskAssessment-4", type: "checkbox", label: "Concrete Pouring" },
  { id: "typeOfRiskAssessment-5", type: "checkbox", label: "Rebar Cutting & Placement" },
  { id: "typeOfRiskAssessment-6", type: "checkbox", label: "Scaffold Erection & Use" },
  { id: "typeOfRiskAssessment-7", type: "checkbox", label: "Work at Height" },
  { id: "typeOfRiskAssessment-8", type: "checkbox", label: "Use of Ladders" },
  { id: "typeOfRiskAssessment-9", type: "checkbox", label: "Demolition Activities" },
  { id: "typeOfRiskAssessment-10", type: "checkbox", label: "Site Clearing / Debris Removal" },
  { id: "typeOfRiskAssessment-11", type: "checkbox", label: "Road Work / Paving" },

  {
    id: "typeOfRiskAssessment-12", label: "Mechanical & Electrical",
    type: "note",
  },
  { id: "typeOfRiskAssessment-13", type: "checkbox", label: "Crane and Lifting Operations" },
  { id: "typeOfRiskAssessment-14", type: "checkbox", label: "Confined Space Entry" },
  { id: "typeOfRiskAssessment-15", type: "checkbox", label: "Electrical Energized Work" },
  { id: "typeOfRiskAssessment-16", type: "checkbox", label: "Welding / Grinding / Cutting (Hot Work)" },
  { id: "typeOfRiskAssessment-17", type: "checkbox", label: "Generator Maintenance" },
  { id: "typeOfRiskAssessment-18", type: "checkbox", label: "Installation of Heavy Equipment" },

  {
    id: "typeOfRiskAssessment-19", label: "Environmental / Chemical",
    type: "note",
  },
  { id: "typeOfRiskAssessment-20", type: "checkbox", label: "Chemical Handling and Storage" },
  { id: "typeOfRiskAssessment-21", type: "checkbox", label: "Fuel Refueling and Spill Risk" },
  { id: "typeOfRiskAssessment-22", type: "checkbox", label: "Waste Storage / Disposal" },
  { id: "typeOfRiskAssessment-23", type: "checkbox", label: "Air Emissions and Dust Exposure" },
  { id: "typeOfRiskAssessment-24", type: "checkbox", label: "Hazardous Material Movement" },
  { id: "typeOfRiskAssessment-25", type: "checkbox", label: "Biodiversity Disturbance" },

  {
    id: "typeOfRiskAssessment-26", label: "Transport & Logistics",
    type: "note",
  },
  { id: "typeOfRiskAssessment-27", type: "checkbox", label: "Vehicle Movement in Work Zone" },
  { id: "typeOfRiskAssessment-28", type: "checkbox", label: "Loading / Offloading of Goods" },
  { id: "typeOfRiskAssessment-29", type: "checkbox", label: "Forklift Operation" },
  { id: "typeOfRiskAssessment-30", type: "checkbox", label: "Transport of Oversized Load" },
  { id: "typeOfRiskAssessment-31", type: "checkbox", label: "Warehouse Operations" },

  {
    id: "typeOfRiskAssessment-32", label: "People & Administrative",
    type: "note",
  },
  { id: "typeOfRiskAssessment-33", type: "checkbox", label: "Lone Worker Activities" },
  { id: "typeOfRiskAssessment-34", type: "checkbox", label: "Manual Handling Tasks" },
  { id: "typeOfRiskAssessment-35", type: "checkbox", label: "Visitor Entry Management" },
  { id: "typeOfRiskAssessment-36", type: "checkbox", label: "Office Fire Safety" },
  { id: "typeOfRiskAssessment-37", type: "checkbox", label: "Emergency Drill and Response" },
  { id: "typeOfRiskAssessment-38", type: "checkbox", label: "Training Exercises (High Risk Scenarios)" },
];
export const verifyRiskAssessment = [
  {
    id: "verifyRiskAssessment-1", type: "checkbox",
    label:
      "Task Method Statement or Job Procedure (for non-routine or high-risk work)",
  },
  {
    id: "verifyRiskAssessment-2", type: "checkbox",
    label:
      "Permit-to-Work / Risk Authorization Form (confined space, height, hot work, etc.)",
  },
  {
    id: "verifyRiskAssessment-3", type: "checkbox",
    label:
      "Job Safety Analysis (JSA) / Task Hazard Analysis (THA) (if previously prepared)",
  },
  {
    id: "verifyRiskAssessment-4", type: "checkbox",
    label: "Site Photo or Sketch (to show task area, access, or hazard zones)",
  },
  {
    id: "verifyRiskAssessment-5", type: "checkbox",
    label:
      "PPE Checklist or Briefing Record (for pre-start or daily safety reviews)",
  },
  {
    id: "verifyRiskAssessment-6", type: "checkbox",
    label:
      "Equipment or Tool Certification (for crane, hoist, pressure tools, etc.)",
  },
  {
    id: "verifyRiskAssessment-7", type: "checkbox",
    label:
      "Emergency Contact Card / Rescue Plan (especially for confined space or height)",
  },
  {
    id: "verifyRiskAssessment-8", type: "checkbox",
    label:
      "Incident or Near Miss Log (related to the same task, tool, or site zone)",
  },
  {
    id: "verifyRiskAssessment-9", type: "checkbox",
    label:
      "Stakeholder Concern / Worker Feedback Log (if task affects public or workforce safety)",
  },
  {
    id: "verifyRiskAssessment-10", type: "checkbox",
    label:
      "Fire Watch Log or Hot Work Controls (only if welding, cutting, or similar is involved)",
  },
  {
    id: "verifyRiskAssessment-11", type: "checkbox",
    label:
      "Noise / Air Quality Monitoring Snapshot (for industrial or enclosed activities)",
  },
  {
    id: "verifyRiskAssessment-12", type: "checkbox",
    label:
      "Environmental Permit or Waste Disposal Record (only if activity includes environmental interface)",
  },
  {
    id: "verifyRiskAssessment-13", type: "checkbox",
    label:
      "Lifting Plan or Load Test Certificate (if lifting equipment is part of the task)",
  },
  {
    id: "verifyRiskAssessment-14", type: "checkbox",
    label:
      "Community Notification Record (if work is near public spaces, roads, or buildings)",
  },
  // {

  //   label: "Accepted Formats: PDF, DOCX, XLSX, JPG, PNG, CSV",
  // },
  // // --- Added Risk Assessment Titles ---
  // { id: "verifyRiskAssessment-16", type: "checkbox", label: "Excavation & Trenching Risk Assessment" },
  // { id: "verifyRiskAssessment-17", type: "checkbox", label: "Concrete Pouring Risk Assessment" },
  // { id: "verifyRiskAssessment-18", type: "checkbox", label: "Rebar Cutting & Placement Risk Assessment" },
  // { id: "verifyRiskAssessment-19", type: "checkbox", label: "Scaffold Erection & Use Risk Assessment" },
  // { id: "verifyRiskAssessment-20", type: "checkbox", label: "Work at Height Risk Assessment" },
  // { id: "verifyRiskAssessment-21", type: "checkbox", label: "Ladder Use Risk Assessment" },
  // { id: "verifyRiskAssessment-22", type: "checkbox", label: "Demolition Activities Risk Assessment" },
  // { id: "verifyRiskAssessment-23", type: "checkbox", label: "Site Clearing / Debris Removal Risk Assessment" },
  // { id: "verifyRiskAssessment-24", type: "checkbox", label: "Road Work & Paving Risk Assessment" },
  // { id: "verifyRiskAssessment-25", type: "checkbox", label: "Crane & Lifting Operations Risk Assessment" },
  // { id: "verifyRiskAssessment-26", type: "checkbox", label: "Confined Space Entry Risk Assessment" },
  // { id: "verifyRiskAssessment-27", type: "checkbox", label: "Electrical Energized Work Risk Assessment" },
  // { id: "verifyRiskAssessment-28", type: "checkbox", label: "Welding / Grinding / Cutting (Hot Work) Risk Assessment" },
  // { id: "verifyRiskAssessment-29", type: "checkbox", label: "Generator Maintenance Risk Assessment" },
  // { id: "verifyRiskAssessment-30", type: "checkbox", label: "Heavy Equipment Installation Risk Assessment" },
  // { id: "verifyRiskAssessment-31", type: "checkbox", label: "Chemical Handling & Storage Risk Assessment" },
  // { id: "verifyRiskAssessment-32", type: "checkbox", label: "Fuel Refueling & Spill Risk Assessment" },
  // { id: "verifyRiskAssessment-33", type: "checkbox", label: "Waste Storage & Disposal Risk Assessment" },
  // { id: "verifyRiskAssessment-34", type: "checkbox", label: "Air Emissions & Dust Exposure Risk Assessment" },
  // { id: "verifyRiskAssessment-35", type: "checkbox", label: "Hazardous Material Movement Risk Assessment" },
  // { id: "verifyRiskAssessment-36", type: "checkbox", label: "Biodiversity Disturbance Risk Assessment" },
  // { id: "verifyRiskAssessment-37", type: "checkbox", label: "Vehicle Movement in Work Zone Risk Assessment" },
  // { id: "verifyRiskAssessment-38", type: "checkbox", label: "Loading & Offloading of Goods Risk Assessment" },
  // { id: "verifyRiskAssessment-39", type: "checkbox", label: "Forklift Operation Risk Assessment" },
  // { id: "verifyRiskAssessment-40", type: "checkbox", label: "Oversized Load Transport Risk Assessment" },
  // { id: "verifyRiskAssessment-41", type: "checkbox", label: "Warehouse Operations Risk Assessment" },
  // { id: "verifyRiskAssessment-42", type: "checkbox", label: "Lone Worker Risk Assessment" },
  // { id: "verifyRiskAssessment-43", type: "checkbox", label: "Manual Handling Risk Assessment" },
  // { id: "verifyRiskAssessment-44", type: "checkbox", label: "Visitor Entry Management Risk Assessment" },
  // { id: "verifyRiskAssessment-45", type: "checkbox", label: "Office Fire Safety Risk Assessment" },
  // { id: "verifyRiskAssessment-46", type: "checkbox", label: "Emergency Drill & Response Risk Assessment" },
  // { id: "verifyRiskAssessment-47", type: "checkbox", label: "High-Risk Training Exercises Risk Assessment" },
  // {

  //   label: "Any other: Please write the title of risk assessment",
  // },
];

export const verifyRiskAssessmentReports = [
  // --- Added Risk Assessment Titles ---
  { id: "verifyRiskAssessmentReports-1", type: "checkbox", label: "Excavation & Trenching Risk Assessment" },
  { id: "verifyRiskAssessmentReports-2", type: "checkbox", label: "Concrete Pouring Risk Assessment" },
  { id: "verifyRiskAssessmentReports-3", type: "checkbox", label: "Rebar Cutting & Placement Risk Assessment" },
  { id: "verifyRiskAssessmentReports-4", type: "checkbox", label: "Scaffold Erection & Use Risk Assessment" },
  { id: "verifyRiskAssessmentReports-5", type: "checkbox", label: "Work at Height Risk Assessment" },
  { id: "verifyRiskAssessmentReports-6", type: "checkbox", label: "Ladder Use Risk Assessment" },
  { id: "verifyRiskAssessmentReports-7", type: "checkbox", label: "Demolition Activities Risk Assessment" },
  { id: "verifyRiskAssessmentReports-8", type: "checkbox", label: "Site Clearing / Debris Removal Risk Assessment" },
  { id: "verifyRiskAssessmentReports-9", type: "checkbox", label: "Road Work & Paving Risk Assessment" },
  { id: "verifyRiskAssessmentReports-10", type: "checkbox", label: "Crane & Lifting Operations Risk Assessment" },
  { id: "verifyRiskAssessmentReports-11", type: "checkbox", label: "Confined Space Entry Risk Assessment" },
  { id: "verifyRiskAssessmentReports-12", type: "checkbox", label: "Electrical Energized Work Risk Assessment" },
  {
    id: "verifyRiskAssessmentReports-13", type: "checkbox",
    label: "Welding / Grinding / Cutting (Hot Work) Risk Assessment",
  },
  { id: "verifyRiskAssessmentReports-14", type: "checkbox", label: "Generator Maintenance Risk Assessment" },
  { id: "verifyRiskAssessmentReports-15", type: "checkbox", label: "Heavy Equipment Installation Risk Assessment" },
  { id: "verifyRiskAssessmentReports-16", type: "checkbox", label: "Chemical Handling & Storage Risk Assessment" },
  { id: "verifyRiskAssessmentReports-17", type: "checkbox", label: "Fuel Refueling & Spill Risk Assessment" },
  { id: "verifyRiskAssessmentReports-18", type: "checkbox", label: "Waste Storage & Disposal Risk Assessment" },
  { id: "verifyRiskAssessmentReports-19", type: "checkbox", label: "Air Emissions & Dust Exposure Risk Assessment" },
  { id: "verifyRiskAssessmentReports-20", type: "checkbox", label: "Hazardous Material Movement Risk Assessment" },
  { id: "verifyRiskAssessmentReports-21", type: "checkbox", label: "Biodiversity Disturbance Risk Assessment" },
  { id: "verifyRiskAssessmentReports-22", type: "checkbox", label: "Vehicle Movement in Work Zone Risk Assessment" },
  { id: "verifyRiskAssessmentReports-23", type: "checkbox", label: "Loading & Offloading of Goods Risk Assessment" },
  { id: "verifyRiskAssessmentReports-24", type: "checkbox", label: "Forklift Operation Risk Assessment" },
  { id: "verifyRiskAssessmentReports-25", type: "checkbox", label: "Oversized Load Transport Risk Assessment" },
  { id: "verifyRiskAssessmentReports-26", type: "checkbox", label: "Warehouse Operations Risk Assessment" },
  { id: "verifyRiskAssessmentReports-27", type: "checkbox", label: "Lone Worker Risk Assessment" },
  { id: "verifyRiskAssessmentReports-28", type: "checkbox", label: "Manual Handling Risk Assessment" },
  { id: "verifyRiskAssessmentReports-29", type: "checkbox", label: "Visitor Entry Management Risk Assessment" },
  { id: "verifyRiskAssessmentReports-30", type: "checkbox", label: "Office Fire Safety Risk Assessment" },
  { id: "verifyRiskAssessmentReports-31", type: "checkbox", label: "Emergency Drill & Response Risk Assessment" },
  { id: "verifyRiskAssessmentReports-32", type: "checkbox", label: "High-Risk Training Exercises Risk Assessment" },
  {
    id: "verifyRiskAssessmentReports-33", type: "text",
    label: "Any other: Please write the title of risk assessment",
  },
];

export const esSurveyMonitoringToolType = [
  {
    id: "esSurveyMonitoringToolType-1", type: "checkbox-group",
    label: "Select the Survey, Monitoring or Tracking Tool Type",
  },
  {
    id: "esSurveyMonitoringToolType-2", type: "checkbox",
    label: "Environmental Compliance Monitoring Format",
  },
  {
    id: "esSurveyMonitoringToolType-3", type: "checkbox",
    label: "Social Compliance Monitoring Format",
  },
  {
    id: "esSurveyMonitoringToolType-4", type: "checkbox",
    label: "Occupational Health & Safety (OHS) Monitoring Format",
  },
  {
    id: "esSurveyMonitoringToolType-5", type: "checkbox",
    label: "ESG KPI Tracking Tool",
  },
  {
    id: "esSurveyMonitoringToolType-6", type: "checkbox",
    label: "Grievance & Incident Logging Sheet",
  },
  {
    id: "esSurveyMonitoringToolType-7", type: "checkbox",
    label: "Training & Capacity Building Tracking Sheet",
  },
  {
    id: "esSurveyMonitoringToolType-8", type: "checkbox",
    label: "Contractor & Subcontractor Compliance Checklist",
  },
  {
    id: "esSurveyMonitoringToolType-9", type: "checkbox",
    label: "Waste Management Tracking Log",
  },
  {
    id: "esSurveyMonitoringToolType-10", type: "checkbox",
    label: "Water & Wastewater Monitoring Log",
  },
  {
    id: "esSurveyMonitoringToolType-11", type: "checkbox",
    label: "Air Quality & Emissions Monitoring Checklist",
  },
  {
    id: "esSurveyMonitoringToolType-12", type: "checkbox",
    label: "Noise & Vibration Monitoring Log",
  },
  {
    id: "esSurveyMonitoringToolType-13", type: "checkbox",
    label: "Emergency Drill & Response Tracking Sheet",
  },
  {
    id: "esSurveyMonitoringToolType-14", type: "checkbox",
    label: "Traffic & Road Safety Monitoring Checklist",
  },
  {
    id: "esSurveyMonitoringToolType-15", type: "checkbox",
    label: "Stakeholder Engagement Tracking Format",
  },
  {
    id: "esSurveyMonitoringToolType-16", type: "checkbox",
    label: "Community Health & Safety Monitoring Tool",
  },
  {
    id: "esSurveyMonitoringToolType-17", type: "checkbox",
    label: "Biodiversity Monitoring & Habitat Disturbance Log",
  },
  {
    id: "esSurveyMonitoringToolType-18", type: "checkbox",
    label: "Supply Chain ESG Compliance Checklist",
  },
  {
    id: "esSurveyMonitoringToolType-19", type: "checkbox",
    label: "Climate Risk Monitoring & Adaptation Tracker",
  },
  {
    id: "esSurveyMonitoringToolType-20", type: "checkbox",
    label: "Audit & Inspection Tracking Format",
  },
  {
    id: "esSurveyMonitoringToolType-21", type: "checkbox",
    label: "Community Satisfaction Survey Tool",
  },
  {
    id: "esSurveyMonitoringToolType-22", type: "checkbox",
    label: "Worker Welfare & Well-being Survey Tool",
  },
  {
    id: "esSurveyMonitoringToolType-23", type: "checkbox",
    label: "Gender & Diversity Inclusion Survey Tool",
  },
  {
    id: "esSurveyMonitoringToolType-24", type: "checkbox",
    label: "Indigenous Peoples Engagement & FPIC Survey Tool",
  },
  {
    id: "esSurveyMonitoringToolType-25", type: "checkbox",
    label: "Livelihood Restoration Monitoring Survey",
  },
  {
    id: "esSurveyMonitoringToolType-26", type: "checkbox",
    label: "Social Impact & Vulnerability Assessment Checklist",
  },
  {
    id: "esSurveyMonitoringToolType-27", type: "checkbox",
    label: "Stakeholder Perception & Feedback Survey",
  },
  {
    id: "esSurveyMonitoringToolType-28", type: "checkbox",
    label: "Resettlement & Compensation Follow-Up Survey",
  },
  {
    id: "esSurveyMonitoringToolType-29", type: "checkbox",
    label: "Youth & Women Participation Survey Tool",
  },
  {
    id: "esSurveyMonitoringToolType-30", type: "checkbox",
    label: "GBV (Gender-Based Violence) Risk Screening Checklist",
  },
  {
    id: "esSurveyMonitoringToolType-31", type: "checkbox",
    label: "Custom Tool (User-defined)",
  },
];
export const esSurveyScopeFormatSpecs = [
  {
    id: "esSurveyScopeFormatSpecs-1", type: "text",
    label: "Project / Site Name",
  },
  {
    id: "esSurveyScopeFormatSpecs-2", type: "dropdown",
    label: "Industry Sector",
    options: [
      "Construction",
      "Energy",
      "Manufacturing",
      "Mining",
      "Logistics",
      "Agriculture",
      "Healthcare",
      "Services",
      "Other",
    ],
  },
  {
    id: "esSurveyScopeFormatSpecs-3", type: "checkbox-group",
    label: "Compliance / Monitoring Focus Area",
    options: [
      "Environmental",
      "Social",
      "OHS",
      "ESG KPIs",
      "Community & Stakeholder Engagement",
      "Other (specify)",
    ],
  },
  {
    id: "esSurveyScopeFormatSpecs-4", type: "checkbox-group",
    label: "Monitoring Frequency",
    options: [
      "Daily",
      "Weekly",
      "Monthly",
      "Quarterly",
      "Annually",
      "One-Time Survey",
    ],
  },
  {
    id: "esSurveyScopeFormatSpecs-5", type: "checkbox-group",
    label: "Compliance / Survey Framework",
    options: [
      "IFC PS",
      "ISO 14001/45001",
      "National Regulations",
      "ESG Framework (GRI, SASB, TCFD, etc.)",
      "Custom Framework (specify)",
    ],
  },
  {
    id: "esSurveyScopeFormatSpecs-6", type: "text",
    label: "Responsible Department / Person",
  },
  {
    id: "esSurveyScopeFormatSpecs-7", type: "text",
    label: "Number of Sites / Locations",
  },
  {
    id: "esSurveyScopeFormatSpecs-8", type: "text",
    label: "Geographic Region / Zone (if applicable)",
  },
  {
    id: "esSurveyScopeFormatSpecs-9", type: "checkbox-group",
    label: "Type of Monitoring / Survey Method",
    options: [
      "Visual Inspection",
      "Measurement / Data Logging",
      "Stakeholder Input / Survey",
      "Automated Monitoring",
      "Hybrid Method",
    ],
  },
  {
    id: "esSurveyScopeFormatSpecs-10", type: "checkbox-group",
    label: "Record Type",
    options: [
      "Checklist",
      "Log Sheet",
      "Register",
      "Audit Template",
      "Survey Questionnaire",
      "Custom Format",
    ],
  },
  {
    id: "esSurveyScopeFormatSpecs-11", type: "checkbox-group",
    label: "Data Collection Mode (for Surveys)",
    options: ["In-Person", "Online / Digital", "Phone-Based", "Paper-Based"],
  },
  {
    id: "esSurveyScopeFormatSpecs-12", type: "checkbox-group",
    label: "Target Group (for Social Tools)",
    options: [
      "Workers",
      "Local Community",
      "Indigenous Peoples",
      "Women & Youth",
      "Contractors & Suppliers",
      "Other (specify)",
    ],
  },
  {
    id: "esSurveyScopeFormatSpecs-13", type: "checkbox-group",
    label: "Criticality Level",
    options: ["High-Risk", "Medium-Risk", "Low-Risk"],
  },
  {
    id: "esSurveyScopeFormatSpecs-14", type: "checkbox-group",
    label: "Reporting Requirement",
    options: [
      "Internal Use Only",
      "External / Client Reporting",
      "Regulatory Submission",
      "Public Disclosure",
    ],
  },
  {
    id: "esSurveyScopeFormatSpecs-15", type: "checkbox-group",
    label: "Data Confidentiality Level",
    options: ["Public", "Internal", "Restricted"],
  },
  {
    id: "esSurveyScopeFormatSpecs-16", type: "text",
    label: "Timeframe for Initial Deployment",
  },
  {
    id: "esSurveyScopeFormatSpecs-17", type: "checkbox-group",
    label: "Integration Needed",
    options: [
      "Link to Existing Monitoring Tools",
      "Standalone",
      "Export to ESG/Compliance Dashboards",
    ],
  },
  {
    id: "esSurveyScopeFormatSpecs-18", type: "checkbox-group",
    label: "Do You Need Preloaded Template Suggestions?",
    options: ["Yes", "No"],
  },
  {
    id: "esSurveyScopeFormatSpecs-19", type: "checkbox-group",
    label: "Any Existing Monitoring / Survey Formats to Upload for Reference?",
    options: ["Yes", "No"],
  },
  {
    id: "esSurveyScopeFormatSpecs-20", type: "upload",
    label: "Upload Reference",
  },
  {
    id: "esSurveyScopeFormatSpecs-21", type: "text",
    label: "Custom Notes",
  },
  {
    id: "esSurveyScopeFormatSpecs-22", type: "checkbox",
    label: "Let AI-Driven Dashboard Select",
  },
];
export const esSurveyScopeDevelopFormat = [
  {
    id: "esSurveyScopeDevelopFormat-1", type: "checkbox-group",
    label: "Users click to select sections for the tool:",
  },
  {
    id: "esSurveyScopeDevelopFormat-2", type: "checkbox",
    label: "Compliance Item / Survey Question Description",
  },
  {
    id: "esSurveyScopeDevelopFormat-3", type: "checkbox",
    label: "Standard / Regulation / Guideline Reference",
  },
  {
    id: "esSurveyScopeDevelopFormat-4", type: "checkbox",
    label: "Monitoring Method / Survey Methodology / Inspection Criteria",
  },
  {
    id: "esSurveyScopeDevelopFormat-5", type: "text",
    label: "Monitoring Location / Area",
  },
  {
    id: "esSurveyScopeDevelopFormat-6", type: "dropdown",
    label: "Target Group",
    options: [
      "Workers",
      "Community",
      "Indigenous Peoples",
      "Contractors",
      "Other",
    ],
  },
  {
    id: "esSurveyScopeDevelopFormat-7", type: "dropdown",
    label: "Data Entry Field",
    options: ["Numeric", "Text", "Dropdown"],
  },
  {
    id: "esSurveyScopeDevelopFormat-8", type: "checkbox",
    label: "Frequency of Monitoring / Survey",
  },
  {
    id: "esSurveyScopeDevelopFormat-9", type: "checkbox",
    label: "Responsible Party / Team",
  },
  {
    id: "esSurveyScopeDevelopFormat-10", type: "dropdown",
    label: "Compliance Status",
    options: ["Compliant", "Non-Compliant", "Partial", "N/A"],
  },
  {
    id: "esSurveyScopeDevelopFormat-11", type: "dropdown",
    label: "Survey Response Options",
    options: ["Yes/No", "Scale 1–5", "Open Text", "Multiple Choice"],
  },
  {
    id: "esSurveyScopeDevelopFormat-12", type: "text",
    label: "Notes & Observations Field",
  },
  {
    id: "esSurveyScopeDevelopFormat-13", type: "text",
    label: "Corrective Action Field / Follow-Up Action Required",
  },
  {
    id: "esSurveyScopeDevelopFormat-14", type: "date",
    label: "Deadline Tracking",
  },
  {
    id: "esSurveyScopeDevelopFormat-15", type: "upload",
    label: "Upload Item Name or File Upload Field",
  },
  {
    id: "esSurveyScopeDevelopFormat-16", type: "dropdown",
    label: "Evidence Required",
    options: ["Yes", "No"],
  },
  {
    id: "esSurveyScopeDevelopFormat-17", type: "dropdown",
    label: "Priority Level",
    options: ["High", "Medium", "Low"],
  },
  {
    id: "esSurveyScopeDevelopFormat-18", type: "dropdown",
    label: "Risk Rating Field",
    options: ["High", "Medium", "Low", "Free Text"],
  },
  {
    id: "esSurveyScopeDevelopFormat-19", type: "dropdown",
    label: "Gender / Diversity Tag",
    options: ["Female", "Male", "Youth", "Elderly", "Other"],
  },
  {
    id: "esSurveyScopeDevelopFormat-20", type: "date",
    label: "Date of Last Monitoring / Survey",
  },
  {
    id: "esSurveyScopeDevelopFormat-21", type: "date",
    label: "Next Due Date",
  },
  {
    id: "esSurveyScopeDevelopFormat-22", type: "text",
    label: "Verification / Review Field",
  },
  {
    id: "esSurveyScopeDevelopFormat-23", type: "text",
    label: "Reviewer Comment Field",
  },
  {
    id: "esSurveyScopeDevelopFormat-24", type: "auto",
    label: "Audit Trail (Auto-filled: User, Timestamp)",
  },
  {
    id: "esSurveyScopeDevelopFormat-25", type: "text",
    label: "Linked Incident / Grievance / Complaint Reference",
  },
  {
    id: "esSurveyScopeDevelopFormat-26", type: "text",
    label: "Linked Action Plan Reference",
  },
  {
    id: "esSurveyScopeDevelopFormat-27", type: "text",
    label: "Compliance Notes Template (Pre-fill Option)",
  },
  {
    id: "esSurveyScopeDevelopFormat-28", type: "checkbox",
    label: "Responsible Manager Sign-Off Field",
  },
  {
    id: "esSurveyScopeDevelopFormat-29", type: "text",
    label: "Additional Survey Notes",
  },
  {
    id: "esSurveyScopeDevelopFormat-30", type: "dropdown",
    label: "Language of Survey",
    options: ["English", "Local", "Other"],
  },
  {
    id: "esSurveyScopeDevelopFormat-31", type: "dropdown",
    label: "Consent Confirmation Field",
    options: ["Yes", "No"],
  },
  {
    id: "esSurveyScopeDevelopFormat-32", type: "checkbox",
    label: "Let AI-Driven Dashboard Select",
  },
];
export const esSurveyScopeCustomFinalizeTool = [
  { id: "esSurveyScopeCustomFinalizeTool-1", type: "checkbox", label: "Add Company Logo & Header" },
  { id: "esSurveyScopeCustomFinalizeTool-2", type: "text", label: "Customize Field Labels (Editable)" },
  { id: "esSurveyScopeCustomFinalizeTool-3", type: "text", label: "Set Mandatory/Optional Fields" },
  {
    id: "esSurveyScopeCustomFinalizeTool-4", type: "checkbox",
    label: "Add Color-Coded Compliance/Survey Status (e.g., Green/Amber/Red)",
  },
  {
    id: "esSurveyScopeCustomFinalizeTool-5", type: "checkbox",
    label: "Include Auto-Sum / Totals Row (if Numeric Fields)",
  },
  { id: "esSurveyScopeCustomFinalizeTool-6", type: "checkbox", label: "Include Signature Field (Optional)" },
  { id: "esSurveyScopeCustomFinalizeTool-7", type: "text", label: "Add Reviewer/Verifier Name Field" },
  { id: "esSurveyScopeCustomFinalizeTool-8", type: "checkbox", label: "Enable Date & Time Stamp (Auto-fill)" },
  {
    id: "esSurveyScopeCustomFinalizeTool-9", type: "checkbox",
    label:
      "Add Section Dividers (For Grouping Related Checks or Survey Sections)",
  },
  { id: "esSurveyScopeCustomFinalizeTool-10", type: "upload", label: "Include Photo Upload Field (Optional)" },
  {
    id: "esSurveyScopeCustomFinalizeTool-11", type: "dropdown",
    label: "Add Dropdown Selection Options (Customize Lists)",
    options: ["Option 1", "Option 2", "Option 3"],
  },
  { id: "esSurveyScopeCustomFinalizeTool-12", type: "text", label: "Set Default Values (For Repetitive Fields)" },
  {
    id: "esSurveyScopeCustomFinalizeTool-13", type: "checkbox",
    label:
      "Enable Conditional Formatting (e.g., auto-highlight gaps or trigger alerts)",
  },
  {
    id: "esSurveyScopeCustomFinalizeTool-14", type: "checkbox",
    label: "Enable Comments/Annotation Field (for reviewers/respondents)",
  },
  { id: "esSurveyScopeCustomFinalizeTool-15", type: "checkbox", label: "Enable Print-Optimized Layout (PDF format)" },
  {
    id: "esSurveyScopeCustomFinalizeTool-16", type: "text",
    label: "Add Instructions/Guidelines Section (Free Text or Upload)",
  },
  { id: "esSurveyScopeCustomFinalizeTool-17", type: "text", label: "Add Survey Introduction Text (for Social Tools)" },
  {
    id: "esSurveyScopeCustomFinalizeTool-18", type: "dropdown",
    label: "Set Language Options (for Multi-Lingual Surveys)",
    options: ["English", "Local", "Other"],
  },
  {
    id: "esSurveyScopeCustomFinalizeTool-19", type: "checkbox",
    label: "Enable Consent Checkbox (for Social/Community Surveys)",
  },
  {
    id: "esSurveyScopeCustomFinalizeTool-20", type: "checkbox",
    label: "Enable Anonymity Option (for Sensitive Surveys, e.g., GBV Tools)",
  },
  {
    id: "esSurveyScopeCustomFinalizeTool-21", type: "dropdown",
    label:
      "Customize Rating/Scale Labels (e.g., 1–5, Yes/No, Satisfied/Not Satisfied)",
    options: ["1–5", "Yes/No", "Satisfied/Not Satisfied", "Custom"],
  },
  {
    id: "esSurveyScopeCustomFinalizeTool-22", type: "checkbox",
    label: "Enable Skip Logic (Show/Hide Fields Based on Responses)",
  },
  { id: "esSurveyScopeCustomFinalizeTool-23", type: "text", label: "Add Custom Footer (e.g., Confidentiality Notice)" },
  { id: "esSurveyScopeCustomFinalizeTool-24", type: "checkbox", label: "Preview Tool Before Finalizing" },
  { id: "esSurveyScopeCustomFinalizeTool-25", type: "checkbox", label: "Save as Template for Future Use" },
  { id: "esSurveyScopeCustomFinalizeTool-26", type: "checkbox", label: "Let AI-Driven Dashboard Select" },
];
export const esSurveyScopeDownloadTool = [
  { id: "esSurveyScopeDownloadTool-1", type: "checkbox", label: "Download as Word/Excel Template" },
  { id: "esSurveyScopeDownloadTool-2", type: "checkbox", label: "Download as PDF (Read-only Format)" },
  { id: "esSurveyScopeDownloadTool-3", type: "checkbox", label: "Save in Dashboard for Ongoing Use" },
];
export const esSurveyScopeComplianceTracking = [
  { id: "esSurveyScopeComplianceTracking-1", type: "upload", label: "Upload Filled Monitoring Logs" },
];
export const esSurveyScopeDownloadTrackingStatus = [
  // Dashboard & Reporting Options
  {
    id: "esSurveyScopeDownloadTrackingStatus-1", type: "checkbox",
    label: "Dashboard Visuals: Compliance & Survey Status by Site / Department",
  },
  { id: "esSurveyScopeDownloadTrackingStatus-2", type: "checkbox", label: "Compliance & Survey Trend Charts (Bar / Line)" },
  { id: "esSurveyScopeDownloadTrackingStatus-3", type: "checkbox", label: "High-Risk & Critical Alert Section" },
  { id: "esSurveyScopeDownloadTrackingStatus-4", type: "checkbox", label: "Non-Compliance & Key Findings Summary Table" },
  {
    id: "esSurveyScopeDownloadTrackingStatus-5", type: "checkbox",
    label: "Compliance & Survey Scorecard (by Plan/Procedure/Checklist/Survey)",
  },
  { id: "esSurveyScopeDownloadTrackingStatus-6", type: "checkbox", label: "ESG KPI Achievement Status" },
  { id: "esSurveyScopeDownloadTrackingStatus-7", type: "checkbox", label: "Survey Response Summary (Aggregated Responses)" },
  { id: "esSurveyScopeDownloadTrackingStatus-8", type: "checkbox", label: "Stakeholder & Community Feedback Snapshot" },
  {
    id: "esSurveyScopeDownloadTrackingStatus-9", type: "checkbox",
    label: "Outstanding Corrective Actions & Follow-Up List",
  },
  { id: "esSurveyScopeDownloadTrackingStatus-10", type: "checkbox", label: "Next Due Monitoring / Survey Tasks List" },
  { id: "esSurveyScopeDownloadTrackingStatus-11", type: "checkbox", label: "Timeline Graph (Progress Over Time)" },
  {
    id: "esSurveyScopeDownloadTrackingStatus-12", type: "checkbox",
    label: "Heatmap: Compliance/Survey Status Across Locations",
  },
  {
    id: "esSurveyScopeDownloadTrackingStatus-13", type: "checkbox",
    label: "Download Consolidated Monitoring & Survey Report (PDF / Excel)",
  },
  {
    id: "esSurveyScopeDownloadTrackingStatus-14", type: "checkbox",
    label: "Download Detailed Compliance & Survey Register (Excel)",
  },
  {
    id: "esSurveyScopeDownloadTrackingStatus-15", type: "checkbox",
    label: "Download Gap & Risk Analysis Report (Word / PDF)",
  },
  { id: "esSurveyScopeDownloadTrackingStatus-16", type: "checkbox", label: "Export Visual Charts & Graphs (PNG / PPT)" },
  {
    id: "esSurveyScopeDownloadTrackingStatus-17", type: "checkbox",
    label: "Site/Department-Wise Performance Comparison Report",
  },
  {
    id: "esSurveyScopeDownloadTrackingStatus-18", type: "checkbox",
    label: "Incident & Grievance Closure Report (if applicable)",
  },
  { id: "esSurveyScopeDownloadTrackingStatus-19", type: "checkbox", label: "Training & Capacity Building Status Report" },
  { id: "esSurveyScopeDownloadTrackingStatus-20", type: "checkbox", label: "Audit & Inspection Summary Log (if applicable)" },
];
export const esLegalApplicationReq = [
  {
    id: "esLegalApplicationReq-1", type: "checkbox-group",
    label: "Select Applicable Legal & Regulatory Frameworks. ",
  },
  {
    id: "esLegalApplicationReq-2", type: "location",
    label: "Country / Region Selection",
    autoDetect: true, // Using GPS/IP
    manualSelect: true,
  },
  {
    id: "esLegalApplicationReq-3", type: "checkbox-group",
    label: "Industry Sector Selection",
    options: [
      "Construction",
      "Energy",
      "Mining",
      "Oil & Gas",
      "Manufacturing",
      "Logistics",
      "Agriculture",
      "Healthcare",
      "Finance",
      "Technology & Services",
      "Other (Custom)",
    ],
  },
  {
    id: "esLegalApplicationReq-4", type: "checkbox-group",
    label: "Applicable Legal & Regulatory Areas",
    options: [
      "Environmental Laws & Permits",
      "Social Laws & Labor Regulations",
      "Health & Safety (OHS) Laws",
      "Climate & Energy Regulations",
      "Biodiversity & Conservation Requirements",
      "Waste & Pollution Control",
      "Water Resource Regulations",
      "Cultural Heritage & Indigenous Rights",
      "ESG Disclosure & Reporting Regulations",
      "Green Finance & Bond Compliance",
      "Supply Chain & Procurement Compliance",
      "Anti-Corruption & Bribery Compliance",
      "Data Privacy & Cybersecurity",
      "Sustainable Product & Packaging Regulations",
      "Gender Equality & Non-Discrimination",
      "IFC Performance Standards (PS1–PS8)",
      "Equator Principles",
      "ISO Standards (14001, 45001, 26000, 9001, etc.)",
      "EU Frameworks (CSRD, ESRS, EU Taxonomy)",
      "OECD Guidelines for Multinational Enterprises",
      "UN Guiding Principles (UNGPs)",
      "LEED / WELL / Green Building Certifications",
      "ICMA Green / Social / Sustainability Bonds Framework",
      "Climate Bonds Initiative (CBI) Certification",
      "Canadian Frameworks (CCOHS, CIB, Environmental Acts)",
      "Custom Legal Frameworks (Upload or Specify)",
      "Multi-Country Compliance",
      "Multi-Site / Project-Wide Compliance View",
      "National Climate Commitments (NDCs, Paris Agreement Compliance)",
      "Local Municipal / City-Level Regulations",
      "Corporate Governance & Ethics Compliance",
      "Modern Slavery & Human Trafficking Acts",
      "Other Custom (User-Defined)",
    ],
  },
];
export const esLegalApplicationScopeCompParams = [
  {
    id: "esLegalApplicationScopeCompParams-1", type: "checkbox-group",
    label: "Scope & Compliance Parameters",
  },
  {
    id: "esLegalApplicationScopeCompParams-2", type: "text",
    label: "Project / Site Name",
  },

  {
    id: "esLegalApplicationScopeCompParams-3", type: "date-range",
    label: "Project Start & End Dates",
    startLabel: "Start Date",
    endLabel: "End Date",
  },

  {
    id: "esLegalApplicationScopeCompParams-4", type: "dropdown",
    label: "Industry Sector",
    options: [
      "Construction",
      "Energy",
      "Mining",
      "Oil & Gas",
      "Manufacturing",
      "Logistics",
      "Agriculture",
      "Healthcare",
      "Finance",
      "Technology & Services",
      "Other (Custom)",
    ],
  },

  {
    id: "esLegalApplicationScopeCompParams-5", type: "dropdown",
    label: "Site Location - Country",
    options: [
      "Afghanistan",
      "Albania",
      "Algeria",
      "Argentina",
      "Australia",
      "Austria",
      "Bangladesh",
      "Belgium",
      "Brazil",
      "Canada",
      "China",
      "Egypt",
      "France",
      "Germany",
      "India",
      "Indonesia",
      "Italy",
      "Japan",
      "Mexico",
      "Nigeria",
      "Pakistan",
      "Russia",
      "Saudi Arabia",
      "South Africa",
      "Turkey",
      "United Kingdom",
      "United States",
      "Other",
    ],
  },

  {
    id: "esLegalApplicationScopeCompParams-6", type: "dropdown",
    label: "Site Location - Region",
    options: [
      "North America",
      "South America",
      "Europe",
      "Asia Pacific",
      "Middle East",
      "Africa",
      "Other",
    ],
  },

  {
    id: "esLegalApplicationScopeCompParams-7", type: "dropdown",
    label: "Site Location - District",
    options: [
      "Urban",
      "Semi-Urban",
      "Rural",
      "Industrial Zone",
      "Special Economic Zone",
      "Other",
    ],
  },

  {
    id: "esLegalApplicationScopeCompParams-8", type: "text",
    label: "Number of Sites / Operations Covered",
  },

  {
    id: "esLegalApplicationScopeCompParams-9", type: "text",
    label: "Regulatory Authority Name(s) (if applicable)",
  },

  {
    id: "esLegalApplicationScopeCompParams-10", type: "text",
    label: "Applicable Permit / License Types",
  },

  {
    id: "esLegalApplicationScopeCompParams-11", type: "text-multiline",
    label: "Associated Contractors / Subcontractors List",
  },

  {
    id: "esLegalApplicationScopeCompParams-12", type: "checkbox-group",
    label: "Risk Classification",
    options: ["High", "Medium", "Low"],
  },

  {
    id: "esLegalApplicationScopeCompParams-13", type: "text",
    label: "Linked ESG / Sustainability Strategy (Optional)",
    optional: true,
  },

  {
    id: "esLegalApplicationScopeCompParams-14", type: "checkbox-group",
    label: "Compliance Monitoring Frequency",
    options: ["Monthly", "Quarterly", "Annually", "Other"],
  },

  {
    id: "esLegalApplicationScopeCompParams-15", type: "text",
    label: "Compliance Review Responsibility (Department / Person)",
  },

  {
    id: "esLegalApplicationScopeCompParams-16", type: "radio-group",
    label: "Integration with Existing E&S System",
    options: ["Yes", "No"],
  },

  {
    id: "esLegalApplicationScopeCompParams-17", type: "text-multiline",
    label: "Custom Notes (Optional)",
    optional: true,
  },
];
export const esLegalApplicationScopeCompActivity = [
  {
    id: "esLegalApplicationScopeCompActivity-1", type: "checkbox-group",
    label: "Work Activities:",
  },
  {
    type: "checkbox-group",
    options: [
      "Construction (Buildings, Roads, Infrastructure, Bridges)",
      "Plant Operations (Industrial Production, Chemical Processing)",
      "Equipment Installation, Commissioning, and Testing",
      "Survey, Monitoring, Inspection Field Work",
      "Logistics and Warehousing Operations",
      "Procurement, Supplier, and Vendor Management",
      "Administration and Corporate Office Operations",
      "Vehicle Fleet and Transport Management",
      "Maintenance and Repair Services",
      "Renewable Energy Operations (Solar, Wind, Hydro, Hybrid)",
      "Waste Collection, Management, Recycling, Disposal",
      "Water Extraction, Supply, and Wastewater Treatment",
      "Land Management and Restoration Activities",
      "Biodiversity Protection and Conservation Programs",
      "Agriculture / Forestry / Aquaculture",
      "Mining and Extraction Activities",
      "Energy Generation / Transmission (Solar, Wind, Hydro, Gas)",
      "Chemical Handling and Storage",
      "Transportation / Shipping Operations",
      "Retail / Office Facility Management",
      "Other Activities (Custom Specify)",
      "Emergency Response Drills and Preparedness",
      "Site Demobilization and Closure Activities",
      "Decommissioning and Rehabilitation Work",
      "Hazardous Material Transportation",
      "Fuel Storage and Dispensing Operations",
      "Public Engagement & Consultation Programs",
      "ICT/Data Center Environmental Operations",
      "Public Health & Pandemic Response Measures",
      "Marine & Coastal Operations (if applicable)",
      "Urban Development & Public Utilities",
      "Road & Traffic Safety Operations",
      "Community Health Programs (Vaccinations, Clinics)",
      "Waste-to-Energy or Circular Economy Projects",
      "Carbon Offset / Carbon Credit Activities",
      "ESG Training & Capacity Building Programs",
    ],
  },
  {
    id: "esLegalApplicationScopeCompActivity-2", type: "text",
    label: "Other Customize (free text)",
    optional: true,
  },
];
export const esLegalApplicationScopeCompLogs = [
  {
    id: "esLegalApplicationScopeCompLogs-1", type: "upload",
    label:
      "Download Legal Compliance Register (Word/Excel / PDF)  Download file/report/log .",
  },
];
export const esLegalApplicationScopeComptracking = [
  {
    id: "esLegalApplicationScopeComptracking-1", type: "checkbox-group",
    label: "Upload & Map Existing Legal Documents",
    options: [
      "Environmental Permits / Licenses",
      "Labor & Social Compliance Certificates",
      "Health & Safety Certifications (OHS)",
      "Pollution / Waste Management Approvals",
      "Climate & Emissions Disclosures (if applicable)",
      "Biodiversity / Conservation Permits",
      "Cultural Heritage / Indigenous Agreements",
      "Water Use / Extraction & Discharge Permits",
      "Hazardous Material Handling & Storage Permits",
      "Waste Transportation / Disposal Certifications",
      "Energy Efficiency Certifications (if applicable)",
      "Green Building Certifications (LEED, WELL, etc.)",
      "Green / Social Bond Framework Documents",
      "ISO Certifications (14001, 45001, etc.)",
      "Incident & Accident Logs (Compliance-Related)",
      "Any Previous Legal Compliance Audits",
      "Legal Correspondence / Notices from Regulators",
      "Corrective Action Plans (CAPs) from Previous Audits",
      "Supplier / Contractor Legal Compliance Proofs",
      "Stakeholder FPIC (Free, Prior & Informed Consent) Records",
      "Site Environmental / Social Baseline Studies",
      "Grievance Mechanism Logs & Closure Reports",
      "Security Risk Assessments (if applicable)",
      "Indigenous Peoples Plans (IPPs)",
      "Land Acquisition & Resettlement Action Plans (RAPs)",
      "Corporate ESG Policies & Statements",
      "Annual ESG / Sustainability Reports",
      "ESG-Related Insurance Certificates (if applicable)",
      "Custom Upload (User-defined)",
    ],
  },
  {
    id: "esLegalApplicationScopeComptracking-2", type: "text",
    label: "Custom Upload Description (Optional)",
    optional: true,
  },
];
export const esLegalApplicationScopeComptrackingCheck = [
  {
    id: "esLegalApplicationScopeComptrackingCheck-1", type: "info",
    label: "Auto-Generate Legal Compliance Tracker",
    description:
      "Automatically generate a legal compliance tracker based on selected frameworks.",
  },
  {
    type: "dashboard-view",
    label: "Dashboard View",
    items: [
      "✔ Legal Compliance Status (Color-Coded)",
      "✔ Expiring Permits & Certificates (Alert Section)",
      "✔ Upcoming Legal Review Deadlines",
    ],
  },
  {
    id: "esLegalApplicationScopeComptrackingCheck-2", type: "checkbox-group",
    label: "Set Alerts / Notifications",
    options: [
      "Permit Renewal Reminders",
      "Audit Due Dates",
      "Compliance Review Updates",
      "Legal Compliance Status (with Color-Code)",
      "Expiring Permits & Certificates (Alert Section)",
      "Upcoming Legal Review Deadlines",
    ],
  },
];

export const enviromentalSocialSystemDevData = [
  // Step 2: Provide Relevant Data and Information

  { id: "enviromentalSocialSystemDevData-1", type: "text", label: "Project / Site Name" },
  {
    id: "enviromentalSocialSystemDevData-2", type: "text",
    label: "Project Location (Country, Region, District, GPS Coordinates)",
  },

  {
    id: "enviromentalSocialSystemDevData-3", type: "dropdown",
    label: "Type of Industry",
    options: [
      "Construction",
      "Manufacturing",
      "Mining",
      "Energy",
      "Logistics",
      "Agriculture",
      "Healthcare",
      "Services",
      "Others",
    ],
  },

  {
    id: "enviromentalSocialSystemDevData-4", type: "dropdown",
    label: "Nature of Operations",
    options: [
      "Civil Works",
      "Mechanical",
      "Electrical",
      "Environmental",
      "Mixed",
    ],
  },

  {
    id: "enviromentalSocialSystemDevData-5", type: "checkbox-group",
    label: "Project Phase",
    options: [
      "Planning",
      "Construction",
      "Operation",
      "Maintenance",
      "Decommissioning",
    ],
  },

  {
    id: "enviromentalSocialSystemDevData-6", type: "text",
    label: "Expected Project Duration (e.g., 6 months, 24 months, ongoing)",
  },
  { id: "enviromentalSocialSystemDevData-7", type: "text", label: "Total Site Area (hectares / m²)" },

  {
    id: "enviromentalSocialSystemDevData-8", type: "checkbox-group",
    label: "Ownership Type",
    options: ["Private", "Public", "PPP", "Joint Venture"],
  },

  { id: "enviromentalSocialSystemDevData-9", type: "text", label: "Developer / Client Organization" },

  {
    id: "enviromentalSocialSystemDevData-10", type: "checkbox-group",
    label: "ESG Reporting Framework Followed (if any)",
    options: ["GRI", "SASB", "TCFD", "IFRS", "CSRD", "None"],
  },

  { id: "enviromentalSocialSystemDevData-11", type: "text", label: "Certifications / Accreditations Held (if any)" },

  {
    id: "enviromentalSocialSystemDevData-12", type: "checkbox-group",
    label: "Applicable Financing / Bond Frameworks (if any)",
    options: [
      "Green Bonds",
      "Social Bonds",
      "Sustainability Bonds",
      "Other (specify)",
    ],
  },

  {
    id: "enviromentalSocialSystemDevData-13", type: "radio-group",
    label:
      "Has the Project Undergone an Environmental & Social Impact Assessment (ESIA)",
    options: ["Yes", "No"],
  },

  {
    id: "enviromentalSocialSystemDevData-14", type: "radio-group",
    label: "Has the Project Identified Material ESG Risks or Opportunities",
    options: ["Yes", "No"],
  },
];
export const enviromentalSocialSystemDocuments = [
  // Upload filled Query form for Relevant Plan / Procedure / Work Instructions
  {
    id: "enviromentalSocialSystemDocuments-1", type: "upload",
    label:
      "Upload Filled Query Form for Relevant Plan / Procedure / Work Instructions",
  },

  // Upload Supporting Documents (Optional but Recommended)
  {
    id: "enviromentalSocialSystemDocuments-2", type: "checkbox-group",
    label: "Upload Supporting Documents (Optional but Recommended)",
    options: [
      "E&S Policy Statement",
      "Organizational Structure / Roles & Responsibilities",
      "Site Layout Plan / Maps",
      "Permits, Licenses, or Approvals",
      "Previous E&S Audits or Assessments",
      "Monitoring Data Logs (Air, Noise, Wastewater)",
      "Incident Reports / Grievance Logs",
      "List of Contractors / Subcontractors Involved",
      "Contractor Agreements or Safety Records",
      "Stakeholder Meeting Minutes / Consultation Records",
      "List of Stakeholders and Engagement History",
      "Emergency Drill or Training Records",
      "Photos of Site or Critical Work Areas",
      "Existing Work Instructions or Procedures (if any)",
      "Environmental Impact Assessment (EIA) Summary",
      "List of Environmental Aspects and Social Impacts Identified",
      "Security Risk Assessment (if applicable)",
      "Community Liaison Records (if available)",
      "Number of Workers (direct + contractor)",
      "Current Waste Types and Volumes (Solid / Hazardous / Wastewater)",
      "Existing Grievance Records (if applicable)",
      "List of Emergency Scenarios Considered",
      "Existing OHS Risks and Monitoring Systems",
      "Transport & Traffic Layout / Routes",
      "Current Monitoring Data (Air, Noise, Water, Waste) (if available)",
      "Incident or Near Miss History (past 12–24 months)",
      "Community Health and Safety Concerns",
      "Biodiversity or Cultural Heritage Site Proximity (if applicable)",
      "Existing Training Programs and Records",
      "Equipment and Resource Inventory (e.g., PPE, Monitoring Tools)",
      "Site Maps / Layout Diagrams",
      "ESG Reporting Framework Used (GRI, SASB, TCFD, IFRS, etc.)",
      "Sustainability Targets or KPIs (if any)",
      "Certifications or Accreditations Held (ISO, GMP, LEED, CE, etc.)",
      "Green / Social Bond Documentation (if applicable)",
      "Climate Risk or GHG Assessment Reports (if applicable)",
    ],
  },
];
export const downloadGeneratedDocuments = [
  {
    id: "downloadGeneratedDocuments-1", type: "checkbox-group",
    label: "Step 4: Download Generated Documents",
    options: [
      "Download Relevant Plan(s)",
      "Download Procedure(s)",
      "Download Work Instruction(s)",
    ],
  },
];
export const reviewAndCommentDocuments = [
  {
    id: "reviewAndCommentDocuments-1", type: "checkbox-group",
    label: "Review and Comment",
    options: [
      "Review Drafts and Add Inline Comments",
      "Request Clarifications or Revisions",
      "Upload Additional Documents (if needed)",
      "Assign Review to Internal Stakeholders or Management",
    ],
  },
];
export const reviewDocumentsDownloadGeneratedReports = [
  {
    id: "reviewDocumentsDownloadGeneratedReports-1", type: "checkbox-group",
    label: "Download Generated Documents",
    options: [
      "Download Relevant Plan(s)",
      "Download Procedure(s)",
      "Download Work Instruction(s)",
    ],
  },
];

export const finalizedCleanDocuments = [
  {
    id: "finalizedCleanDocuments-1", type: "checkbox-group",
    label: "Final Clean Version",
    options: [
      "Download Finalized and Approved Plan(s)",
      "Download Finalized Procedure(s)",
      "Download Finalized Work Instruction(s)",
    ],
  },
];
export const auditorInputBasicAudit = [
  // 🔶 Auditor Inputs – Basic Audit Details

  { id: "auditorInputBasicAudit-1", type: "text", label: "Audit Name/Title" },
  { id: "auditorInputBasicAudit-2", type: "text", label: "Company/Project Name" },
  { id: "auditorInputBasicAudit-3", type: "text", label: "Site Name/Location" },
  { id: "auditorInputBasicAudit-4", type: "text", label: "Auditor Name and Organization" },

  {
    id: "auditorInputBasicAudit-5", type: "checkbox-group",
    label: "Audit Type",
    options: ["Internal", "External", "Third-Party"],
  },

  {
    id: "auditorInputBasicAudit-6", type: "text",
    label:
      "Audit Scope (e.g., Construction, Operation, Maintenance, Warehousing)",
  },
  { id: "auditorInputBasicAudit-7", type: "text", label: "Audit Dates" },
  { id: "auditorInputBasicAudit-8", type: "text", label: "Audit Team Members" },
];
export const siteAndActivitiesProfiling = [
  // 🔶 Site and Activities Profiling

  {
    id: "siteAndActivitiesProfiling-1", type: "checkbox-group",
    label: "Site Type",
    options: [
      "Factory",
      "Construction Site",
      "Office",
      "Warehouse",
      "Field Operations",
    ],
  },

  {
    id: "siteAndActivitiesProfiling-2", type: "checkbox-group",
    label: "Key Activities Observed",
    options: [
      "Construction Works",
      "Manufacturing Processes",
      "Material Handling / Warehousing",
      "Vehicle Movements",
      "Chemical Handling/Storage",
      "Energy Generation/Use",
      "Maintenance/Repair Works",
      "Field Inspections / Surveys",
    ],
  },

  { id: "siteAndActivitiesProfiling-3", type: "text", label: "No. of Workers On-Site" },

  {
    id: "siteAndActivitiesProfiling-4", type: "radio-group",
    label: "Use of Contractors/Subcontractors",
    options: ["Yes", "No"],
  },
];
export const frameWorkAutoMapHseAudit = [
  // 🔶 Frameworks Automatically Mapped (based on Activities & Country)

  {
    id: "frameWorkAutoMapHseAudit-1", type: "checkbox-group",
    label: "Frameworks Automatically Mapped (based on Activities & Country)",
    options: [
      "National Labor and HSE Laws (Country Specific)",
      "OSHA Standards (if applicable)",
      "ISO 45001:2018",
      "ISO 14001:2015",
      "IFC Performance Standards (PS1-PS8)",
      "GRI Standards for OHS and Labor Indicators",
      "Local Environmental Agency Regulations (e.g., SEPA, CEPA, UAE MoCCAE)",
      "Industry Best Practice Guidelines (API, ILO, IOGP if applicable)",
    ],
  },
  { id: "frameWorkAutoMapHseAudit-2", label: "Any other relevant report", checked: false, customName: "" },
];
export const editorsEntersObsHseAudit = [
  // 🔶 Auditor Enters Observations in Categories
  {
    id: "editorsEntersObsHseAudit-1", type: "heading",
    label: "Auditor Enters Observations in Categories",
  },

  // 1. Occupational Health & Safety
  {
    id: "editorsEntersObsHseAudit-2", type: "checkbox-with-input",
    label: "Occupational Health & Safety",
    options: [
      "PPE Usage (Compliance with PPE Matrix)",
      "Working at Heights Controls",
      "Machinery Guarding and Lockout/Tagout",
      "Electrical Safety",
      "Ergonomics at Workstations",
      "Other",
    ],
  },

  // 2. Environment
  {
    id: "editorsEntersObsHseAudit-3", type: "checkbox-with-input",
    label: "Environment",
    options: [
      "Air Emissions Controls",
      "Water Management",
      "Waste Management (storage, disposal)",
      "Spill Prevention and Response",
      "Hazardous Materials Handling",
      "Other",
    ],
  },

  // 3. Emergency Preparedness
  {
    id: "editorsEntersObsHseAudit-4", type: "checkbox-with-input",
    label: "Emergency Preparedness",
    options: [
      "Fire Safety Measures",
      "Emergency Exits and Assembly Points",
      "Emergency Drills Conducted",
      "Other",
    ],
  },

  // 4. Labor and Social Compliance
  {
    id: "editorsEntersObsHseAudit-5", type: "checkbox-with-input",
    label: "Labor and Social Compliance",
    options: [
      "Worker Contracts",
      "Child/Forced Labor Check",
      "Grievance Mechanism Availability",
      "Other",
    ],
  },

  // 5. General Other Observations
  {
    id: "editorsEntersObsHseAudit-6", type: "text",
    label: "Other Observations (General)",
    placeholder: "Enter any additional observations",
  },
];
export const comparisionEngineHseAudit = [
  {
    id: "comparisionEngineHseAudit-1", type: "heading",
    label: "Comparison Engine - Compliance Analysis",
  },

  {
    id: "comparisionEngineHseAudit-2", type: "checkbox-with-input",
    label: "Observation Status",
    options: [
      "Fully Compliant",
      "Minor Non-Compliance",
      "Major Non-Compliance",
    ],
  },

  {
    id: "comparisionEngineHseAudit-3", type: "checkbox-with-input",
    label: "Legal / Standard Cross-Check",
    options: [
      "Relevant Law/Standard Referenced",
      "Gap Description Auto-Generated",
      "Other",
    ],
  },

  {
    id: "comparisionEngineHseAudit-4", type: "radio-with-input",
    label: "Risk Level Auto-Assigned",
    options: [
      "High Risk (Immediate Action Needed)",
      "Medium Risk (Short-Term Correction)",
      "Low Risk (Monitoring Required)",
    ],
  },

  {
    id: "comparisionEngineHseAudit-5", type: "checkbox-with-single-input",
    label: "Regulatory Breach Identified (If any critical laws breached)",
    placeholder: "Describe the regulatory breach and applicable law/standard",
  },

  {
    id: "comparisionEngineHseAudit-6", type: "text",
    label: "Additional Compliance Notes",
    placeholder: "Enter any additional compliance observations or notes",
  },
];
export const dashboardAutoSuggestionHseAudit = [
  // 🔶 Dashboard Auto-Suggests Recommendations

  {
    id: "dashboardAutoSuggestionHseAudit-1", type: "checkbox-group",
    label: "Dashboard Auto-Suggests Recommendations.",
  },
  {
    id: "dashboardAutoSuggestionHseAudit-2", type: "checkbox-group",
    label: "Based on Gap Type",
    options: [
      "Immediate Corrective Action",
      "Training or Awareness Sessions",
      "Engineering Control Implementations",
      "Policy/Procedure Update Needed",
      "Contractor Requalification",
    ],
  },

  {
    id: "dashboardAutoSuggestionHseAudit-3", type: "checkbox-group",
    label: "Corrective Actions Auto-Tagged",
    options: [
      "Responsible Party",
      "Due Date",
      "Priority Level",
      "Resource/Support Needed",
    ],
  },
];
export const autoGeneratedReportSectionsHseAudit = [
  // 🔶 Auto-Generate Professional HSE Audit Report

  { id: "autoGeneratedReportSectionsHseAudit-1", type: "checkbox", label: "Executive Summary" },
  { id: "autoGeneratedReportSectionsHseAudit-2", type: "checkbox", label: "Site and Activity Description" },
  { id: "autoGeneratedReportSectionsHseAudit-3", type: "checkbox", label: "Audit Findings (Compliance / Non-Compliance)" },
  { id: "autoGeneratedReportSectionsHseAudit-4", type: "checkbox", label: "Gap Analysis Table" },
  { id: "autoGeneratedReportSectionsHseAudit-5", type: "checkbox", label: "Corrective Action Plan Table" },
  {
    id: "autoGeneratedReportSectionsHseAudit-6", type: "checkbox",
    label: "Visual Risk Heatmap (by Department, Category, Site Area)",
  },
  { id: "autoGeneratedReportSectionsHseAudit-7", type: "checkbox", label: "Photos and Evidence Attachment Section" },
  { id: "autoGeneratedReportSectionsHseAudit-8", type: "checkbox", label: "Complete Audit Report" },
];
export const optionalMonitoringSetupHseAudit = [
  // 🔶 Optional Monitoring Setup

  { id: "optionalMonitoringSetupHseAudit-1", type: "checkbox", label: "Corrective Actions Status Dashboard" },
  { id: "optionalMonitoringSetupHseAudit-2", type: "checkbox", label: "Monthly or Quarterly Progress Update Reminders" },
  { id: "optionalMonitoringSetupHseAudit-3", type: "checkbox", label: "Audit Closure Verification status" },
  { id: "optionalMonitoringSetupHseAudit-4", type: "checkbox", label: "Permit Expiry Monitoring for Compliance Items" },
  {
    id: "optionalMonitoringSetupHseAudit-5", type: "checkbox",
    label: "ESG KPI Dashboard Integration (OHS Metrics like LTI, TRIR)",
  },
  {
    id: "optionalMonitoringSetupHseAudit-6", type: "checkbox",
    label: "Re-Audit Scheduling Auto-Prompt (based on closure rates)",
  },
];
export const supplierAssessmentModule = [
  { id: "supplierAssessmentModule-1", type: "text", label: "Project / Site Name" },

  {
    id: "supplierAssessmentModule-2", type: "checkbox-group",
    label: "Procurement Category",
    options: ["Materials", "Equipment", "Services", "Others (Specify)"],
  },

  {
    id: "supplierAssessmentModule-3", type: "dropdown",
    label: "Industry Sector",
    options: [
      "Construction",
      "Energy",
      "Mining",
      "Oil & Gas",
      "Manufacturing",
      "Logistics",
      "Agriculture",
      "Healthcare",
      "Finance",
      "Technology",
      "Services",
      "Other",
    ],
  },

  {
    id: "supplierAssessmentModule-4", type: "checkbox-group",
    label: "Supplier Type",
    options: [
      "Manufacturer",
      "Service Provider",
      "Contractor / Subcontractor",
      "Logistics / Transport Provider",
      "Consultant",
      "Other (Specify)",
    ],
  },

  { id: "supplierAssessmentModule-5", type: "text", label: "Supplier Country / Region" },

  {
    id: "supplierAssessmentModule-6", type: "checkbox-group",
    label: "Supply Chain Tier",
    options: ["Tier 1", "Tier 2", "Tier 3", "Other"],
  },

  {
    id: "supplierAssessmentModule-7", type: "checkbox-group",
    label: "Criticality Classification",
    options: ["Critical Supplier", "Key Supplier", "General Supplier"],
  },

  { id: "supplierAssessmentModule-8", type: "text", label: "Contract Value Range (Optional)" },

  {
    id: "supplierAssessmentModule-9", type: "checkbox-group",
    label: "Associated Project Phase",
    options: ["Design", "Construction", "Operation", "Decommissioning"],
  },
  { id: "supplierAssessmentModule-10", label: "Additional Notes (Optional)", checked: false, customName: "" },
];
export const esgRiskComplianceAssessment = [
  {
    id: "esgRiskComplianceAssessment-1", type: "label",
    label: "Customized Assessment",
  },
  {
    id: "esgRiskComplianceAssessment-2", type: "checkbox-group",
    label: "Assessment of ESG Questionnaire Based on:",
    options: ["Industry Sector", "Region / Jurisdiction", "Supplier Type"],
  },
  {
    id: "esgRiskComplianceAssessment-3", type: "checkbox-group",
    label: "Risk Categories",
    options: [
      "Environmental Compliance Risk",
      "Social & Labor Risk",
      "OHS Risk",
      "Supply Chain & Transparency Risk",
      "Business Ethics & Governance Risk",
      "Climate & Energy Transition Risk",
    ],
  },
  {
    id: "esgRiskComplianceAssessment-4", type: "checkbox-group",
    label: "HSE Performance",
    options: [
      "Lost Time Injury Frequency Rate (LTIFR)",
      "Total Recordable Incident Rate (TRIR)",
      "Environmental Non-Compliance Cases",
    ],
  },
  {
    id: "esgRiskComplianceAssessment-5", type: "checkbox-group",
    label: "Site Audit Option",
    options: [
      "Desktop Review Only",
      "Onsite Audit Required",
      "Hybrid Assessment",
    ],
  },
  {
    id: "esgRiskComplianceAssessment-6", type: "checkbox-group",
    label: "Assessment Inputs",
    options: [
      "Compliance Documentation Review",
      "Self-Assessment Questionnaire Responses",
      "Audit / Inspection Reports",
    ],
  },
  {
    id: "esgRiskComplianceAssessment-7", type: "label",
    label: "Scoring",
  },
  {
    id: "esgRiskComplianceAssessment-8", type: "checkbox-group",
    label: "Rating Scale",
    options: ["0 (Not Compliant)", "1", "2", "3", "4", "5 (Best Practice)"],
  },
  {
    id: "esgRiskComplianceAssessment-9", type: "checkbox-group",
    label: "Auto-Generated ESG Risk Rating",
    options: ["High Risk", "Medium Risk", "Low Risk"],
  },
  {
    id: "esgRiskComplianceAssessment-10", type: "checkbox-group",
    label: "Technical Capability",
    options: [
      "Production / Service Capacity",
      "Equipment & Technology Availability",
      "Quality Control Processes",
      "R&D / Innovation Strength",
      "Supply Continuity / Business Continuity Planning",
    ],
  },
  {
    id: "esgRiskComplianceAssessment-11", type: "checkbox-group",
    label: "Track Record & References",
    options: [
      "List of Past Projects / Contracts",
      "Client Testimonials / Reference Letters",
      "Record of Compliance (Penalties, Warnings)",
    ],
  },
  {
    id: "esgRiskComplianceAssessment-12", type: "checkbox-group",
    label: "Responsiveness & Customer Service",
    options: ["Response Time to Inquiries", "Dispute Resolution History"],
  },
  {
    id: "esgRiskComplianceAssessment-13", type: "checkbox-group",
    label: "Digital Readiness (Optional)",
    options: [
      "Use of Digital Tools / Reporting Systems",
      "Cybersecurity Compliance",
      "Let AI-Driven Self-Assessment",
    ],
  },
];
export const esgScoringAndSelectionStep = [
  {
    id: "esgScoringAndSelectionStep-1", type: "section-header",
    label: "Scoring & Selection Decision",
    description:
      "Complete the weighted scorecard and review automated red flags before making final decision",
  },
  {
    id: "esgScoringAndSelectionStep-2", type: "note",
    label:
      "Complete the weighted scorecard and review automated red flags before making final decision",
  },
  {
    id: "esgScoringAndSelectionStep-3", type: "weighted-scorecard",
    label: "Weighted Scorecard (%)",
    description:
      "Enter percentage weights for each category (total should equal 100%)",
    fields: [
      {
        type: "text",
        label: "ESG Compliance (%)",
        placeholder: "Enter percentage",
        validation: { min: 0, max: 100, type: "number" },
      },
      {
        type: "text",
        label: "Technical Capability (%)",
        placeholder: "Enter percentage",
        validation: { min: 0, max: 100, type: "number" },
      },
      {
        type: "text",
        label: "Financial & Legal (%)",
        placeholder: "Enter percentage",
        validation: { min: 0, max: 100, type: "number" },
      },
      {
        type: "text",
        label: "HSE & Risk (%)",
        placeholder: "Enter percentage",
        validation: { min: 0, max: 100, type: "number" },
      },
      {
        type: "text",
        label: "References & Track Record (%)",
        placeholder: "Enter percentage",
        validation: { min: 0, max: 100, type: "number" },
      },
    ],
    summary: {
      display:
        "• ESG Compliance: __%  • Technical Capability: __%  • Financial & Legal: __%  • HSE & Risk: __%  • References & Track Record: __%",
    },
  },
  {
    id: "esgScoringAndSelectionStep-4", type: "auto-flags",
    label: "Flagging Critical Red Flags Automatically",
    description:
      "System automatically detects and flags critical issues (E.g., Child Labor, Missing Permits, Repeated Incidents)",
    placeholder: "e.g., Child Labor, Missing Permits, Repeated Incidents",
    autoDetectedFlags: [
      "Child Labor",
      "Missing Permits",
      "Repeated Safety Incidents",
      "Environmental Violations",
      "Financial Irregularities",
      "Legal Non-compliance",
      "Human Rights Violations",
      "Corruption/Bribery Cases",
      "Poor Safety Record",
    ],
  },
  {
    id: "esgScoringAndSelectionStep-5", type: "checkbox-group",
    label: "Scoring Outcome",
    description: "Select the appropriate outcome based on evaluation results",
    options: [
      "Approved",
      "Conditionally Approved (Action Plan Required)",
      "Rejected",
    ],
    required: true,
    singleSelect: true,
    display:
      "[ ] Approved  [ ] Conditionally Approved (Action Plan Required)  [ ] Rejected",
  },
  {
    id: "esgScoringAndSelectionStep-6", type: "textarea",
    label: "Decision Notes & Comments Field",
    placeholder:
      "Enter detailed notes and comments regarding the scoring decision, including rationale for approval/rejection and any specific conditions or action plans required",
    rows: 4,
    required: true,
  },
  {
    id: "esgScoringAndSelectionStep-7", type: "digital-signature",
    label: "Approver / Reviewer Sign-Off (Digital Signature)",
    description:
      "Digital signature and approval details from authorized personnel",
    fields: [
      {
        type: "text",
        label: "Approver Name",
        placeholder: "Enter approver full name",
        required: true,
      },
      {
        type: "text",
        label: "Title/Position",
        placeholder: "Enter approver title or position",
        required: true,
      },
      {
        type: "text",
        label: "Organization/Department",
        placeholder: "Enter organization or department",
        required: true,
      },
      {
        type: "date",
        label: "Approval Date",
        required: true,
      },
      {
        type: "signature-pad",
        label: "Digital Signature",
        placeholder: "Click here to sign digitally",
        required: true,
      },
    ],
  },
];
export const monitoringAndImprovementStep = [
  {
    id: "monitoringAndImprovementStep-1", type: "checkbox-group",
    label: "Review Frequency Setup",
    options: ["Every 6 Months", "Annually", "Custom"],
    required: true,
  },
  {
    id: "monitoringAndImprovementStep-2", type: "checkbox",
    label: "Update Supplier Information Periodically",
    required: false,
  },
  {
    id: "monitoringAndImprovementStep-3", type: "checkbox",
    label: "Track & Monitor Corrective Action Implementation",
    required: false,
  },
  {
    id: "monitoringAndImprovementStep-4", type: "checkbox-group",
    label: "Auto-Alert Triggers",
    description: "System will send alerts for key compliance risks",
    options: [
      "Certification Expiry",
      "ESG Performance Drop",
      "Risk Escalation",
    ],
  },
];
export const reportingAndExportStep = [
  {
    id: "reportingAndExportStep-1", type: "checkbox-group",
    label: "Exportable Documents",
    description: "Select which reports and exports are needed",
    options: [
      "Supplier Assessment Report (PDF/Word)",
      "ESG Risk Summary (PDF/Excel)",
      "Approved Supplier List (Excel)",
      "Audit Trail & Scorecard (Excel/CSV)",
      "Corrective Action & Monitoring Logs (PDF/Excel)",
      "Visual Dashboard Export (Charts in PNG/PPT)",
    ],
  },
];

export const benchMarkingCategory = [
  { id: "benchMarkingCategory-1", type: "checkbox", label: "Real Estate & Infrastructure" },
  { id: "benchMarkingCategory-2", type: "checkbox", label: "Public Corporations" },
  { id: "benchMarkingCategory-3", type: "checkbox", label: "Investment Firms" },
  { id: "benchMarkingCategory-4", type: "checkbox", label: "Gender Equality" },
  { id: "benchMarkingCategory-5", type: "checkbox", label: "General Corporate Sustainability" },
];

export const preferredBenchmarkOptions = [
  { id: "preferredBenchmarkOptions-1", type: "checkbox", label: "🏢 GRESB (for Real Estate/Infrastructure)" },
  { id: "preferredBenchmarkOptions-2", type: "checkbox", label: "📈 DJSI (Dow Jones Sustainability Index)" },
  { id: "preferredBenchmarkOptions-3", type: "checkbox", label: "💼 MSCI ESG Ratings" },
  { id: "preferredBenchmarkOptions-4", type: "checkbox", label: "👩💼 GEI Bloomberg Gender-Equality Index" },
  { id: "preferredBenchmarkOptions-5", type: "checkbox", label: "🌱 FTSE4Good Index" },
  { id: "preferredBenchmarkOptions-6", type: "checkbox", label: "💹 S&P Global ESG Scores" },
  {
    id: "preferredBenchmarkOptions-7", type: "checkbox",
    label: "🇨🇦 RIA (Responsible Investment Association Canada)",
  },
  { id: "preferredBenchmarkOptions-8", type: "checkbox", label: "🌐 Corporate Knights Global 100" },
  { id: "preferredBenchmarkOptions-9", type: "checkbox", label: "📊 CSA Rating (Sustainalytics Methodology)" },
];
export const benchmarkingInsightsDownload = [
  { id: "benchmarkingInsightsDownload-1", type: "checkbox", label: "Comparative ESG Score vs. Selected Benchmark" },
  { id: "benchmarkingInsightsDownload-2", type: "checkbox", label: "🧮 Weighted performance by ESG Pillars" },
  {
    id: "benchmarkingInsightsDownload-3", type: "checkbox",
    label: "📍 Positioning: Percentile rank within sector or geography",
  },
  { id: "benchmarkingInsightsDownload-4", type: "checkbox", label: "⚠️ Gaps Highlighted (vs. benchmark criteria)" },
  { id: "benchmarkingInsightsDownload-5", type: "checkbox", label: "✅ Compliance flags with SDGs, TCFD, GRI, SASB" },
  { id: "benchmarkingInsightsDownload-6", type: "checkbox", label: "📌 Suggestions for improvement" },
  { id: "benchmarkingInsightsDownload-7", type: "checkbox", label: "📊 “Scorecard” or “View Interactive Report”" },
  { id: "benchmarkingInsightsDownload-8", type: "checkbox", label: "📈 Peer Benchmarking Chart" },
  {
    id: "benchmarkingInsightsDownload-9", type: "checkbox",
    label: "📉 ESG Maturity Level (e.g., Beginner, Developing, Advanced)",
  },
  { id: "benchmarkingInsightsDownload-10", type: "checkbox", label: "📈 Trendline (if historic data uploaded)" },
];

export const reportingReqSectorSpecific = [
  { id: "reportingReqSectorSpecific-1", type: "checkbox", label: "GRI Core and Comprehensive Reports" },
  { id: "reportingReqSectorSpecific-2", type: "checkbox", label: "SASB/ISSB Sectoral KPIs" },
  { id: "reportingReqSectorSpecific-3", type: "checkbox", label: "CDP Questionnaires – Climate, Forest, Water" },
  { id: "reportingReqSectorSpecific-4", type: "checkbox", label: "SFDR Articles 6, 8, 9 for Financial Products" },
  { id: "reportingReqSectorSpecific-5", type: "checkbox", label: "ISO Compliance Reports" },
  {
    id: "reportingReqSectorSpecific-6", type: "checkbox",
    label: "TCFD Scenario Disclosures (Financial and Non-Financial Entities)",
  },
  {
    id: "reportingReqSectorSpecific-7", type: "checkbox",
    label: "CORSIA Monitoring, Reporting, and Verification (MRV) Plans",
  },
  { id: "reportingReqSectorSpecific-8", type: "checkbox", label: "EPA Environmental Authority Submissions" },
  { id: "reportingReqSectorSpecific-9", type: "checkbox", label: "REACH / RoHS Safety Declarations" },
  { id: "reportingReqSectorSpecific-10", type: "checkbox", label: "LEED Certification Submissions" },
  { id: "reportingReqSectorSpecific-11", type: "checkbox", label: "BREEAM Certification Submissions" },
  { id: "reportingReqSectorSpecific-12", type: "checkbox", label: "GRESB Certification Submissions" },
  { id: "reportingReqSectorSpecific-13", type: "checkbox", label: "IFC PS1–8 Integrated ESMP & Monitoring Reports" },
  {
    id: "reportingReqSectorSpecific-14", type: "checkbox",
    label: "Equator Principles E&S Screening and Categorization",
  },
  { id: "reportingReqSectorSpecific-15", type: "checkbox", label: "ICMA Post-Issuance Use-of-Proceeds Reports" },
  { id: "reportingReqSectorSpecific-16", type: "checkbox", label: "GSTC (Tourism) Performance Logs" },
  { id: "reportingReqSectorSpecific-17", type: "checkbox", label: "Others" },
];
export const downloadReportsAssessments = [
  {
    id: "downloadReportsAssessments-1", type: "checkbox",
    label: "KPI Dashboards (Scopes 1–4, H&S, DEI, Energy, Waste, Water)",
  },
  { id: "downloadReportsAssessments-2", type: "checkbox", label: "Smart ESG Alert System & Compliance Calendar" },
  { id: "downloadReportsAssessments-3", type: "checkbox", label: "ESG Forecasting & Peer Benchmarking" },
  {
    id: "downloadReportsAssessments-4", type: "checkbox",
    label: "Scope 3 Supply Chain Traceability & Tier Risk Ratings",
  },
  { id: "downloadReportsAssessments-5", type: "checkbox", label: "Climate Scenario Modelling (1.5°C, 2°C, 4°C)" },
  { id: "downloadReportsAssessments-6", type: "checkbox", label: "Community Impact Heatmaps" },
  { id: "downloadReportsAssessments-7", type: "checkbox", label: "FPIC Tracker" },
  { id: "downloadReportsAssessments-8", type: "checkbox", label: "Resettlement Log" },
  {
    id: "downloadReportsAssessments-9", type: "checkbox",
    label:
      "Circularity Tools (Packaging, Materials, Recyclability, Waste Recovery)",
  },
  { id: "downloadReportsAssessments-10", type: "checkbox", label: "Green Bond Performance" },
  { id: "downloadReportsAssessments-11", type: "checkbox", label: "Social Bond Performance" },
  { id: "downloadReportsAssessments-12", type: "checkbox", label: "SLL Performance Dashboards (ICMA)" },
  {
    id: "downloadReportsAssessments-13", type: "checkbox",
    label: "Ecosystem & Biodiversity Risk Monitors (linked with PS6)",
  },
  { id: "downloadReportsAssessments-14", type: "checkbox", label: "SDG Alignment Dashboards (Academia)" },
  {
    id: "downloadReportsAssessments-15", type: "checkbox",
    label: "Grievance Redress Mechanism (GRM) Interfaces (aligned with PS1)",
  },
  {
    id: "downloadReportsAssessments-16", type: "checkbox",
    label: "Greenhouse Gas Inventories (Scopes 1–3 with Industry Benchmarks)",
  },
  { id: "downloadReportsAssessments-17", type: "checkbox", label: "ESG Gap Assessments and Peer Benchmarking" },
  { id: "downloadReportsAssessments-18", type: "checkbox", label: "Resource Efficiency Reviews" },
  {
    id: "downloadReportsAssessments-19", type: "checkbox",
    label: "Climate Risk and Resilience Reports (TCFD-aligned)",
  },
  {
    id: "downloadReportsAssessments-20", type: "checkbox",
    label: "Net-Zero Alignment and Transition Risk Forecasts",
  },
  {
    id: "downloadReportsAssessments-21", type: "checkbox",
    label: "Carbon Offset Strategy Reports and MRV Records (Scope 4)",
  },
  { id: "downloadReportsAssessments-22", type: "checkbox", label: "Product Lifecycle Carbon Footprint Assessments" },
  {
    id: "downloadReportsAssessments-23", type: "checkbox",
    label: "Biodiversity and Ecosystem Risk Reports (PS6 alignment)",
  },
  {
    id: "downloadReportsAssessments-24", type: "checkbox",
    label: "FPIC and Resettlement Planning Logs (aligned with IFC PS5 & PS7)",
  },
  {
    id: "downloadReportsAssessments-25", type: "checkbox",
    label: "ESG Due Diligence for Investors, Lenders, and M&A Transactions",
  },
  {
    id: "downloadReportsAssessments-26", type: "checkbox",
    label:
      "Circular Economy Analysis Reports (Reuse, Recyclability, Waste Diversion)",
  },
  { id: "downloadReportsAssessments-27", type: "checkbox", label: "DEI/Gender Equity Benchmarking Reports" },
  {
    id: "downloadReportsAssessments-28", type: "checkbox",
    label: "Supplier Risk Maps, Audit Logs, and Corrective Action Plans",
  },
];

export const monitoringReportingFrequency = [
  // 📅 Reporting Frequency Selection
  {
    id: "monitoringReportingFrequency-1", type: "checkbox",
    label: "📅 Daily Monitoring (Operational Sites, HSE Incidents)",
  },
  {
    id: "monitoringReportingFrequency-2", type: "checkbox",
    label: "📆 Weekly Updates (Field Progress, Workforce Data)",
  },
  {
    id: "monitoringReportingFrequency-3", type: "checkbox",
    label: "🗓️ Monthly ESG Data Consolidation (KPI Updates)",
  },
  {
    id: "monitoringReportingFrequency-4", type: "checkbox",
    label: "📊 Quarterly ESG Performance Reviews (Management Reporting)",
  },
  {
    id: "monitoringReportingFrequency-5", type: "checkbox",
    label:
      "📄 Bi-Annual Regulatory Reporting (Permit Conditions, License Renewals)",
  },
  {
    id: "monitoringReportingFrequency-6", type: "checkbox",
    label: "📘 Annual ESG Comprehensive Report (Audit, Disclosure Ready)",
  },

  // 🛠️ Monitoring Add-ons
  {
    id: "monitoringReportingFrequency-7", label: "Monitoring Add-ons:",
    type: "heading",
  },
  { id: "monitoringReportingFrequency-8", type: "checkbox", label: "📡 Real-Time Compliance Dashboard" },
  { id: "monitoringReportingFrequency-9", type: "checkbox", label: "🚨 Automated Alerts for Non-Compliance" },
  { id: "monitoringReportingFrequency-10", type: "checkbox", label: "⏰ Permit Expiry Notifications" },
  { id: "monitoringReportingFrequency-11", type: "checkbox", label: "📝 Incident and Grievance Real-Time Logging" },
  {
    id: "monitoringReportingFrequency-12", type: "checkbox",
    label: "🔧 Corrective Action Assignment and Tracking System",
  },
];

export const typesOfReportCompaniesOperational = [
  // Types of Reports Company Can Generate
  {
    id: "typesOfReportCompaniesOperational-1", label: "Types of Reports Company Can Generate:",
    type: "heading",
  },
  { id: "typesOfReportCompaniesOperational-2", type: "checkbox", label: "📊 General ESG Progress Summary Report" },
  { id: "typesOfReportCompaniesOperational-3", type: "checkbox", label: "🌍 Environmental Legal Compliance Assessment" },
  {
    id: "typesOfReportCompaniesOperational-4", type: "checkbox",
    label: "🛡️ Health & Safety Legal Compliance Status Report",
  },
  {
    id: "typesOfReportCompaniesOperational-5", type: "checkbox",
    label: "👷 Labor Rights and Working Conditions Compliance Report",
  },
  {
    id: "typesOfReportCompaniesOperational-6", type: "checkbox",
    label: "🤝 Stakeholder Consultation Outcomes and Grievance Tracking Report",
  },
  {
    id: "typesOfReportCompaniesOperational-7", type: "checkbox",
    label: "🌦️ Climate Risk Analysis and Resilience Planning Report",
  },
  {
    id: "typesOfReportCompaniesOperational-8", type: "checkbox",
    label: "🏛️ Corporate Governance, Anti-Corruption Compliance Summary",
  },
  { id: "typesOfReportCompaniesOperational-9", type: "checkbox", label: "🔗 Supply Chain ESG Risk Evaluation Report" },
  {
    id: "typesOfReportCompaniesOperational-10", type: "checkbox",
    label: "⚡️ Energy Consumption and GHG Inventory Report",
  },
  {
    id: "typesOfReportCompaniesOperational-11", type: "checkbox",
    label: "🌱 Biodiversity Protection and Land Impact Report",
  },

  // Special Customization Choices
  {
    id: "typesOfReportCompaniesOperational-12", label: "Special Customization Choices:",
    type: "heading",
  },
  { id: "typesOfReportCompaniesOperational-13", type: "checkbox", label: "📄 Executive Summary Only (Short Report)" },
  { id: "typesOfReportCompaniesOperational-14", type: "checkbox", label: "📚 Full Technical Report with Annexures" },
  { id: "typesOfReportCompaniesOperational-15", type: "checkbox", label: "📈 Dashboard KPI Visuals and Trend Graphs" },
  {
    id: "typesOfReportCompaniesOperational-16", type: "checkbox",
    label: "🗺️ Compliance Heat Maps and Risk Zone Identification",
  },
  { id: "typesOfReportCompaniesOperational-17", type: "checkbox", label: "🏅 Industry Benchmark Comparison Analytics" },
  { id: "typesOfReportCompaniesOperational-18", type: "checkbox", label: "🛠️ Customized Risk Mitigation Recommendations" },
];

export const dashboardDataProcessing = [
  // Data Processing Features
  {
    id: "dashboardDataProcessing-1", label: "Data Processing Features:",
    type: "heading",
  },
  {
    id: "dashboardDataProcessing-2", type: "checkbox",
    label: "✅ Auto-Validation of Data Entries (Consistency Check)",
  },
  {
    id: "dashboardDataProcessing-3", type: "checkbox",
    label: "🔍 Cross-Verification against Selected Regulatory Frameworks",
  },
  { id: "dashboardDataProcessing-4", type: "checkbox", label: "⚠️ Dynamic Missing Data Identification" },
  {
    id: "dashboardDataProcessing-5", type: "checkbox",
    label: "📉 Risk Exposure Prediction Based on Operational Trends",
  },
  {
    id: "dashboardDataProcessing-6", type: "checkbox",
    label: "🛠️ Automatic Recommendation of Corrective Actions and Improvements",
  },
  {
    id: "dashboardDataProcessing-7", type: "checkbox",
    label: "🌟 ESG Maturity Score Estimation (Internal Company Scoring)",
  },

  // Reporting and Management Features
  {
    id: "dashboardDataProcessing-8", label: "Reporting and Management Features:",
    type: "heading",
  },
  { id: "dashboardDataProcessing-9", type: "checkbox", label: "📊 Live Dashboard Summary for Management" },
  {
    id: "dashboardDataProcessing-10", type: "checkbox",
    label: "📜 Audit Trail and Compliance Document Repository",
  },
  {
    id: "dashboardDataProcessing-11", type: "checkbox",
    label: "🔄 Corrective Action Tracker with Closure Status",
  },
  {
    id: "dashboardDataProcessing-12", type: "checkbox",
    label: "🏢 Multi-Site Aggregated Reporting Consolidation",
  },
  {
    id: "dashboardDataProcessing-13", type: "checkbox",
    label: "📅 Scheduled Dispatch of Reports (Monthly, Quarterly, Yearly)",
  },
];

export const companyActivitySetup = [
  {
    id: "companyActivitySetup-1", type: "text",
    label: "Project/Facility Name",
  },
  {
    id: "companyActivitySetup-2", type: "text",
    label: "Company Name",
  },
  {
    id: "companyActivitySetup-3", type: "dropdown",
    label: "Sector / Industry Type",
    options: ["Industry Sector", "Region / Jurisdiction", "Supplier Type"],
  },

  {
    id: "companyActivitySetup-4", type: "checkbox-group",
    label: "Assessment of ESG Questionnaire Based on:",
    options: ["Industry Sector", "Region / Jurisdiction", "Supplier Type"],
  },

  {
    id: "companyActivitySetup-5", type: "text",
    label: "Country / Province / District",
  },
  {
    id: "companyActivitySetup-6", type: "text",
    label: "Site GPS Location (Optional)",
  },
  {
    id: "companyActivitySetup-7", type: "checkbox-group",
    label: "Ownership Type",
    options: ["Private", "Public", "JV", "PPP"],
  },
  {
    id: "companyActivitySetup-8", type: "checkbox-group",
    label: "Funding Source",
    options: ["Equity", "Debt", "Multilateral", "Other"],
  },
  {
    id: "companyActivitySetup-9", type: "label",
    label: "Activities/Operations",
  },
  {
    id: "companyActivitySetup-10", type: "checkbox-group",
    label: "Operations",
    options: [
      "Construction (Buildings, Roads, Infrastructure)",
      "Manufacturing / Processing Facility",
      "Warehousing / Logistics Operations",
      "Agriculture / Forestry / Aquaculture",
      "Energy Generation / Transmission (Solar, Wind, Hydro, Gas)",
      "Mining and Extraction",
      "Water Extraction / Treatment",
      "Chemical Handling / Storage",
      "Transportation / Shipping Operations",
      "Retail / Office Facility",
      "Other",
    ],
  },
];

export const screeningQuestions = [
  // Screening Questions
  {
    id: "screeningQuestions-1", label: "Screening Questions:",
    type: "heading",
  },
  { id: "screeningQuestions-2", type: "checkbox", label: "🌍 Land acquisition involved?" },
  {
    id: "screeningQuestions-3", type: "checkbox",
    label: "🏞️ Located near protected areas / critical habitats?",
  },
  {
    id: "screeningQuestions-4", type: "checkbox",
    label: "👥 Involves indigenous communities or traditional lands?",
  },
  {
    id: "screeningQuestions-5", type: "checkbox",
    label: "⛏️ Significant earthworks or excavation required?",
  },
  {
    id: "screeningQuestions-6", type: "checkbox",
    label: "💧 High water extraction / discharge activities?",
  },
  { id: "screeningQuestions-7", type: "checkbox", label: "☣️ Hazardous material storage/transportation?" },
  { id: "screeningQuestions-8", type: "checkbox", label: "🏠 Worker accommodations provided on site?" },
  {
    id: "screeningQuestions-9", type: "checkbox",
    label: "🤝 Use of third-party labor suppliers / contractors?",
  },
  {
    id: "screeningQuestions-10", type: "checkbox",
    label: "⚖️ History of environmental fines or labor violations?",
  },
  {
    id: "screeningQuestions-11", type: "checkbox",
    label: "🗣️ Existing stakeholder or community concerns documented?",
  },
];

export const complianceFrameworkActRisk = [
  // Compliance Frameworks (Based on Activities and Risks)
  {
    id: "complianceFrameworkActRisk-1", label: "Compliance Frameworks (Based on Activities and Risks):",
    type: "heading",
  },
  { id: "complianceFrameworkActRisk-2", type: "checkbox", label: "📜 National Environmental and Labor Laws" },
  { id: "complianceFrameworkActRisk-3", type: "checkbox", label: "🌐 IFC Performance Standards (PS 1–8)" },
  { id: "complianceFrameworkActRisk-4", type: "checkbox", label: "🏦 Equator Principles" },
  { id: "complianceFrameworkActRisk-5", type: "checkbox", label: "✅ ISO 14001 (Environment) / ISO 45001 (OHS)" },
  {
    id: "complianceFrameworkActRisk-6", type: "checkbox",
    label: "📊 GRI / SASB Standards (if public disclosure committed)",
  },
  {
    id: "complianceFrameworkActRisk-7", type: "checkbox",
    label: "🇨🇦 Canada CEPA, Fisheries Act, OHSA (Canadian Projects)",
  },
  {
    id: "complianceFrameworkActRisk-8", type: "checkbox",
    label: "💰 Bank/Investor-Specific ESG Requirements (Upload Option)",
  },
];

export const practicalRiskIdentificationEnvi = [
  // Environmental Risks
  {
    id: "practicalRiskIdentificationEnvi-1", label: "Environmental Risks:",
    type: "heading",
  },
  { id: "practicalRiskIdentificationEnvi-2", type: "checkbox", label: "🌬️ Air Emissions (dust, chemicals, GHGs)" },
  {
    id: "practicalRiskIdentificationEnvi-3", type: "checkbox",
    label: "💧 Water Pollution (industrial discharges, waste runoff)",
  },
  { id: "practicalRiskIdentificationEnvi-4", type: "checkbox", label: "🌱 Soil Contamination" },
  {
    id: "practicalRiskIdentificationEnvi-5", type: "checkbox",
    label: "🐾 Biodiversity Disturbance (deforestation, habitat loss)",
  },

  // Social and Labor Risks
  {
    id: "practicalRiskIdentificationEnvi-6", label: "Social and Labor Risks:",
    type: "heading",
  },
  {
    id: "practicalRiskIdentificationEnvi-7", type: "checkbox",
    label: "👷 Labor Conditions (contracts, minimum wages, working hours)",
  },
  {
    id: "practicalRiskIdentificationEnvi-8", type: "checkbox",
    label: "⚠️ OHS Risks (accidents, lack of PPE, unsafe sites)",
  },
  {
    id: "practicalRiskIdentificationEnvi-9", type: "checkbox",
    label: "🗣️ Community Grievances (noise, displacement, road access)",
  },
  {
    id: "practicalRiskIdentificationEnvi-10", type: "checkbox",
    label: "🌍 Indigenous Peoples Impacts (land rights, culture)",
  },

  // Governance Risks
  {
    id: "practicalRiskIdentificationEnvi-11", label: "Governance Risks:",
    type: "heading",
  },
  { id: "practicalRiskIdentificationEnvi-12", type: "checkbox", label: "🚫 No grievance redress mechanism" },
  { id: "practicalRiskIdentificationEnvi-13", type: "checkbox", label: "🔍 No anti-bribery, anti-corruption policies" },

  // Climate Risks
  {
    id: "practicalRiskIdentificationEnvi-14", label: "Climate Risks:",
    type: "heading",
  },
  { id: "practicalRiskIdentificationEnvi-15", type: "checkbox", label: "🌊 Flood / Heat / Drought Vulnerability" },
  { id: "practicalRiskIdentificationEnvi-16", type: "checkbox", label: "🌎 Carbon Emissions/Transition Risk" },
];

export const convertedEnvironmentalActsData = {
  type: "nested-dropdown",
  label: "Environmental Legislative Framework",
  options: [
    {
      id: "practicalRiskIdentificationEnvi-17", value: "act1",
      label: "Canadian Environmental Protection Act (CEPA), 1999",
      subOptions: [
        "Alberta Equivalency Order (SOR/94-752)",
        "Asbestos Mines and Mills Release Regulations (SOR/90-341)",
        "Benzene in Gasoline Regulations (SOR/97-493)",
        "Boards of Review, Rules of Procedure for (SOR/2003-28)",
        "Certain Products Containing Toxic Substances Regulations (SOR/2025-36)",
        "Chromium Electroplating, Chromium Anodizing and Reverse Etching Regulations (SOR/2009-162)",
        "Circumstances for Granting Waivers Pursuant to Section 147 of the Act, Regulations Prescribing (SOR/2010-138)",
        "Clean Electricity Regulations (SOR/2024-263)",
        "Clean Fuel Regulations (SOR/2022-140)",
        "Concentration of Phosphorus in Certain Cleaning Products Regulations (SOR/89-501)",
        "Contaminated Fuel Regulations (SOR/91-486)",
        "Cross-border Movement of Hazardous Waste and Hazardous Recyclable Material Regulations (SOR/2021-25)",
        "Disposal at Sea Permit Application Regulations (SOR/2014-177)",
        "Disposal at Sea Regulations (SOR/2001-275)",
        "Environmental Emergency Regulations, 2019 (SOR/2019-51)",
        "Export of Substances on the Export Control List Regulations (SOR/2013-88)",
        "Federal Halocarbon Regulations, 2022 (SOR/2022-110)",
        "Formaldehyde Emissions from Composite Wood Products Regulations (SOR/2021-148)",
        "Fuels Information Regulations, No. 1 (C.R.C., c. 407)",
        "Gasoline and Gasoline Blend Dispensing Flow Rate Regulations (SOR/2000-43)",
        "Gasoline Regulations (SOR/90-247)",
        "Heavy-duty Vehicle and Engine Greenhouse Gas Emission Regulations (SOR/2013-24)",
        "Marine Spark-Ignition Engine, Vessel and Off-road Recreational Vehicle Emission Regulations (SOR/2011-10)",
        "Masked Name Regulations (SOR/94-261)",
        "Microbeads in Toiletries Regulations (SOR/2017-111)",
        "Multi-Sector Air Pollutants Regulations (SOR/2016-151)",
        "New Substances Fees Regulations (SOR/2002-374)",
        "New Substances Notification Regulations (Chemicals and Polymers) (SOR/2005-247)",
        "New Substances Notification Regulations (Organisms) (SOR/2005-248)",
        "Off-road Compression-Ignition (Mobile and Stationary) and Large Spark-Ignition Engine Emission Regulations (SOR/2020-258)",
        "Off-Road Small Spark-Ignition Engine Emission Regulations (SOR/2003-355)",
        "On-Road Vehicle and Engine Emission Regulations (SOR/2003-2)",
        "Order Declaring that the Reduction of Carbon Dioxide Emissions from Coal-fired Generation of Electricity Regulations Do Not Apply in Saskatchewan, 2025 (SOR/2024-269)",
        "Ozone-depleting Substances and Halocarbon Alternatives Regulations (SOR/2016-137)",
        "Passenger Automobile and Light Truck Greenhouse Gas Emission Regulations (SOR/2010-201)",
        "PCB Regulations (SOR/2008-273)",
        "Persistence and Bioaccumulation Regulations (SOR/2000-107)",
        "Products Containing Mercury Regulations (SOR/2014-254)",
        "Prohibition of Asbestos and Products Containing Asbestos Regulations (SOR/2018-196)",
        "Prohibition of Certain Toxic Substances Regulations, 2012 (SOR/2012-285)",
        "Prohibition of the Manufacture and Importation of Wheel Weights Containing Lead Regulations (SOR/2023-15)",
        "Provisions of the Regulations Respecting Reduction in the Release of Methane and Certain Volatile Organic Compounds (Upstream Oil and Gas Sector) Do Not Apply in Alberta, Order Declaring that the (SOR/2020-233)",
        "Pulp and Paper Mill Defoamer and Wood Chip Regulations (SOR/92-268)",
        "Pulp and Paper Mill Effluent Chlorinated Dioxins and Furans Regulations (SOR/92-267)",
        "Reduction in the Release of Methane and Certain Volatile Organic Compounds (Upstream Oil and Gas Sector), Regulations Respecting (SOR/2018-66)",
        "Reduction in the Release of Volatile Organic Compounds (Storage and Loading of Volatile Petroleum Liquids) Regulations (SOR/2025-88)",
        "Reduction in the Release of Volatile Organic Compounds Regulations (Petroleum Sector) (SOR/2020-231)",
        "Reduction of Carbon Dioxide Emissions From Coal-Fired Generation of Electricity Regulations (SOR/2012-167)",
        "Reduction of Carbon Dioxide Emissions from Coal-fired Generation of Electricity Regulations Do Not Apply in Nova Scotia, Order Declaring that the (SOR/2014-265)",
        "Regulations Limiting Carbon Dioxide Emissions from Natural Gas-fired Generation of Electricity (SOR/2018-261)",
        "Regulations Respecting Reduction in the Release of Methane and Certain Volatile Organic Compounds (Upstream Oil and Gas Sector) Do Not Apply in British Columbia, 2025, Order Declaring that the (SOR/2025-37)",
        "Regulatory Provisions for Purposes of Enforcement (Canadian Environmental Protection Act, 1999), Regulations Designating (SOR/2012-134)",
        "Release and Environmental Emergency Notification Regulations (SOR/2011-90)",
        "Secondary Lead Smelter Release Regulations (SOR/91-155)",
        "Single-use Plastics Prohibition Regulations (SOR/2022-138)",
        "Solvent Degreasing Regulations (SOR/2003-283)",
        "Storage Tank Systems for Petroleum Products and Allied Petroleum Products Regulations (SOR/2008-197)",
        "Sulphur in Diesel Fuel Regulations (SOR/2002-254)",
        "Sulphur in Gasoline Regulations (SOR/99-236)",
        "Tetrachloroethylene (Use in Dry Cleaning and Reporting Requirements) Regulations (SOR/2003-79)",
        "Tributyltetradecylphosphonium Chloride Regulations (SOR/2000-66)",
        "Virtual Elimination List (SOR/2006-298)",
        "Volatile Organic Compound (VOC) Concentration Limits for Architectural Coatings Regulations (SOR/2009-264)",
        "Volatile Organic Compound (VOC) Concentration Limits for Automotive Refinishing Products Regulations (SOR/2009-197)",
        "Volatile Organic Compound Concentration Limits for Certain Products Regulations (SOR/2021-268)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-18", value: "act2",
      label: "Canadian Environmental Assessment Act, 2012",
      subOptions: [
        "Cost Recovery Regulations (SOR/2012-146)",
        "Physical Activities, Regulations Designating (SOR/2012-147)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-19", value: "act3",
      label: "Impact Assessment Act (IAA), 2019",
      subOptions: [
        "Cross-border Movement of Hazardous Waste and Hazardous Recyclable Material Regulations (SOR/2021-25)",
        "Information and Management of Time Limits Regulations (SOR/2019-283)",
        "Order Designating Certain Excluded Classes of Projects (SOR/2025-60)",
        "Physical Activities Regulations (SOR/2019-285)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-20", value: "act4",
      label: "Fisheries Act, R.S.C. 1985",
      subOptions: [
        "Aboriginal Communal Fishing Licences Regulations (SOR/93-332)",
        "Alberta Fishery Regulations, 1998 (SOR/98-246)",
        "Aquaculture Activities Regulations (SOR/2015-177)",
        "Aquatic Invasive Species Regulations (SOR/2015-121)",
        "Atlantic Fishery Regulations, 1985 (SOR/86-21)",
        "Authorizations Concerning Fish and Fish Habitat Protection Regulations (SOR/2019-286)",
        "Ballast Water Regulations (SOR/2021-120)",
        "British Columbia Sport Fishing Regulations, 1996 (SOR/96-137)",
        "Conditions for Making Regulations Under Subsection 36(5.2) of the Fisheries Act, Regulations Establishing (SOR/2014-91)",
        "Deposit Out of the Normal Course of Events Notification Regulations (SOR/2011-91)",
        "Dogfish Exemption Notice (C.R.C., c. 836)",
        "Experimental Lakes Area Research Activities Regulations (SOR/2014-95)",
        "Fish Toxicant Regulations (SOR/88-258)",
        "Fishery (General) Regulations (SOR/93-53)",
        "Foreign Vessel Fishing Regulations (C.R.C., c. 815)",
        "Management of Contaminated Fisheries Regulations (SOR/90-351)",
        "Manitoba Fishery Regulations, 1987 (SOR/87-509)",
        "Marine Mammal Regulations (SOR/93-56)",
        "Maritime Provinces Fishery Regulations (SOR/93-55)",
        "Meat and Poultry Products Plant Liquid Effluent Regulations (C.R.C., c. 818)",
        "Metal and Diamond Mining Effluent Regulations (SOR/2002-222)",
        "Newfoundland and Labrador Fishery Regulations (SOR/78-443)",
        "Northwest Territories Fishery Regulations (C.R.C., c. 847)",
        "Ontario Fishery Regulations, 1989 (SOR/89-93)",
        "Ontario Fishery Regulations, 2007 (SOR/2007-237)",
        "Order Declaring that the Wastewater Systems Effluent Regulations Do Not Apply in Quebec (SOR/2018-194)",
        "Order Designating the Minister of the Environment as the Minister Responsible for the Administration and Enforcement of Subsections 36(3) to (6) of the Fisheries Act (SI/2014-21)",
        "Pacific Aquaculture Regulations (SOR/2010-270)",
        "Pacific Fishery Management Area Regulations, 2007 (SOR/2007-77)",
        "Pacific Fishery Regulations, 1993 (SOR/93-54)",
        "Pacific Hake Exemption Notice (SOR/86-750)",
        "Petroleum Refinery Liquid Effluent Regulations (C.R.C., c. 828)",
        "Possession and Export of Elvers Regulations (SOR/2024-237)",
        "Potato Processing Plant Liquid Effluent Regulations (C.R.C., c. 829)",
        "Pulp and Paper Effluent Regulations (SOR/92-269)",
        "Quebec Fishery Regulations, 1990 (SOR/90-214)",
        "Roe Herring Exemption Notice (C.R.C., c. 837)",
        "Saskatchewan Fishery Regulations, 1995 (SOR/95-233)",
        "Wastewater Systems Effluent Regulations (SOR/2012-139)",
        "Wastewater Systems Effluent Regulations Do Not Apply in Yukon, Order Declaring that the (SOR/2014-279)",
        "Yukon Territory Fishery Regulations (C.R.C., c. 854)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-21", value: "act5",
      label: "Species at Risk Act (SARA), 2002",
      subOptions: [
        "Critical Habitat of Atlantic Whitefish (Coregonus huntsmani) Order (SOR/2018-182)",
        "Critical Habitat of Carmine Shiner (Notropis percobromus) Order (SOR/2018-183)",
        "Critical Habitat of the Atlantic Mud-piddock (Barnea truncata) Order (SOR/2023-221)",
        "Critical Habitat of the Atlantic Salmon (Salmo salar) Inner Bay of Fundy Population Order (SOR/2019-322)",
        "Critical Habitat of the Barrens Willow (Salix jejuna) Order (SOR/2019-236)",
        "Critical Habitat of the Beluga Whale (Delphinapterus leucas) St. Lawrence Estuary Population Order (SOR/2017-263)",
        "Critical Habitat of the Black Redhorse (Moxostoma duquesnei) Order (SOR/2022-235)",
        "Critical Habitat of the Bull Trout (Salvelinus confluentus) Saskatchewan-Nelson Rivers Populations Order (SOR/2021-31)",
        "Critical Habitat of the Cerulean Warbler (Setophaga cerulea) Order (SOR/2022-97)",
        "Critical Habitat of the Coastrange Sculpin (Cottus aleuticus) Cultus Population Order (SOR/2019-3)",
        "Critical Habitat of the Copper Redhorse (Moxostoma hubbsi) Order (SOR/2021-95)",
        "Critical Habitat of the Eastern Sand Darter (Ammocrypta pellucida) Ontario Populations Order (SOR/2017-265)",
        "Critical Habitat of the Eastern Sand Darter (Ammocrypta pellucida) Quebec Populations Order (SOR/2018-159)",
        "Critical Habitat of the Fawnsfoot (Truncilla donaciformis) Order (SOR/2022-216)",
        "Critical Habitat of the Fernald’s Braya (Braya fernaldii) Order (SOR/2021-12)",
        "Critical Habitat of the Gattinger’s Agalinis (Agalinis gattingeri) Order (SOR/2022-4)",
        "Critical Habitat of the Harbour Seal Lacs des Loups Marins subspecies (Phoca vitulina mellonae) Order (SOR/2018-268)",
        "Critical Habitat of the Hotwater Physa (Physella wrighti) Order (SOR/2019-21)",
        "Critical Habitat of the Kidneyshell (Ptychobranchus fasciolaris) Order (SOR/2019-309)",
        "Critical Habitat of the Killer Whale (Orcinus orca) Northeast Pacific Northern Resident Population Order (SOR/2018-279)",
        "Critical Habitat of the Killer Whale (Orcinus orca) Northeast Pacific Southern Resident Population Order (SOR/2018-278)",
        "Critical Habitat of the Lake Chubsucker (Erimyzon sucetta) Order (SOR/2018-156)",
        "Critical Habitat of the Lilliput (Toxolasma parvum) Order (SOR/2022-215)",
        "Critical Habitat of the Misty Lake Lentic Threespine Stickleback (Gasterosteus aculeatus) Order (SOR/2018-208)",
        "Critical Habitat of the Misty Lake Lotic Threespine Stickleback (Gasterosteus aculeatus) Order (SOR/2018-209)",
        "Critical Habitat of the Nooksack Dace (Rhinichthys cataractae ssp.) Order (SOR/2016-82)",
        "Critical Habitat of the North Atlantic Right Whale (Eubalaena glacialis) Order (SOR/2017-262)",
        "Critical Habitat of the Northern Abalone (Haliotis kamtschatkana) Order (SOR/2017-266)",
        "Critical Habitat of the Northern Bottlenose Whale (Hyperoodon ampullatus) Scotian Shelf Population Order (SOR/2018-157)",
        "Critical Habitat of the Northern Madtom (Noturus stigmosus) Order (SOR/2016-81)",
        "Critical Habitat of the Northern Riffleshell (Epioblasma torulosa rangiana) Order (SOR/2019-327)",
        "Critical Habitat of the Northern Wolffish (Anarhichas denticulatus) Order (SOR/2020-185)",
        "Critical Habitat of the Paxton Lake Benthic Threespine Stickleback (Gasterosteus aculeatus) Order (SOR/2020-25)",
        "Critical Habitat of the Paxton Lake Limnetic Threespine Stickleback (Gasterosteus aculeatus) Order (SOR/2020-26)",
        "Critical Habitat of the Pugnose Minnow (Opsopoeodus emiliae) Order (SOR/2022-236)",
        "Critical Habitat of the Pugnose Shiner (Notropis anogenus) Order (SOR/2019-326)",
        "Critical Habitat of the Rainbow Smelt (Osmerus mordax) Lake Utopia Small-Bodied Population Order (SOR/2019-310)",
        "Critical Habitat of the Rainbow Trout (Oncorhynchus mykiss) Athabasca River Populations Order (SOR/2021-32)",
        "Critical Habitat of the Rayed Bean (Villosa fabalis) Order (SOR/2019-330)",
        "Critical Habitat of the Redside Dace (Clinostomus elongatus) Order (SOR/2025-4)",
        "Critical Habitat of the Rocky Mountain Sculpin (Cottus sp.) Eastslope Populations Order (SOR/2017-267)",
        "Critical Habitat of the Roseate Tern (Sterna dougallii) Order (SOR/2016-281)",
        "Critical Habitat of the Round Hickorynut (Obovaria subrotunda) Order (SOR/2019-308)",
        "Critical Habitat of the Round Pigtoe (Pleurobema sintoxia) Order (SOR/2019-328)",
        "Critical Habitat of the Salamander Mussel (Simpsonaias ambigua) Order (SOR/2019-331)",
        "Critical Habitat of the Salish Sucker (Catostomus catostomus ssp.) Order (SOR/2019-274)",
        "Critical Habitat of the Silver Shiner (Notropis photogenis) Order (SOR/2023-39)",
        "Critical Habitat of the Snuffbox (Epioblasma triquetra) Order (SOR/2019-329)",
        "Critical Habitat of the Speckled Dace (Rhinichthys osculus) Order (SOR/2018-218)",
        "Critical Habitat of the Spotted Gar (Lepisosteus oculatus) Order (SOR/2024-195)",
        "Critical Habitat of the Spotted Wolffish (Anarhichas minor) Order (SOR/2020-186)",
        "Critical Habitat of the Spring Cisco (Coregonus sp.) Order (SOR/2018-158)",
        "Critical Habitat of the Striped Bass (Morone saxatilis) St. Lawrence River Population Order (SOR/2022-2)",
        "Critical Habitat of the Threehorn Wartyback (Obliquaria reflexa) Order (SOR/2022-217)",
        "Critical Habitat of the Vananda Creek Benthic Threespine Stickleback (Gasterosteus aculeatus) Order (SOR/2020-27)",
        "Critical Habitat of the Vananda Creek Limnetic Threespine Stickleback (Gasterosteus aculeatus) Order (SOR/2020-28)",
        "Critical Habitat of the Vancouver Lamprey (Entosphenus macrostomus) Order (SOR/2020-29)",
        "Critical Habitat of the Western Brook Lamprey (Lampetra richardsoni) Morrison Creek Population Order (SOR/2019-123)",
        "Critical Habitat of the Western Chorus Frog (Pseudacris triseriata) Great Lakes / St. Lawrence – Canadian Shield Population Order (SOR/2018-169)",
        "Critical Habitat of the Western Silvery Minnow (Hybognathus argyritis) Order (SOR/2019-2)",
        "Critical Habitat of the Westslope Cutthroat Trout (Oncorhynchus clarkii lewisi) Alberta Population Order (SOR/2015-241)",
        "Critical Habitat of the White Sturgeon (Acipenser transmontanus) Kootenay River Population Order (SOR/2016-86)",
        "Critical Habitat of the White Sturgeon (Acipenser transmontanus) Nechako River Population Order (SOR/2024-21)",
        "Critical Habitat of the White Sturgeon (Acipenser transmontanus) Upper Columbia River Population Order (SOR/2016-85)",
        "Critical Habitat of the White Sturgeon (Acipenser transmontanus) Upper Fraser River Population Order (SOR/2016-83)",
        "Critical Habitat of the Woodland Caribou (Rangifer tarandus caribou) Boreal Population Order (SOR/2019-188)",
        "Decisions not to add Certain Species to the List of Endangered Species, Order Giving Notice of (SI/2006-110)",
        "Emergency Order for the Protection of the Greater Sage-Grouse (SOR/2013-202)",
        "Emergency Order for the Protection of the Western Chorus Frog (Great Lakes / St. Lawrence — Canadian Shield Population) (SOR/2016-211)",
        "Emergency Order for the Protection of the Western Chorus Frog Great Lakes / St. Lawrence — Canadian Shield Population (Longueuil) (SOR/2021-231)",
        "Exemption Order for Certain Licences, Authorizations and Documents (Bull Trout (Saskatchewan-Nelson Rivers Populations)) (SOR/2019-288)",
        "Exemption Order for Certain Licences, Authorizations and Documents (Rainbow Trout (Athabasca River Populations)) (SOR/2019-289)",
        "Exemption Order for Certain Licences, Authorizations and Documents (Westslope Cutthroat Trout (Alberta Population)) (SOR/2013-35)",
        "Exemption Order for Certain Licences, Authorizations and Documents (White Sturgeon) (SOR/2006-190)",
        "Extending the Time for the Assessment of the Status of Wildlife Species, Order (SOR/2006-115)",
        "Extending the Time for the Assessment of the Status of Wildlife Species, Order (SOR/2003-215)",
        "List of Wildlife Species at Risk (Decision Not To Add or Referral Back to COSEWIC) Order (SI/2009-20)",
        "List of Wildlife Species at Risk (Decisions Not to Add Certain Species) Order (SI/2019-66)",
        "List of Wildlife Species at Risk (Decisions Not to Add Certain Species) Order (SI/2012-45)",
        "List of Wildlife Species at Risk (Decisions Not to Add Certain Species) Order (SI/2010-14)",
        "List of Wildlife Species at Risk (Decisions Not to Add Certain Species) Order (SI/2017-24)",
        "List of Wildlife Species at Risk (Decisions Not to Add Certain Species) Order (SI/2013-27)",
        "List of Wildlife Species at Risk (referral back to COSEWIC) Order (SI/2018-17)",
        "List of Wildlife Species at Risk (referral back to COSEWIC) Order (SI/2021-58)",
        "List of Wildlife Species at Risk (referral back to COSEWIC) Order (SI/2017-29)",
        "List of Wildlife Species at Risk (referral back to COSEWIC) Order (SI/2021-33)",
        "List of Wildlife Species at Risk (referral back to COSEWIC) Order (SI/2022-7)",
        "List of Wildlife Species at Risk (referral back to COSEWIC) Order (SI/2019-13)",
        "List of Wildlife Species at Risk (referral back to COSEWIC) Order (SI/2013-28)",
        "Order Acknowledging Receipt of the Assessment Done Pursuant to Subsection 23(1) of the Act (SI/2005-115)",
        "Order Acknowledging Receipt of the Assessment Done Pursuant to Subsection 23(1) of the Act (SI/2021-32)",
        "Order Acknowledging Receipt of the Assessment Done Pursuant to Subsection 23(1) of the Act (SI/2023-66)",
        "Order Acknowledging Receipt of the Assessment Done Pursuant to Subsection 23(1) of the Act (SI/2011-11)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2022-27)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2017-30)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2008-70)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2010-76)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2016-55)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2017-72)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2020-12)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2016-49)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2007-57)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2005-71)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2019-12)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2016-31)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2004-138)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2010-42)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2012-46)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2018-112)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2017-17)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2020-61)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2022-26)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2022-6)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2018-40)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2021-6)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Species at Risk Act (SI/2004-48)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 28(1) of the Act (SI/2019-72)",
        "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2011-91)",
        "Order Acknowledging Receipt of the Assessments Done Under Subsection 23(1) of the Act (SI/2023-13)",
        "Order Acknowledging Receipt of the Assessments Done Under Subsection 23(1) of the Species at Risk Act (Certain Wildlife Species of Red Knot and Four Other Wildlife Species) (SI/2024-65)",
        "Order Acknowledging Receipt of the Assessments Done Under Subsection 23(1) of the Species at Risk Act (Chestnut-collared Longspur and Nine Other Wildlife Species) (SI/2023-75)",
        "Order Declining to make an Emergency Order for the protection of the Killer Whale Northeast Pacific Southern Resident Population (SI/2018-102)",
        "Order Giving Notice of Decisions not to add Certain Species to the List of Endangered Species (SI/2007-115)",
        "Order Giving Notice of Decisions not to add Certain Species to the List of Endangered Species (SI/2005-72)",
        "Order Giving Notice of Decisions not to add Certain Species to the List of Endangered Species (SI/2005-2)",
        "Order Giving Notice of Decisions not to add Certain Species to the List of Endangered Species (SI/2006-61)",
        "Order Giving Notice of Decisions Not to Add Certain Species to the List of Endangered Species (SI/2011-56)",
        "Permits Authorizing an Activity Affecting Listed Wildlife Species Regulations (SOR/2013-140)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-22", value: "act6",
      label: "Migratory Birds Convention Act, 1994",
      subOptions: [
        "Designation of Regulatory Provisions for Purposes of Enforcement (Migratory Birds Convention Act, 1994) Regulations (SOR/2017-108)",
        "Migratory Bird Sanctuary Regulations (C.R.C., c. 1036)",
        "Migratory Birds Regulations, 2022 (SOR/2022-105)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-23", value: "act7",
      label: "Canada Wildlife Act, 1985",
      subOptions: [
        "Assigning the Administration, Management and Control of Certain Lands from the Minister of Indian Affairs and Northern Development to the Minister of the Environment (SI/86-150)",
        "Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands (SI/85-142)",
        "Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands (SI/82-30)",
        "Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands (SI/80-114)",
        "Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands (SI/81-90)",
        "Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands (SI/80-129)",
        "Assigning to the Minister of the Environment, the Administration, Management and Control of Certain Public Lands (SI/84-62)",
        "Assigning to the Minister of the Environment, the Administration, Management and Control of Certain Public Lands (SI/82-197)",
        "Assigning to the Minister of the Environment, the Administration, Management and Control of Certain Public Lands (SI/85-37)",
        "Assigning to the Minister of the Environment, the Administration, Management and Control of Certain Public Lands (SI/84-77)",
        "Designation of Regulatory Provisions for Purposes of Enforcement (Canada Wildlife Act) Regulations (SOR/2017-107)",
        "Order Assigning to the Minister of the Environment the Administration of Certain Public Lands (SI/95-56)",
        "Order Assigning to the Minister of the Environment the Administration of Certain Public Lands (SI/98-103)",
        "Order Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands (SI/88-138)",
        "Order Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands (SI/89-151)",
        "Order Assigning to the Minister of the Environment, the Administration of Certain Public Lands (SI/95-42)",
        "Order Assigning to the Minister of the Environment, the Administration, Management and Control of Certain Public Lands (SI/92-107)",
        "Order Authorizing the Minister of the Environment to Exercise, with the Concurrence of the Minister of National Defence, the Administration of Certain Public Lands (SI/2003-93)",
        "Scott Islands Protected Marine Area Establishment Order (SI/2018-44)",
        "Scott Islands Protected Marine Area Regulations (SOR/2018-119)",
        "Wildlife Area Regulations (C.R.C., c. 1609)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-24", value: "act8",
      label: "Canada National Parks Act, 2000",
      subOptions: [
        "Boundaries of the Town of Banff in Banff National Park and Adding a Description of the Boundaries as Schedule IV to the Act, Order Fixing the (SOR/90-45)",
        "Gros Morne National Park of Canada Snowshoe Hare Regulations (SOR/2005-205)",
        "Gros Morne National Park of Canada Timber Harvesting Regulations (SOR/2005-204)",
        "Gwaii Haanas National Park Reserve Order (SOR/96-93)",
        "Migratory Birds Regulations, 2022 (SOR/2022-105)",
        "Mingan Archipelago National Park Reserve of Canada Snowshoe Hare Regulations (SOR/2004-301)",
        "National Historic Parks General Regulations (SOR/82-263)",
        "National Historic Parks Wildlife and Domestic Animals Regulations (SOR/81-613)",
        "National Historic Sites of Canada Order (C.R.C., c. 1112)",
        "National Parks Cemetery Regulations (SOR/83-677)",
        "National Parks General Regulations (SOR/78-213)",
        "National Parks Highway Traffic Regulations (C.R.C., c. 1126)",
        "National Parks of Canada Aircraft Access Regulations (SOR/97-150)",
        "National Parks of Canada Businesses Regulations (SOR/98-455)",
        "National Parks of Canada Camping Regulations (SOR/80-127)",
        "National Parks of Canada Domestic Animals Regulations (SOR/98-177)",
        "National Parks of Canada Fire Protection Regulations (SOR/80-946)",
        "National Parks of Canada Fishing Regulations (C.R.C., c. 1120)",
        "National Parks of Canada Garbage Regulations (SOR/80-217)",
        "National Parks of Canada Land Use Planning Regulations (SOR/2024-230)",
        "National Parks of Canada Lease and Licence of Occupation Regulations (SOR/92-25)",
        "National Parks of Canada Water and Sewer Regulations (C.R.C., c. 1134)",
        "National Parks of Canada Wilderness Area Declaration Regulations (SOR/2000-387)",
        "National Parks Town, Visitor Centre and Resort Subdivision Designation Regulations (SOR/91-8)",
        "National Parks Wildlife Regulations (SOR/81-401)",
        "Wapusk National Park of Canada Park Use Regulations (SOR/2010-67)",
        "Wood Buffalo National Park Game Regulations (SOR/78-830)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-25", value: "act9",
      label: "Canada Water Act, R.S.C. 1985",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-26", value: "act10",
      label: "Arctic Waters Pollution Prevention Act, 1985",
      subOptions: [
        "Arctic Shipping Pollution Prevention Regulations (C.R.C., c. 353)",
        "Arctic Waters Experimental Pollution Regulations, 1978 (SOR/78-417)",
        "Arctic Waters Experimental Pollution Regulations, 1979 (SOR/80-9)",
        "Arctic Waters Experimental Pollution Regulations, 1982 (Dome Petroleum) (SOR/82-276)",
        "Arctic Waters Experimental Pollution Regulations, 1982 (Dome Petroleum) (SOR/82-832)",
        "Arctic Waters Pollution Prevention Regulations (C.R.C., c. 354)",
        "Charts and Nautical Publications Regulations, 1995 (SOR/95-149)",
        "Governor in Council Authority Delegation Order (C.R.C., c. 355)",
        "Navigation Safety Regulations (SOR/2005-134)",
        "Ship Station (Radio) Regulations, 1999 (SOR/2000-260)",
        "Shipping Safety Control Zones Order (C.R.C., c. 356)",
        "Steering Appliances and Equipment Regulations (SOR/83-810)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-27", value: "act11",
      label: "Transportation of Dangerous Goods Act, 1992",
      subOptions: [
        "Transportation of Dangerous Goods by Rail Security Regulations (SOR/2019-113)",
        "Transportation of Dangerous Goods Regulations (SOR/2001-286)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-28", value: "act12",
      label: "Pest Control Products Act, 2002",
      subOptions: [
        "Biocides Regulations [Not in force] (SOR/2024-110)",
        "List of Pest Control Product Formulants and Contaminants of Health or Environmental Concern (SI/2005-114)",
        "Pest Control Products Fees and Charges Regulations (SOR/2017-9)",
        "Pest Control Products Incident Reporting Regulations (SOR/2006-260)",
        "Pest Control Products Regulations (SOR/2006-124)",
        "Pest Control Products Sales Information Reporting Regulations (SOR/2006-261)",
        "Review Panel Regulations (SOR/2008-22)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-29", value: "act13",
      label: "Nuclear Safety and Control Act, 1997",
      subOptions: [
        "Administrative Monetary Penalties Regulations (Canadian Nuclear Safety Commission) (SOR/2013-139)",
        "Canadian Nuclear Safety Commission By-laws (SOR/2000-212)",
        "Canadian Nuclear Safety Commission Cost Recovery Fees Regulations (SOR/2003-212)",
        "Canadian Nuclear Safety Commission Rules of Procedure (SOR/2000-211)",
        "Class I Nuclear Facilities Regulations (SOR/2000-204)",
        "Class II Nuclear Facilities and Prescribed Equipment Regulations (SOR/2000-205)",
        "Directive to the Canadian Nuclear Safety Commission Regarding the Health of Canadians (SOR/2007-282)",
        "General Nuclear Safety and Control Regulations (SOR/2000-202)",
        "Nuclear Non-proliferation Import and Export Control Regulations (SOR/2000-210)",
        "Nuclear Security Regulations (SOR/2000-209)",
        "Nuclear Substances and Radiation Devices Regulations (SOR/2000-207)",
        "Packaging and Transport of Nuclear Substances Regulations, 2015 (SOR/2015-145)",
        "Radiation Protection Regulations (SOR/2000-203)",
        "Uranium Mines and Mills Regulations (SOR/2000-206)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-30", value: "act14",
      label: "Greenhouse Gas Pollution Pricing Act, 2018",
      subOptions: [
        "Canadian Greenhouse Gas Offset Credit System Regulations (SOR/2022-111)",
        "Fuel Charge Regulations (2018, c. 12, s. 187)",
        "Output-Based Pricing System Regulations (SOR/2019-266)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-31", value: "act15",
      label: "Federal Sustainable Development Act, 2008",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-32", value: "act16",
      label: "Canadian Navigable Waters Act, R.S.C. 1985",
      subOptions: [
        "Canadian Navigable Waters Act Fees Regulations (SOR/2024-148)",
        "Ferry Cable Regulations (SOR/86-1026)",
        "Major Works Order (SOR/2019-320)",
        "Minor Works Order (SOR/2021-170)",
        "Navigable Waters Bridges Regulations (C.R.C., c. 1231)",
        "Navigable Waters Works Regulations (C.R.C., c. 1232)",
        "Order Exempting Certain Navigable Waters Located in Quebec from the Application of Section 23 of the Canadian Navigable Waters Act (SOR/2023-213)",
        "Order Exempting Kapisikama Lake, Located in Quebec, from the Application of Section 23 of the Canadian Navigable Waters Act (SOR/2024-102)",
        "Proclamation Exempting the Mink Arm portion of South McMahon Lake from the Operation of Section 22 of the Act (SOR/2013-141)",
        "Proclamation Exempting the Waters of Lake Pignac and Lake B from the Operation of Section 22 of the Act (SOR/2013-142)",
        "Proclamation Exempting the Waters of Sandy Pond from the Operation of Section 22 of the Navigable Waters Protection Act (SOR/2009-202)",
        "Proclamation Exempting Tom MacKay Lake from the Operation of Section 22 of the Act (SOR/2005-226)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-33", value: "act17",
      label: "Oceans Act, S.C. 1996",
      subOptions: [
        "Anguniaqvia niqiqyuam Marine Protected Areas Regulations (SOR/2016-280)",
        "Banc-des-Américains Marine Protected Area Regulations (SOR/2019-50)",
        "Basin Head Marine Protected Area Regulations (SOR/2005-293)",
        "Bowie Seamount Marine Protected Area Regulations (SOR/2008-124)",
        "Certain Marine Carriers Remission Order, 2011 (SI/2011-66)",
        "Confederation Bridge Area Provincial (P.E.I.) Laws Application Regulations (SOR/97-375)",
        "Eastport Marine Protected Areas Regulations (SOR/2005-294)",
        "Fishing Zones of Canada (Zone 6) Order (C.R.C., c. 1549)",
        "Fishing Zones of Canada (Zones 1, 2 and 3) Order (C.R.C., c. 1547)",
        "Fishing Zones of Canada (Zones 4 and 5) Order (C.R.C., c. 1548)",
        "Gilbert Bay Marine Protected Area Regulations (SOR/2005-295)",
        "Gully Marine Protected Area Regulations (SOR/2004-112)",
        "Hecate Strait and Queen Charlotte Sound Glass Sponge Reefs Marine Protected Areas Regulations (SOR/2017-15)",
        "Laurentian Channel Marine Protected Area Regulations (SOR/2019-105)",
        "Musquash Estuary Marine Protected Area Regulations (SOR/2006-354)",
        "Order No. 2 Designating the Tuvaijuittuq Marine Protected Area (SOR/2024-165)",
        "St. Anns Bank Marine Protected Area Regulations (SOR/2017-106)",
        "Tang.ɢwan — ḥačxʷiqak — Tsigis Marine Protected Area Regulations (SOR/2024-122)",
        "Tarium Niryutait Marine Protected Areas Regulations (SOR/2010-190)",
        "Territorial Sea Geographical Coordinates (Area 7) Order (SOR/85-872)",
        "Territorial Sea Geographical Coordinates Order (C.R.C., c. 1550)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-34", value: "act18",
      label: "Hazardous Products Act, 1985",
      subOptions: [
        "Children’s Jewellery Regulations [Repealed] (SOR/2005-132)",
        "Controlled Products Regulations [Repealed] (SOR/88-66)",
        "Cribs and Cradles Regulations [Repealed] (SOR/86-962)",
        "Hazardous Products (Booster Cushions) Regulations [Repealed] (SOR/89-446)",
        "Hazardous Products (Child Restraint Systems) Regulations [Repealed] (SOR/88-151)",
        "Hazardous Products (Children’s Sleepwear) Regulations [Repealed] (SOR/87-443)",
        "Hazardous Products (Crocidolite Asbestos) Regulations [Repealed] (SOR/89-440)",
        "Hazardous Products (Lighters) Regulations [Repealed] (SOR/89-514)",
        "Hazardous Products (Toys) Regulations [Repealed] (C.R.C., c. 931)",
        "Ingredient Disclosure List [Repealed] (SOR/88-64)",
        "Safety Glass Regulations [Repealed] (C.R.C., c. 933)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-35", value: "act19",
      label:
        "Environmental Violations Administrative Monetary Penalties Act, 2009",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-36", value: "act20",
      label:
        "Canada Foundation for Sustainable Development Technology Act, 2001",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-37", value: "act21",
      label: "Federal Sustainable Development Strategy (FSDS) 2022–2026",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-38", value: "act22",
      label: "Canada Oil and Gas Operations Act, 1985",
      subOptions: [
        "Canada Oil and Gas Certificate of Fitness Regulations (SOR/96-114)",
        "Canada Oil and Gas Diving Regulations (SOR/88-600)",
        "Canada Oil and Gas Drilling and Production Regulations (SOR/2009-315)",
        "Canada Oil and Gas Geophysical Operations Regulations (SOR/96-117)",
        "Canada Oil and Gas Installations Regulations (SOR/96-118)",
        "Canada Oil and Gas Operations Administrative Monetary Penalties Regulations (SOR/2016-25)",
        "Canada Oil and Gas Operations Financial Requirements Regulations (SOR/2016-26)",
        "Canada Oil and Gas Operations Regulations (SOR/83-149)",
        "List of Spill-treating Agents (Canada Oil and Gas Operations Act), Regulations Establishing a (SOR/2016-108)",
        "Navigation Safety Regulations, 2020 (SOR/2020-216)",
        "Oil and Gas Spills and Debris Liability Regulations (SOR/87-331)",
        "Polar Bear Pass Withdrawal Order (SOR/84-409)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-39", value: "act23",
      label: "Explosives Act, 1985",
      subOptions: ["Explosives Regulations, 2013 (SOR/2013-211)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-40", value: "act24",
      label: "Marine Liability Act, 2001",
      subOptions: [
        "Compulsory Insurance for Ships Carrying Passengers, Regulations Respecting (SOR/2018-245)",
        "Marine Liability and Information Return Regulations (SOR/2016-307)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-41", value: "act25",
      label: "Safe Drinking Water for First Nations Act, 2013",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-42", value: "act26",
      label: "Energy Efficiency Act, 1992",
      subOptions: ["Energy Efficiency Regulations, 2016 (SOR/2016-311)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-43", value: "act27",
      label: "Canadian Energy Regulator Act, 2019",
      subOptions: [
        "Canada Offshore Renewable Energy Regulations (SOR/2024-272)",
        "Circumstances for Excluding Periods from Time Limits Regulations (SOR/2019-348)",
        "International and Interprovincial Power Line Damage Prevention Regulations – Obligations of Holders of Permits and Certificates (SOR/2020-49)",
        "International and Interprovincial Power Line Damage Prevention Regulations — Authorizations (SOR/2019-347)",
        "Order Designating the Minister of Natural Resources, a member of the Queen’s Privy Council for Canada, as the Minister for the purposes of the two Acts (SI/2019-65)",
        "Regulations Amending the Pipeline Financial Requirements Regulations (SOR/2021-134)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-44", value: "act28",
      label: "Canadian Net-Zero Emissions Accountability Act, 2021",
      subOptions: ["2030 Emissions Reduction Plan (ERP)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-45", value: "act29",
      label: "Wastewater Systems Effluent Regulations (WSER), 2012",
      subOptions: [], // No additional regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-46", value: "act30",
      label: "Clean Fuel Regulations (CFR), 2022",
      subOptions: [], // No additional regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-47", value: "act31",
      label: "Hazardous Waste Export and Import Regulations (HWEIR), 2021",
      subOptions: [
        "Cross-border Movement of Hazardous Waste and Hazardous Recyclable Material Regulations (SOR/2021-25)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-48", value: "act32",
      label: "Single-use Plastics Prohibition Regulations, 2022",
      subOptions: [], // No additional regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-49", value: "act33",
      label: "Environmental Emergency Regulations (E2), 2019",
      subOptions: [], // No additional regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-50", value: "act34",
      label: "Canada Business Corporations Act (CBCA)",
      subOptions: [], // No regulations listed
    },
  ],
};

export const annexure7 = {
  type: "nested-dropdown",
  label: "Provincial and Territorial Environmental Framework",
  options: [
    // Alberta
    {
      id: "practicalRiskIdentificationEnvi-51", value: "act1",
      label: "Environmental Protection and Enhancement Act (EPEA), 1992",
      subOptions: [
        "Air Policy Sector, “Air Management in Alberta” (January 2009) Government of Alberta",
        "Environmental Protection and Enhancement Act, RSA 2000, e-12, s 2",
        "Environmental Protection and Enhancement Act, s 2",
        "Environmental Protection and Enhancement Act, ss 39(c), 43 & 44(1)",
        "Activities Designation Regulation, Alta Reg 276/2003, ss 2, 3 & 4",
        "Environmental Protection and Enhancement Act, ss 108 & 109",
        "Environmental Protection and Enhancement Act, ss 113, 129, 140 & 150",
        "Release Reporting Regulation, Alta Reg 117/1993",
        "Waste Control Regulation, Alta Reg 192/1996",
        "Pesticide Sales, Handling, Use and Application Regulation, Alta Reg 24/1997",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-52", value: "act2",
      label: "Water Act, 1999",
      subOptions: ["Water (Ministerial Laws), 276/2003"],
    },
    {
      id: "practicalRiskIdentificationEnvi-53", value: "act3",
      label: "Climate Change and Emissions Management Act, 2003",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-54", value: "act4",
      label: "Public Lands Act, 2000",
      subOptions: ["Public Lands Administration Regulation, Alta Reg 187/2011"],
    },
    {
      id: "practicalRiskIdentificationEnvi-55", value: "act5",
      label: "Forests Act, R.S.A. 2000, c. F-22",
      subOptions: ["Timber Management Regulation, Alta Reg 60/1973"],
    },
    {
      id: "practicalRiskIdentificationEnvi-56", value: "act6",
      label: "Mines and Minerals Act, 2000",
      subOptions: [
        "Mines and Minerals Administration Regulation, Alta Reg 262/1997",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-57", value: "act7",
      label: "Oil Sands Conservation Act, 2000",
      subOptions: ["Oil Sands Conservation Rules, Alta Reg 76/1988"],
    },
    {
      id: "practicalRiskIdentificationEnvi-58", value: "act8",
      label: "Alberta Land Stewardship Act (ALSA), 2009",
      subOptions: ["Alberta Land Stewardship Regulation, Alta Reg 247/2011"],
    },
    {
      id: "practicalRiskIdentificationEnvi-59", value: "act9",
      label: "Emissions Management and Climate Resilience Act, 2023",
      subOptions: [
        "Technology Innovation and Emissions Reduction Regulation, Alta Reg 133/2019",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-60", value: "act10",
      label: "Wildlife Act, 1984, R.S.A. 2000, c. W-10",
      subOptions: ["Wildlife Regulation, Alta Reg 143/1997"],
    },
    {
      id: "practicalRiskIdentificationEnvi-61", value: "act11",
      label: "Fisheries (Alberta) Act, R.S.A. 2000, c. F-16",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-62", value: "act12",
      label: "Coal Conservation Act, R.S.A. 2000, c. C-17",
      subOptions: ["Coal Conservation Rules, Alta Reg 270/81"],
    },
    {
      id: "practicalRiskIdentificationEnvi-63", value: "act13",
      label: "Oil and Gas Conservation Act, R.S.A. 2000, c. O-6",
      subOptions: ["Oil and Gas Conservation Rules, Alta Reg 151/1971"],
    },
    {
      id: "practicalRiskIdentificationEnvi-64", value: "act14",
      label: "Mineral Resource Development Act, 2021, c M-16.8",
      subOptions: [
        "Mineral Resource Development Regulation, Alta Reg 262/2021",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-65", value: "act15",
      label: "Gas Resources Preservation Act, R.S.A. 2000, c. G-4",
      subOptions: ["Gas Resources Preservation Regulation, Alta Reg 241/1973"],
    },
    {
      id: "practicalRiskIdentificationEnvi-66", value: "act16",
      label: "Renewable Electricity Act, 2016",
      subOptions: ["Renewable Electricity Regulation, Alta Reg 183/2016"],
    },
    // British Columbia
    {
      id: "practicalRiskIdentificationEnvi-67", value: "act17",
      label: "Environmental Management Act (EMA), 2003",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-68", value: "act18",
      label: "Water Sustainability Act, 2016",
      subOptions: ["Water Sustainability Regulation, B.C. Reg. 184/2024"],
    },
    {
      id: "practicalRiskIdentificationEnvi-69", value: "act19",
      label: "Forest and Range Practices Act (FRPA), 2002",
      subOptions: [
        "Forest Planning and Practices Regulation, B.C. Reg. 221/2024",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-70", value: "act20",
      label: "Wildlife Act, 1996",
      subOptions: ["Wildlife Act General Regulation, B.C. Reg. 161/2024"],
    },
    {
      id: "practicalRiskIdentificationEnvi-71", value: "act21",
      label: "Greenhouse Gas Reduction Targets Act, 2007",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-72", value: "act22",
      label: "Carbon Tax Act, 2008",
      subOptions: ["Carbon Tax Regulation, B.C. Reg. 186/2024"],
    },
    {
      id: "practicalRiskIdentificationEnvi-73", value: "act23",
      label: "Clean Energy Act, 2010",
      subOptions: ["Clean or Renewable Resource Regulation, B.C. Reg. 81/2011"],
    },
    {
      id: "practicalRiskIdentificationEnvi-74", value: "act24",
      label: "Heritage Conservation Act, 1996",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-75", value: "act25",
      label: "Oil and Gas Activities Act, 2008",
      subOptions: [
        "Energy Resource Activities General Regulation, B.C. Reg. 187/2023",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-76", value: "act26",
      label: "Integrated Pest Management Act, 2003",
      subOptions: ["Integrated Pest Management Regulation, B.C. Reg. 41/2024"],
    },
    {
      id: "practicalRiskIdentificationEnvi-77", value: "act27",
      label: "Ecological Reserve Act, RSBC 1996",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-78", value: "act28",
      label: "Greenhouse Gas Industrial Reporting and Control Act, 2014",
      subOptions: [
        "Greenhouse Gas Emission Reporting Regulation, B.C. Reg. 185/2024",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-79", value: "act29",
      label: "Environmental Assessment Act, 2018",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-80", value: "act30",
      label: "Land Act, 1996",
      subOptions: ["Land Act Regulation, B.C. Reg. 76/2022"],
    },
    {
      id: "practicalRiskIdentificationEnvi-81", value: "act31",
      label: "Riparian Areas Protection Regulation, 2019",
      subOptions: ["Riparian Areas Protection Regulation, B.C. Reg. 32/2023"],
    },
    {
      id: "practicalRiskIdentificationEnvi-82", value: "act32",
      label: "Climate Change Accountability Act, 2007",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-83", value: "act33",
      label: "Climate Change Accountability Act, 2019",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-84", value: "act34",
      label: "Zero-Emission Vehicles Act, 2019",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-85", value: "act35",
      label: "Drinking Water Protection Act, 2001",
      subOptions: ["Drinking Water Protection Regulation, B.C. Reg. 47/2024"],
    },
    {
      id: "practicalRiskIdentificationEnvi-86", value: "act36",
      label: "Water Protection Act, 1996",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-87", value: "act37",
      label: "Mines Act, 1996",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-88", value: "act38",
      label: "Wildfire Act, 2004",
      subOptions: ["Wildfire Regulation, B.C. Reg. 62/2024"],
    },
    {
      id: "practicalRiskIdentificationEnvi-89", value: "act39",
      label: "Water Users’ Communities Act, 1996",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-90", value: "act40",
      label: "Fish and Seafood Act, 2015",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-91", value: "act41",
      label: "Ministry of Environment Act, 1996",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-92", value: "act42",
      label: "Protected Areas of British Columbia Act, 2000",
      subOptions: [], // No regulations listed
    },
    // Manitoba
    {
      id: "practicalRiskIdentificationEnvi-93", value: "act43",
      label: "The Environment Act, 1988",
      subOptions: ["Classes of Development Regulation, Man. Reg. 164/88"],
    },
    {
      id: "practicalRiskIdentificationEnvi-94", value: "act44",
      label: "The Dangerous Goods Handling and Transportation Act, 1987",
      subOptions: [
        "Dangerous Goods Handling and Transportation Regulation, Man. Reg. 55/2003",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-95", value: "act45",
      label: "The Contaminated Sites Remediation Act, 1996",
      subOptions: [
        "Contaminated Sites Remediation Regulation, Man. Reg. 105/97",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-96", value: "act46",
      label: "The Water Protection Act, 2005",
      subOptions: ["Water Protection Regulation, Man. Reg. 126/2005"],
    },
    {
      id: "practicalRiskIdentificationEnvi-97", value: "act47",
      label: "The Ozone Depleting Substances Act, 1989-1990",
      subOptions: [
        "Ozone Depleting Substances and Other Halocarbons Regulation, Man. Reg. 103/94",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-98", value: "act48",
      label: "The Waste Reduction and Prevention (WRAP) Act, 1989-1990",
      subOptions: [
        "Waste Reduction and Prevention Regulation, Man. Reg. 10/93",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-99", value: "act49",
      label: "The Drinking Water Safety Act, 2002",
      subOptions: ["Drinking Water Safety Regulation, Man. Reg. 41/2007"],
    },
    {
      id: "practicalRiskIdentificationEnvi-100", value: "act50",
      label: "The Groundwater and Water Well Act, 2012",
      subOptions: ["Groundwater and Water Well Regulation, Man. Reg. 214/2015"],
    },
    {
      id: "practicalRiskIdentificationEnvi-101", value: "act51",
      label: "The Water Rights Act, 1988",
      subOptions: ["Water Rights Regulation, Man. Reg. 126/87"],
    },
    {
      id: "practicalRiskIdentificationEnvi-102", value: "act52",
      label: "The Water Resources Conservation Act, 2000",
      subOptions: ["Water Resources Conservation Regulation, Man Reg 179/2010"],
    },
    {
      id: "practicalRiskIdentificationEnvi-103", value: "act53",
      label: "The Ecological Reserves Act, 1987",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-104", value: "act54",
      label: "The Conservation Agreements Act, 1997",
      subOptions: ["Eligible Conservation Agencies Regulation, Man Reg 152/98"],
    },
    {
      id: "practicalRiskIdentificationEnvi-105", value: "act55",
      label: "The Efficiency Manitoba Act, 2017",
      subOptions: ["AgriInsurance Regulation, Man Reg 119/2020"],
    },
    {
      id: "practicalRiskIdentificationEnvi-106", value: "act56",
      label: "The Oil and Gas Act, 1993",
      subOptions: ["Drilling and Production Regulation, Man. Reg. 111/94"],
    },
    {
      id: "practicalRiskIdentificationEnvi-107", value: "act57",
      label:
        "The East Side Traditional Lands Planning and Special Protected Areas Act, 2009",
      subOptions: [
        "East Side Traditional Lands Planning Regulation, Man. Reg. 77/2011",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-108", value: "act58",
      label: "The Endangered Species and Ecosystems Act, 1989-1990",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-109", value: "act59",
      label: "The Mines and Minerals Act, 1991-1992",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-110", value: "act60",
      label: "The Surface Rights Act, 1987-88",
      subOptions: ["Surface Rights Regulation, Man. Reg. 159/2000"],
    },
    // New Brunswick
    {
      id: "practicalRiskIdentificationEnvi-111", value: "act61",
      label: "Clean Environment Act, 1973",
      subOptions: [
        "Environmental Impact Assessment Regulation, NB Reg 87-83",
        "Water Quality Regulation, NB Reg 82-126",
        "Petroleum Product Storage and Handling Regulation, NB Reg 87-97",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-112", value: "act62",
      label: "Clean Air Act, 1997",
      subOptions: [
        "Air Quality Regulation, NB Reg 97-133",
        "Ozone Depleting Substances and Other Halocarbons Regulation, NB Reg 97-132",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-113", value: "act63",
      label: "Clean Water Act, 1989",
      subOptions: [
        "Watercourse and Wetland Alteration Regulation, NB Reg 90-80",
        "Potable Water Regulation, NB Reg 93-203",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-114", value: "act64",
      label: "Climate Change Act, 2018",
      subOptions: [
        "Reduction of Greenhouse Gas Emissions Climate Change Act, NB Reg 2021-43",
        "Penalties Regulation Climate Change Act, 2021-44, NB Reg 2021-44",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-115", value: "act65",
      label: "Pesticide Control Act, P-8, 1973",
      subOptions: ["General Regulation, NB Reg 96-126"],
    },
    {
      id: "practicalRiskIdentificationEnvi-116", value: "act66",
      label: "Unsightly Premises Act, U-1, 1985",
      subOptions: [
        "Dangerous or Unsightly Premises and Property Regulation, NB Reg 2018-19",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-117", value: "act67",
      label: "Heritage Conservation Act, H-4.05, 2010",
      subOptions: ["General Regulation, NB Reg 2010-132"],
    },
    {
      id: "practicalRiskIdentificationEnvi-118", value: "act68",
      label: "Fish and Wildlife Act, F-14.1, 1980",
      subOptions: [
        "Wildlife Refuges and Wildlife Management Areas Regulation, NB Reg 94-43",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-119", value: "act69",
      label: "Protected Natural Areas Act, P-19.01, 2003",
      subOptions: [
        "Establishment of Protected Natural Areas Regulation, NB Reg 2003-8",
        "Protected Area Exemption Regulation, NB Reg 90-120",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-120", value: "act70",
      label: "Regional Solid Waste Commissions Regulation, 1990",
      subOptions: [], // No regulations listed
    },
    // Newfoundland and Labrador
    {
      id: "practicalRiskIdentificationEnvi-121", value: "act71",
      label: "Environmental Protection Act, 2002",
      subOptions: [
        "Environmental Assessment Regulations, 2003 (NLR 54/03)",
        "Pesticides Control Regulations, 2003 (NLR 57/03)",
        "Storage and Handling of Gasoline and Associated Products Regulations, 2003 (NLR 58/03)",
        "Air Pollution Control Regulations, 2004 (NLR 39/04)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-122", value: "act72",
      label: "Wilderness and Ecological Reserves Act, RSNL 1990, c. W-9",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-123", value: "act73",
      label: "Water Resources Act, 2002",
      subOptions: [
        "Environmental Control Water and Sewage Regulations, 2003 (NLR 65/03)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-124", value: "act74",
      label: "Urban and Rural Planning Act, 2000",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-125", value: "act75",
      label: "Waste Management Regulations, 2003",
      subOptions: ["Waste Management Regulations, 2003 (NLR 59/03)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-126", value: "act76",
      label: "Climate Change Action Plan, 2005",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-127", value: "act77",
      label: "Forest Protection Act, 1990",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-128", value: "act78",
      label: "Endangered Species Act, 2004",
      subOptions: ["Endangered Species List Regulations (NLR 57/02)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-129", value: "act79",
      label: "Wildlife Act, 1990",
      subOptions: ["Wild Life Regulations (CNLR 1156/96)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-130", value: "act80",
      label: "Fisheries Restructuring Act, 2001",
      subOptions: [], // No regulations listed
    },
    // Nova Scotia
    {
      id: "practicalRiskIdentificationEnvi-131", value: "act81",
      label: "Environment Act, 1994-1995",
      subOptions: [
        "Environmental Assessment Regulations (NS Reg 26/95)",
        "Solid Waste-Resource Management Regulations (NS Reg 25/96)",
        "Air Quality Regulations",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-132", value: "act82",
      label: "Wilderness Areas Protection Act, 1998",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-133", value: "act83",
      label: "Environmental Goals and Sustainable Prosperity Act, 2007",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-134", value: "act84",
      label: "Special Places Protection Act, RSNS 1989, c 438",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-135", value: "act85",
      label: "Crown Lands Act, 1989",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-136", value: "act86",
      label: "Forests Act, 1989",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-137", value: "act87",
      label: "Wildlife Act, 1989",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-138", value: "act88",
      label: "Non-essential Pesticides Control Act, 2010",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-139", value: "act89",
      label:
        "Importation of Hydraulic Fracturing Wastewater Prohibition Act, 2013",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-140", value: "act90",
      label: "Biodiversity Act, 2021",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-141", value: "act91",
      label: "Environmental Goals and Climate Change Reduction Act, 2021",
      subOptions: [], // No regulations listed
    },
    // Ontario
    {
      id: "practicalRiskIdentificationEnvi-142", value: "act92",
      label: "Environmental Protection Act, 1990",
      subOptions: [
        "General – Waste Management (O. Reg. 347)",
        "Air Pollution – Local Air Quality (O. Reg. 419/05)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-143", value: "act93",
      label: "Environmental Assessment Act, 1990",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-144", value: "act94",
      label: "Clean Water Act, 2006",
      subOptions: ["General Regulation (O. Reg. 287/07)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-145", value: "act95",
      label: "Safe Drinking Water Act, 2002",
      subOptions: [
        "Drinking Water Systems Regulation (O. Reg. 170/03)",
        "Ontario Drinking Water Quality Standards (O. Reg. 169/03)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-146", value: "act96",
      label: "Greenbelt Act, 2005",
      subOptions: ["Designation of Greenbelt Area (O. Reg. 59/05)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-147", value: "act97",
      label: "Ontario Water Resources Act, 1990",
      subOptions: ["Designation of Greenbelt Area (O. Reg. 59/05)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-148", value: "act98",
      label: "Pesticides Act, 1990",
      subOptions: ["General Regulation (O. Reg. 63/09)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-149", value: "act99",
      label: "Nutrient Management Act, 2002",
      subOptions: ["General Regulation (O. Reg. 267/03)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-150", value: "act100",
      label: "Endangered Species Act, 2007",
      subOptions: ["General Regulation (O. Reg. 242/08)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-151", value: "act101",
      label: "Conservation Authorities Act, 1990",
      subOptions: [
        "Development, Interference with Wetlands and Alterations to Shorelines and Watercourses (O. Reg. 97/04)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-152", value: "act102",
      label: "Environmental Bill of Rights, 1993",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-153", value: "act103",
      label: "Provincial Parks and Conservation Reserves Act, 2006",
      subOptions: ["General Regulation (O. Reg. 347/07)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-154", value: "act104",
      label: "Lakes and Rivers Improvement Act, 1990",
      subOptions: ["General Regulation (R.R.O. 1990, Reg. 854)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-155", value: "act105",
      label: "Aggregate Resources Act, 1990",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-156", value: "act106",
      label: "Crown Forest Sustainability Act, 1994",
      subOptions: ["General Regulation (O. Reg. 167/95)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-157", value: "act107",
      label: "Fish and Wildlife Conservation Act, 1997",
      subOptions: ["General Regulation (O. Reg. 665/98)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-158", value: "act108",
      label: "Resource Recovery and Circular Economy Act, 2016",
      subOptions: ["General Regulation (O. Reg. 225/18)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-159", value: "act109",
      label: "Waste-Free Ontario Act, 2016",
      subOptions: [], // No regulations listed
    },
    // Prince Edward Island
    {
      id: "practicalRiskIdentificationEnvi-160", value: "act110",
      label: "Environmental Protection Act, 1988",
      subOptions: [
        "Watercourse and Wetland Protection Regulations (PEI Reg EC720/08)",
        "Ozone Layer Protection Regulations (PEI Reg EC619/94)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-161", value: "act111",
      label: "Water Act, 2017",
      subOptions: ["Water Withdrawal Regulations (Consultation Draft)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-162", value: "act112",
      label: "Planning Act, 1988",
      subOptions: [
        "Subdivision and Development Regulations",
        "Province-Wide Minimum Development Standards Regulations",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-163", value: "act113",
      label: "Renewable Energy Act, 2005",
      subOptions: [
        "Renewable Energy Designated Areas Regulations (PEI Reg EC766/05)",
        "Development Permit Regulations",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-164", value: "act114",
      label: "Pesticides Control Act, 1988",
      subOptions: ["Pesticides Control Act Regulations (PEI Reg EC761/05)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-165", value: "act115",
      label: "Climate Leadership Act, 2018",
      subOptions: ["Climate Leadership Regulations (PEI Reg EC57/19)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-166", value: "act116",
      label: "Net-Zero Carbon Act, 2019",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-167", value: "act117",
      label: "Wildlife Conservation Act, 1988",
      subOptions: [
        "Wildlife Conservation Act General Regulations",
        "Wildlife Conservation Fund Regulations (PEI Reg EC170/09)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-168", value: "act118",
      label: "Forest Management Act, 1988",
      subOptions: ["Provincial Forests Regulations (PEI Reg EC484/00)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-169", value: "act119",
      label: "Water and Sewerage Act, 1988",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-170", value: "act120",
      label: "Fisheries Act, 1988",
      subOptions: ["Fisheries Act Regulations (PEI Reg EC873/95)"],
    },
    // Quebec
    {
      id: "practicalRiskIdentificationEnvi-171", value: "act121",
      label: "Environment Quality Act (EQA), 1972",
      subOptions: [
        "Regulation respecting the application of the Environment Quality Act, 2018 (Q-2, r. 3)",
        "Clean Air Regulation (Q-2, r. 4.1)",
        "Water Withdrawal and Protection Regulation, 2014 (Q-2, r. 35.2)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-172", value: "act122",
      label: "Sustainable Development Act, 2006",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-173", value: "act123",
      label:
        "Act Respecting the Conservation and Development of Wildlife, 1983",
      subOptions: [
        "Regulation respecting wildlife habitats (R.Q. C-61.1, r. 18)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-174", value: "act124",
      label: "Watercourses Act, 1992",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-175", value: "act125",
      label: "Mining Act, 1987",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-176", value: "act126",
      label: "Sustainable Forest Development Act, 2010",
      subOptions: [
        "Regulation respecting the sustainable development of forests in the domain of the State (A-18.1, r. 0.01)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-177", value: "act127",
      label: "Act Respecting Land Use Planning and Development, 1979",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-178", value: "act128",
      label:
        "Act respecting the preservation of agricultural land and agricultural activities, 1996",
      subOptions: [
        "Preservation of Agricultural Land and Agricultural Activities Regulation (c. P-41.1, r. 1)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-179", value: "act129",
      label: "Natural Heritage Conservation Act (NHCA), 2002",
      subOptions: [
        "Regulation respecting certain transitional measures of the Act to amend the Natural Heritage Conservation Act and other provisions, CQLR c C-61.01, r 0.1",
      ],
    },
    // Saskatchewan
    {
      id: "practicalRiskIdentificationEnvi-180", value: "act130",
      label: "Environmental Management and Protection Act, 2010",
      subOptions: [
        "The Environmental Management and Protection (General) Regulations, Chapter E-10.22 Reg 1",
        "The Environmental Management and Protection (Saskatchewan Environmental Code Adoption) Regulations, RRS c E-10.22 Reg 2",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-181", value: "act131",
      label: "Forest Resources Management Act, 1996",
      subOptions: [
        "The Forest Resources Management Regulations, Chapter F-19.1 Reg 1",
        "The Forest Resources Management (Saskatchewan Environmental Code Adoption) Regulations, RRS c F-19.1 Reg 11",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-182", value: "act132",
      label: "Water Security Agency Act, 2013",
      subOptions: [
        "The Water Security Agency Regulations, Chapter W-8.1 Reg 1",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-183", value: "act133",
      label: "Wildlife Act, 1998",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-184", value: "act134",
      label: "Environmental Assessment Act, 1980",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-185", value: "act135",
      label: "Wildlife Habitat Protection Act, 1983",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-186", value: "act136",
      label: "Pest Control Products (Saskatchewan) Act, RSS 1978, c P-8",
      subOptions: [
        "The Pest Control Products Regulations, 2015, Chapter P-8 Reg 4",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-187", value: "act137",
      label: "Saskatchewan Environmental Code, 2015",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-188", value: "act138",
      label: "Saskatchewan Climate Change Strategy, 2017",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-189", value: "act139",
      label: "Provincial Lands Act, 2016",
      subOptions: [
        "The Provincial Lands (Agriculture) Regulations, Chapter P-31.1 Reg 1",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-190", value: "act140",
      label: "Management and Reduction of Greenhouse Gases Act, 2010",
      subOptions: [
        "The Management and Reduction of Greenhouse Gases (General and Electricity Producer) Regulations, Chapter M-2.01 Reg 1",
      ],
    },
    // Northwest Territories
    {
      id: "practicalRiskIdentificationEnvi-191", value: "act141",
      label: "Environmental Protection Act, 1988",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-192", value: "act142",
      label: "Environmental Rights Act, SNWT 2023, c.8",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-193", value: "act143",
      label: "Pesticide Act, 1990",
      subOptions: ["Pesticide Regulations (R.R.N.W.T. 1990, c.P-2)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-194", value: "act144",
      label: "Waters Act, 2014",
      subOptions: ["Waters Regulations, R-019-2014"],
    },
    {
      id: "practicalRiskIdentificationEnvi-195", value: "act145",
      label: "Forest Management Act, 1998",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-196", value: "act146",
      label: "Forest Protection Act, 1988",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-197", value: "act147",
      label: "Wildlife Act, 2013",
      subOptions: ["Wildlife Act Phase 2 Regulations"],
    },
    {
      id: "practicalRiskIdentificationEnvi-198", value: "act148",
      label: "Oil and Gas Operations Act, 2014",
      subOptions: ["Oil and Gas Operations Regulations (N.W.T. Reg. 030-2014)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-199", value: "act149",
      label: "Waste Reduction and Recovery Act, 2003",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-200", value: "act150",
      label: "Mackenzie Valley Resource Management Act, 1998",
      subOptions: ["Mackenzie Valley Land Use Regulations (SOR/98-429)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-201", value: "act151",
      label: "Northwest Territories Lands Act, 2014",
      subOptions: [
        "Northwest Territories Lands Regulations (N.W.T. Reg. 018-2014)",
        "Northwest Territories Mining Regulations (SOR/2014-68)",
      ],
    },
    // Yukon
    {
      id: "practicalRiskIdentificationEnvi-202", value: "act152",
      label: "Environment Act, 1991",
      subOptions: [
        "Beverage Container Regulation (YOIC 1992/17)",
        "Solid Waste Regulation (YOIC 2003/58)",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-203", value: "act153",
      label: "Waters Act, 2003",
      subOptions: ["Waters Regulation (YOIC 2003/58)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-204", value: "act154",
      label: "Wildlife Act, 2002",
      subOptions: ["Wildlife Regulation (Y.O.I.C. 2012/84)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-205", value: "act155",
      label: "Forest Resources Act, 2008",
      subOptions: ["Forest Resources Regulation (YOIC 2010/171)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-206", value: "act156",
      label: "Clean Energy Act, 2022",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-207", value: "act157",
      label: "Waste Reduction and Recovery Act, 2003",
      subOptions: ["Designated Materials Regulation (YOIC 2003/58)"],
    },
    {
      id: "practicalRiskIdentificationEnvi-208", value: "act158",
      label: "Oil and Gas Act, RSY 2002, c 162",
      subOptions: [
        "Oil and Gas Disposition Regulations, YOIC 1999/147",
        "Oil and Gas Drilling and Production Regulations, YOIC 2004/158",
      ],
    },
    {
      id: "practicalRiskIdentificationEnvi-209", value: "act159",
      label: "Species at Risk Act (Federal), 2002",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-210", value: "act160",
      label:
        "Yukon Environmental and Socio-economic Assessment Act (YESAA), 2003",
      subOptions: [
        "Assessable Activities, Exceptions and Executive Committee Projects Regulations (SOR/2005-379)",
      ],
    },
    // Nunavut
    {
      id: "practicalRiskIdentificationEnvi-211", value: "act161",
      label: "Environmental Protection Act, 1999 (adapted)",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-212", value: "act162",
      label:
        "Nunavut Waters and Nunavut Surface Rights Tribunal Act, 2002 (Federal)",
      subOptions: ["Nunavut Waters Regulations"],
    },
    {
      id: "practicalRiskIdentificationEnvi-213", value: "act163",
      label: "Wildlife Act, 2003",
      subOptions: ["Nunavut Hunting Regulations 2022-2023"],
    },
    {
      id: "practicalRiskIdentificationEnvi-214", value: "act164",
      label: "Nunavut Planning and Project Assessment Act (NUPPAA), 2013",
      subOptions: [], // No regulations listed
    },
    {
      id: "practicalRiskIdentificationEnvi-215", value: "act165",
      label: "Species at Risk Act (Federal), 2002",
      subOptions: ["Species at Risk Act (S.C. 2002, c. 29)"],
    },
  ],
};

export const esgGuidelines = [
  // Federal Guidelines as Checkboxes
  {
    id: "esgGuidelines-1", type: "checkbox",
    label:
      "Canadian Environmental Assessment Agency (CEAA) Guidelines for Environmental Impact Assessments",
  },
  {
    id: "esgGuidelines-2", type: "checkbox",
    label:
      "Impact Assessment Agency of Canada (IAAC) Technical Guidance Documents",
  },
  {
    id: "esgGuidelines-3", type: "checkbox",
    label: "Canadian Environmental Quality Guidelines (CEQG)",
  },
  { id: "esgGuidelines-4", type: "checkbox", label: "Canadian Ambient Air Quality Standards (CAAQS)" },
  {
    id: "esgGuidelines-5", type: "checkbox",
    label: "CCME National Classification System for Contaminated Sites",
  },
  {
    id: "esgGuidelines-6", type: "checkbox",
    label: "CCME Guidelines for Canadian Drinking Water Quality",
  },
  {
    id: "esgGuidelines-7", type: "checkbox",
    label:
      "CCME Soil Quality Guidelines for Protection of Environmental and Human Health",
  },
  {
    id: "esgGuidelines-8", type: "checkbox",
    label: "CCME Water Quality Guidelines for Protection of Aquatic Life",
  },
  { id: "esgGuidelines-9", type: "checkbox", label: "CCME Canadian Sediment Quality Guidelines" },
  { id: "esgGuidelines-10", type: "checkbox", label: "CCME Wastewater Management Guidelines" },
  {
    id: "esgGuidelines-11", type: "checkbox",
    label:
      "Fisheries and Oceans Canada (DFO) Fisheries Protection Policy Statements",
  },
  {
    id: "esgGuidelines-12", type: "checkbox",
    label: "Health Canada's Guidelines for Canadian Recreational Water Quality",
  },
  {
    id: "esgGuidelines-13", type: "checkbox",
    label:
      "Health Canada's Guidance on Environmental Noise for New Residential Development",
  },
  {
    id: "esgGuidelines-14", type: "checkbox",
    label:
      "Health Canada's Federal Contaminated Sites Risk Assessment Guidelines",
  },
  {
    id: "esgGuidelines-15", type: "checkbox",
    label:
      "Health Canada's Human Health Risk Assessment for Contaminated Sites",
  },
  {
    id: "esgGuidelines-16", type: "checkbox",
    label:
      "Environment and Climate Change Canada (ECCC) Best Practices for the Prevention of Pollution",
  },
  {
    id: "esgGuidelines-17", type: "checkbox",
    label: "ECCC Code of Practice for the Management of PM2.5 Emissions",
  },
  {
    id: "esgGuidelines-18", type: "checkbox",
    label:
      "ECCC Code of Practice for the Environmental Management of Road Salts",
  },
  {
    id: "esgGuidelines-19", type: "checkbox",
    label: "ECCC Guidelines for Wildlife Surveys for Environmental Assessment",
  },
  {
    id: "esgGuidelines-20", type: "checkbox",
    label:
      "Natural Resources Canada (NRCan) Environmental Protocols for Exploration Projects",
  },
  { id: "esgGuidelines-21", type: "checkbox", label: "Canadian Biodiversity Strategy" },
  {
    id: "esgGuidelines-22", type: "checkbox",
    label: "Canadian Wetland Inventory and Classification System",
  },
  {
    id: "esgGuidelines-23", type: "checkbox",
    label: "Migratory Birds Convention Act – General Nesting Period Guidelines",
  },
  {
    id: "esgGuidelines-24", type: "checkbox",
    label:
      "Species at Risk Public Registry – Recovery Strategies and Management Plans",
  },
  {
    id: "esgGuidelines-25", type: "checkbox",
    label: "Transportation of Dangerous Goods (TDG) Guidelines",
  },
  {
    id: "esgGuidelines-26", type: "checkbox",
    label:
      "Workplace Hazardous Materials Information System (WHMIS) Requirements",
  },
  {
    id: "esgGuidelines-27", type: "checkbox",
    label: "CSA Z1000 Occupational Health and Safety Management Standard",
  },
  {
    id: "esgGuidelines-28", type: "checkbox",
    label:
      "CSA Z1002 Hazard Identification and Elimination and Risk Assessment and Control",
  },
  {
    id: "esgGuidelines-29", type: "checkbox",
    label: "CSA Z1006 Management of Work in Confined Spaces",
  },
  { id: "esgGuidelines-30", type: "checkbox", label: "CSA Z1005 Workplace Incident Investigation" },
  { id: "esgGuidelines-31", type: "checkbox", label: "CSA Z731 Emergency Preparedness and Response" },
  {
    id: "esgGuidelines-32", type: "checkbox",
    label: "CSA ISO 45001 Occupational Health and Safety Management Systems",
  },
  { id: "esgGuidelines-33", type: "checkbox", label: "CSA ISO 14001 Environmental Management Systems" },
  {
    id: "esgGuidelines-34", type: "checkbox",
    label:
      "CSA S850 Design and Assessment of Buildings Subjected to Blast Loads",
  },
  {
    id: "esgGuidelines-35", type: "checkbox",
    label: "CSA Plus 4012 Management of Contaminated Sites Technical Guide",
  },
  {
    id: "esgGuidelines-36", type: "checkbox",
    label: "CSA N288 Series Environmental Protection at Nuclear Facilities",
  },
  {
    id: "esgGuidelines-37", type: "checkbox",
    label: "ISO 14064 Greenhouse Gas Accounting and Verification",
  },
  { id: "esgGuidelines-38", type: "checkbox", label: "ISO 26000 Guidance on Social Responsibility" },
  {
    id: "esgGuidelines-39", type: "checkbox",
    label: "Canadian Dam Association (CDA) Dam Safety Guidelines",
  },
  { id: "esgGuidelines-40", type: "checkbox", label: "National Fire Code of Canada (NFCC)" },
  {
    id: "esgGuidelines-41", type: "checkbox",
    label:
      "National Building Code of Canada (NBCC) – Health and Safety Provisions",
  },
  {
    id: "esgGuidelines-42", type: "checkbox",
    label: "Canadian Best Practices Portal for Health Promotion",
  },
  { id: "esgGuidelines-43", type: "checkbox", label: "PHAC Workplace Health Guidelines" },
  {
    id: "esgGuidelines-44", type: "checkbox",
    label: "PHAC Canadian Pandemic Influenza Preparedness Guidelines",
  },
  {
    id: "esgGuidelines-45", type: "checkbox",
    label: "Canadian Electricity Association Sustainable Electricity Standard",
  },
  {
    id: "esgGuidelines-46", type: "checkbox",
    label:
      "Mining Association of Canada Towards Sustainable Mining (TSM) Protocols",
  },
  {
    id: "esgGuidelines-47", type: "checkbox",
    label: "Energy Utilities Environmental Code of Practice",
  },
  {
    id: "esgGuidelines-48", type: "checkbox",
    label: "Parks Canada Environmental Impact Assessment Guidelines",
  },
  {
    id: "esgGuidelines-49", type: "checkbox",
    label: "Parks Canada Ecological Integrity Monitoring Guidelines",
  },
  {
    id: "esgGuidelines-50", type: "checkbox",
    label: "Greenhouse Gas Emissions Reporting Technical Guidance",
  },
  {
    id: "esgGuidelines-51", type: "checkbox",
    label:
      "Federal Contaminated Sites Action Plan (FCSAP) Risk Assessment Guidance",
  },
  {
    id: "esgGuidelines-52", type: "checkbox",
    label: "CSA CAN/CSA-ISO 14064-1 GHG Quantification and Reporting",
  },
  {
    id: "esgGuidelines-53", type: "checkbox",
    label:
      "CSA Z773 Environmental Management of Petroleum and Petrochemical Sites",
  },
  { id: "esgGuidelines-54", type: "checkbox", label: "CSA W203 Erosion and Sediment Control Standard" },
  {
    id: "esgGuidelines-55", type: "checkbox",
    label: "CSA S900.1 Sustainable Forest Management Requirements",
  },
  {
    id: "esgGuidelines-56", type: "checkbox",
    label:
      "IFC Performance Standards (applicable for international project financing)",
  },
  {
    id: "esgGuidelines-57", type: "checkbox",
    label: "Equator Principles (for project financing ESG requirements)",
  },
  {
    id: "esgGuidelines-58", type: "checkbox",
    label: "World Bank Environmental, Health and Safety (EHS) Guidelines",
  },
  {
    id: "esgGuidelines-59", type: "checkbox",
    label: "Pan-Canadian Framework on Clean Growth and Climate Change",
  },
  { id: "esgGuidelines-60", type: "checkbox", label: "National Adaptation Strategy (Canada)" },
  { id: "esgGuidelines-61", type: "checkbox", label: "Canadian Wildfire Management Strategy" },
  {
    id: "esgGuidelines-62", type: "checkbox",
    label:
      "Canadian Arctic Policy Framework – Environmental and Social Guidelines",
  },
  {
    id: "esgGuidelines-63", type: "checkbox",
    label: "Indigenous Consultation Guidelines for Environmental Assessments",
  },
  { id: "esgGuidelines-64", type: "checkbox", label: "Duty to Consult and Accommodate Guidelines" },
  {
    id: "esgGuidelines-65", type: "checkbox",
    label: "Accessibility Standards Canada Accessibility Guidelines",
  },
  {
    id: "esgGuidelines-66", type: "checkbox",
    label: "Canadian Accessibility Standards for Employment",
  },
  { id: "esgGuidelines-67", type: "checkbox", label: "Climate Lens Assessment Guidance" },
  { id: "esgGuidelines-68", type: "checkbox", label: "Green Infrastructure Standards" },
  {
    id: "esgGuidelines-69", type: "checkbox",
    label: "Canadian Principles for Sustainable Infrastructure",
  },
  {
    id: "esgGuidelines-70", type: "checkbox",
    label: "CSA SPE-890 Site Decommissioning for Oil and Gas",
  },
  {
    id: "esgGuidelines-71", type: "checkbox",
    label: "CSA Z741 Decommissioning Facilities Containing Hazardous Materials",
  },
  {
    id: "esgGuidelines-72", type: "checkbox",
    label: "CSA Z1600 Emergency and Continuity Management Program",
  },
  {
    id: "esgGuidelines-73", type: "checkbox",
    label: "CSA Z1003 Psychological Health and Safety in the Workplace",
  },
  {
    id: "esgGuidelines-74", type: "checkbox",
    label:
      "Canadian Construction Association Environmental Best Practices Guide",
  },
  {
    id: "esgGuidelines-75", type: "checkbox",
    label:
      "Mining Industry Human Resources Council Indigenous Engagement Guidelines",
  },
  {
    id: "esgGuidelines-76", type: "checkbox",
    label:
      "Electricity Canada Environmental Commitment and Responsibility Program (ECRP)",
  },
  {
    id: "esgGuidelines-77", type: "checkbox",
    label:
      "Canadian Renewable Energy Association Environmental Stewardship Guidelines",
  },
  { id: "esgGuidelines-78", type: "checkbox", label: "TCFD Climate Risk Disclosure Standards" },
  {
    id: "esgGuidelines-79", type: "checkbox",
    label:
      "Canadian Corporate Social Responsibility (CSR) Voluntary Guidelines",
  },
  {
    id: "esgGuidelines-80", type: "checkbox",
    label: "National Environmental Emergency (E2) Guidelines",
  },
  // Alberta Guidelines as Nested Dropdown
  {
    id: "esgGuidelines-81", type: "nested-dropdown",
    label: "Alberta ESHS Guidelines",
    options: [
      {
        value: "ab1",
        label: "Alberta Air Management Framework",
        subOptions: [],
      },
      {
        value: "ab2",
        label: "Alberta Environmental Site Assessment Guidelines",
        subOptions: [],
      },
      {
        value: "ab3",
        label:
          "Alberta Tier 1 and Tier 2 Soil and Groundwater Remediation Guidelines",
        subOptions: [],
      },
      {
        value: "ab4",
        label:
          "Alberta Energy Regulator (AER) Directives on Health, Safety, Environment",
        subOptions: [],
      },
      {
        value: "ab5",
        label: "Alberta Traffic Safety Plan and Best Practices for Industry",
        subOptions: [],
      },
      {
        value: "ab6",
        label: "Alberta Occupational Health and Safety Code",
        subOptions: [],
      },
    ],
  },
  // British Columbia Guidelines as Nested Dropdown
  {
    id: "esgGuidelines-82", type: "nested-dropdown",
    label: "British Columbia ESHS Guidelines",
    options: [
      {
        value: "bc1",
        label: "BC Environmental Best Management Practices Series",
        subOptions: [],
      },
      {
        value: "bc2",
        label: "British Columbia Site Profile Guidance for Contaminated Sites",
        subOptions: [],
      },
      {
        value: "bc3",
        label: "BC Environmental Protection Division Technical Guidance",
        subOptions: [],
      },
      {
        value: "bc4",
        label: "BC Workers Compensation Act and OHS Regulation",
        subOptions: [],
      },
    ],
  },
  // Manitoba Guidelines as Nested Dropdown
  {
    id: "esgGuidelines-83", type: "nested-dropdown",
    label: "Manitoba ESHS Guidelines",
    options: [
      {
        value: "mb1",
        label: "Manitoba Contaminated Sites Remediation Guidelines",
        subOptions: [],
      },
      {
        value: "mb2",
        label: "Manitoba Environmental Impact Assessment Technical Guidelines",
        subOptions: [],
      },
      {
        value: "mb3",
        label: "Manitoba Workplace Safety and Health Act and Regulations",
        subOptions: [],
      },
    ],
  },
  // New Brunswick Guidelines as Nested Dropdown
  {
    id: "esgGuidelines-84", type: "nested-dropdown",
    label: "New Brunswick ESHS Guidelines",
    options: [
      {
        value: "nb1",
        label: "New Brunswick Environmental Assessment and Clean Air Guidance",
        subOptions: [],
      },
      {
        value: "nb2",
        label: "New Brunswick Occupational Health and Safety Act",
        subOptions: [],
      },
    ],
  },
  // Newfoundland and Labrador Guidelines as Nested Dropdown
  {
    id: "esgGuidelines-85", type: "nested-dropdown",
    label: "Newfoundland and Labrador ESHS Guidelines",
    options: [
      {
        value: "nl1",
        label: "Newfoundland Environmental Assessment Procedures Manual",
        subOptions: [],
      },
      {
        value: "nl2",
        label:
          "Newfoundland and Labrador Occupational Health and Safety Regulations",
        subOptions: [],
      },
    ],
  },
  // Nova Scotia Guidelines as Nested Dropdown
  {
    id: "esgGuidelines-86", type: "nested-dropdown",
    label: "Nova Scotia ESHS Guidelines",
    options: [
      {
        value: "ns1",
        label: "Nova Scotia Environmental Assessment Regulations Guidance",
        subOptions: [],
      },
      {
        value: "ns2",
        label: "Nova Scotia Occupational Health and Safety Act",
        subOptions: [],
      },
    ],
  },
  // Ontario Guidelines as Nested Dropdown
  {
    id: "esgGuidelines-87", type: "nested-dropdown",
    label: "Ontario ESHS Guidelines",
    options: [
      {
        value: "on1",
        label:
          "Ontario Environmental Site Assessment Standard (O. Reg. 153/04 Protocols)",
        subOptions: [],
      },
      {
        value: "on2",
        label: "Ontario Environmental Noise Guidelines (NPC Series)",
        subOptions: [],
      },
      {
        value: "on3",
        label:
          "Ontario Technical Standards and Safety Authority (TSSA) Environmental Health Guidelines",
        subOptions: [],
      },
      {
        value: "on4",
        label: "Ontario Occupational Health and Safety Act (OHSA)",
        subOptions: [],
      },
    ],
  },
  // Prince Edward Island Guidelines as Nested Dropdown
  {
    id: "esgGuidelines-88", type: "nested-dropdown",
    label: "Prince Edward Island ESHS Guidelines",
    options: [
      {
        value: "pe1",
        label: "PEI Contaminated Sites Guidelines",
        subOptions: [],
      },
      {
        value: "pe2",
        label: "PEI Occupational Health and Safety Act",
        subOptions: [],
      },
    ],
  },
  // Quebec Guidelines as Nested Dropdown
  {
    id: "esgGuidelines-89", type: "nested-dropdown",
    label: "Quebec ESHS Guidelines",
    options: [
      {
        value: "qc1",
        label: "Quebec Environmental Assessment Directive",
        subOptions: [],
      },
      {
        value: "qc2",
        label:
          "Quebec Soil Protection and Contaminated Sites Remediation Policy",
        subOptions: [],
      },
      {
        value: "qc3",
        label: "Quebec Act Respecting Occupational Health and Safety (AOHS)",
        subOptions: [],
      },
      {
        value: "qc4",
        label: "Quebec Building Chapter Safety Code (Chapter I – Building)",
        subOptions: [],
      },
    ],
  },
  // Saskatchewan Guidelines as Nested Dropdown
  {
    id: "esgGuidelines-90", type: "nested-dropdown",
    label: "Saskatchewan ESHS Guidelines",
    options: [
      {
        value: "sk1",
        label: "Saskatchewan Environmental Code",
        subOptions: [],
      },
      {
        value: "sk2",
        label:
          "Saskatchewan Technical Guidelines for Environmental Site Assessment and Remediation",
        subOptions: [],
      },
      {
        value: "sk3",
        label: "Saskatchewan Occupational Health and Safety Regulations",
        subOptions: [],
      },
    ],
  },
  // Northwest Territories Guidelines as Nested Dropdown
  {
    id: "esgGuidelines-91", type: "nested-dropdown",
    label: "Northwest Territories ESHS Guidelines",
    options: [
      {
        value: "nt1",
        label: "Northern Land Use Guidelines (Industrial Development)",
        subOptions: [],
      },
      {
        value: "nt2",
        label: "NWT Safety Act and Occupational Health and Safety Regulations",
        subOptions: [],
      },
    ],
  },
  // Yukon Guidelines as Nested Dropdown
  {
    id: "esgGuidelines-92", type: "nested-dropdown",
    label: "Yukon ESHS Guidelines",
    options: [
      {
        value: "yt1",
        label: "Yukon Environmental Assessment Guidelines (YESAA)",
        subOptions: [],
      },
      {
        value: "yt2",
        label: "Yukon Occupational Health and Safety Act and Regulations",
        subOptions: [],
      },
    ],
  },
  // Nunavut Guidelines as Nested Dropdown
  {
    id: "esgGuidelines-93", type: "nested-dropdown",
    label: "Nunavut ESHS Guidelines",
    options: [
      {
        value: "nu1",
        label: "Nunavut Environmental Impact Assessment Guidelines",
        subOptions: [],
      },
      {
        value: "nu2",
        label: "Nunavut Safety Act and OHS Regulations (via WSCC)",
        subOptions: [],
      },
    ],
  },
];

export const Standards_Legal_Benchmark_Cross_Check = [
  {
    heading: "",
    items: [],
  },
  // ==================== NEW SECTION 1 ====================
  {
    heading: "1. Global ESG Standards & Frameworks",
    type: "checkbox-group",
    items: [
      { id: "s1-gri", type: "checkbox", label: "GRI (Universal / Sector Standards)" },
      { id: "s1-sasb", type: "checkbox", label: "SASB / ISSB (Sector Metrics)" },
      { id: "s1-tcfd", type: "checkbox", label: "TCFD / CDP (Climate Disclosures)" },
      { id: "s1-ungc", type: "checkbox", label: "UNGC Principles / SDG Mapping" },
      {
        id: "s1-iso",
        type: "checkbox",
        label:
          "ISO Standards (ISO 14001, ISO 45001, ISO 26000, ISO 37001 Anti-Bribery, ISO 50001 Energy Mgmt)",
      },
      { id: "s1-iirc", type: "checkbox", label: "IIRC (Integrated Reporting Framework)" },
      { id: "s1-aa1000", type: "checkbox", label: "AA1000 Accountability Principles" },
      { id: "s1-other-cb", type: "checkbox", label: "Other" },
      { id: "s1-other-text", type: "text", label: "Other (specify):", placeholder: "Type here..." },
      {
        id: "s1-notes",
        type: "textarea",
        label: "Verifier Notes (Free Text):",
        placeholder: "Add comments for Global ESG Standards...",
        rows: 4,
      },
    ],
  },

  // ==================== NEW SECTION 2 ====================
  {
    heading: "2. National / Country-Specific Laws",
    type: "checkbox-group",
    items: [
      {
        id: "s2-env",
        type: "checkbox",
        label:
          "Environmental Regulations (Air, Water, Waste, Biodiversity, Noise)",
      },
      {
        id: "s2-labor",
        type: "checkbox",
        label:
          "Labor & Human Rights (ILO Codes, Child/Forced Labor, Diversity, DEI Laws)",
      },
      {
        id: "s2-health",
        type: "checkbox",
        label:
          "Occupational Health & Safety (Permits, PPE, Work Hours, JSA/HIRA)",
      },
      {
        id: "s2-corp",
        type: "checkbox",
        label:
          "Corporate / Financial Disclosure Rules (SEC, EU CSRD, India BRSR, UK Modern Slavery Act)",
      },
      {
        id: "s2-country",
        type: "checkbox",
        label: "Country-Specific ESG / CSR / Sustainability Legislation",
      },
      {
        id: "s2-data",
        type: "checkbox",
        label: "Data Protection & Privacy (GDPR, HIPAA if relevant)",
      },
      { id: "s2-other-cb", type: "checkbox", label: "Other" },
      { id: "s2-other-text", type: "text", label: "Other (specify):", placeholder: "Type here..." },
      {
        id: "s2-notes",
        type: "textarea",
        label: "Verifier Notes (Free Text):",
        placeholder: "Add comments for National Laws...",
        rows: 4,
      },
    ],
  },

  // ==================== NEW SECTION 3 ====================
  {
    heading: "3. Sector-Specific Norms & Guidelines",
    type: "checkbox-group",
    items: [
      {
        id: "s3-construction",
        type: "checkbox",
        label:
          "Construction / Infrastructure (IFC PS1–8, FIDIC sustainability guidance)",
      },
      {
        id: "s3-mining",
        type: "checkbox",
        label:
          "Mining / Extraction (ICMM Standards, Tailings, Acid Drainage, IRMA)",
      },
      {
        id: "s3-energy",
        type: "checkbox",
        label:
          "Energy / Utilities (Carbon Intensity, Renewables, IEA standards, EU Taxonomy)",
      },
      {
        id: "s3-healthcare",
        type: "checkbox",
        label:
          "Healthcare / Laboratory (Biohazard, WHO Standards, OSHA healthcare-specific)",
      },
      {
        id: "s3-agriculture",
        type: "checkbox",
        label:
          "Agriculture / Forestry (FAO, FSC, RSPO, Rainforest Alliance, Global GAP)",
      },
      {
        id: "s3-manufacturing",
        type: "checkbox",
        label:
          "Manufacturing / Industry (Lean/OHSAS, Process Safety, Responsible Care Initiative)",
      },
      {
        id: "s3-it",
        type: "checkbox",
        label:
          "IT / Telecom / Data Centers (GHG Scope 2, Energy Efficiency, ISO 27001 links, Green ICT)",
      },
      {
        id: "s3-transport",
        type: "checkbox",
        label:
          "Transport & Logistics (IMO, ICAO, IATA, CORSIA aviation carbon rules)",
      },
      {
        id: "s3-finance",
        type: "checkbox",
        label:
          "Finance / Banking (PRI, GFANZ, Sustainable Finance Disclosure Regulation – SFDR)",
      },
      { id: "s3-other-cb", type: "checkbox", label: "Other" },
      { id: "s3-other-text", type: "text", label: "Other (specify):", placeholder: "Type here..." },
      {
        id: "s3-notes",
        type: "textarea",
        label: "Verifier Notes (Free Text):",
        placeholder: "Add comments for Sector-Specific Norms...",
        rows: 4,
      },
    ],
  },

  // ==================== NEW SECTION 4 ====================
  {
    heading: "4. Other Commitments & Voluntary Codes",
    type: "checkbox-group",
    items: [
      { id: "s4-ifc", type: "checkbox", label: "IFC Performance Standards (PS1–PS8)" },
      { id: "s4-oecd", type: "checkbox", label: "OECD Guidelines for Multinationals" },
      {
        id: "s4-equator",
        type: "checkbox",
        label: "Equator Principles (if financial/infra project)",
      },
      { id: "s4-supplier", type: "checkbox", label: "Corporate ESG / Supplier Codes of Conduct" },
      {
        id: "s4-loan",
        type: "checkbox",
        label:
          "ESG Loan / Bond Covenants (Green Bonds, Sustainability-Linked Loans, EU Green Bond Standard)",
      },
      {
        id: "s4-unpri",
        type: "checkbox",
        label: "UN PRI (Principles for Responsible Investment)",
      },
      { id: "s4-sbti", type: "checkbox", label: "Science Based Targets initiative (SBTi)" },
      {
        id: "s4-re100",
        type: "checkbox",
        label: "RE100, EP100, EV100 (climate/energy voluntary pledges)",
      },
      { id: "s4-other-cb", type: "checkbox", label: "Other" },
      { id: "s4-other-text", type: "text", label: "Other (specify):", placeholder: "Type here..." },
      {
        id: "s4-notes",
        type: "textarea",
        label: "Verifier Notes (Free Text):",
        placeholder: "Add final comments or observations...",
        rows: 5,
      },
    ],
  },
];

export const Verification_Checks = [
  {
    heading: "",
    items: [],
  },
  // Data Validation & Analytical Cross-Check

  {
    heading: "1. Data Validation & Analytical Cross-Check",
    type: "checkbox-group",
    items: [
      {
        id: "vc1-historical",
        type: "checkbox",
        label:
          "Compare reported values against historical datasets (last quarter, last year, multi-year trend)",
      },
      {
        id: "vc1-prev-findings",
        type: "checkbox",
        label:
          "Check against previous verification findings (recurring gaps, recurring non-compliances)",
      },
      {
        id: "vc1-targets",
        type: "checkbox",
        label:
          "Validate against targets, KPIs, and ESG commitments (e.g., Net Zero 2030, Zero Harm)",
      },
      {
        id: "vc1-benchmark",
        type: "checkbox",
        label: "Benchmark against peer/industry averages (AI-assisted)",
      },
      {
        id: "vc1-anomalies",
        type: "checkbox",
        label:
          "Identify anomalies or too perfect numbers (e.g., zero accidents for 5 years)",
      },
      {
        id: "vc1-notes",
        type: "textarea",
        label: "Verifier Notes (Free Text):",
        placeholder: "Koi bhi observation yahan likho...",
        rows: 4,
      },
    ],
  },

  {
    heading: "2. Consistency & Integrity Check",
    type: "checkbox-group",
    items: [
      {
        id: "vc2-units",
        type: "checkbox",
        label: "Units and terminology consistent across the report",
      },
      {
        id: "vc2-standards",
        type: "checkbox",
        label: "Cross-referenced with standards (GRI, SASB, ISO clauses)",
      },
      {
        id: "vc2-claims",
        type: "checkbox",
        label: "ESG claims validated (Carbon Neutral, etc.)",
      },
      {
        id: "vc2-contradictions",
        type: "checkbox",
        label: "Identify contradictions (waste badha but Zero Waste claim)",
      },
      { id: "vc2-lineage", type: "checkbox", label: "Trace data lineage (source → report)" },
      { id: "vc2-notes", type: "textarea", label: "Verifier Notes (Free Text):", rows: 4 },
    ],
  },

  {
    heading: "3. Historical & Predictive Analysis",
    type: "checkbox-group",
    items: [
      { id: "vc3-trends", type: "checkbox", label: "Compare with past 3-5 year trends" },
      { id: "vc3-regressions", type: "checkbox", label: "Identify improvements or regressions" },
      { id: "vc3-forecast", type: "checkbox", label: "Forecast potential risks (AI-based)" },
      { id: "vc3-sbti", type: "checkbox", label: "Benchmark against SBTi / Paris Agreement" },
      { id: "vc3-gaps", type: "checkbox", label: "Check if last year's gaps closed" },
      { id: "vc3-notes", type: "textarea", label: "Verifier Notes (Free Text):", rows: 4 },
    ],
  },

  {
    heading: "4. AI-Supported Verification",
    type: "checkbox-group",
    items: [
      {
        id: "vc4-completeness",
        type: "checkbox",
        label: "Completeness - all mandatory sections filled",
      },
      {
        id: "vc4-consistency",
        type: "checkbox",
        label: "Consistency - duplicate/contradictory entries flagged",
      },
      {
        id: "vc4-variance",
        type: "checkbox",
        label: "Historical Variance - abnormal trend deviations flagged",
      },
      {
        id: "vc4-closure",
        type: "checkbox",
        label: "Gap Closure - last year's non-compliances addressed?",
      },
      {
        id: "vc4-predictive",
        type: "checkbox",
        label: "Predictive Alerts - future non-compliance risk",
      },
      { id: "vc4-notes", type: "textarea", label: "Verifier Notes (Free Text):", rows: 4 },
      {
        id: "vc4-score",
        type: "text",
        label: "Verification Readiness Score (%)",
        placeholder: "e.g. 95",
        style: { fontWeight: "bold" },
      },
    ],
  },
];
export const Reviewand_Findings = [
  // NEW SECTION – JO TUMNE ABHI MANGA THA
  {
    heading: "1. Detailed Report (Full Narrative Findings)",
    type: "checkbox-group",
    items: [
      {
        id: "rf1-notes",
        type: "checkbox",
        label:
          "Comprehensive Verification Notes → Expanded written findings on compliance/non-compliance",
      },
      {
        id: "rf1-gap",
        type: "checkbox",
        label:
          "Gap Analysis → Highlight missing evidence, inconsistencies, or standards not met",
      },
      {
        id: "rf1-risk",
        type: "checkbox",
        label:
          "Risk Rating & Impact → Categorize findings as Low / Medium / High",
      },
      {
        id: "rf1-action",
        type: "checkbox",
        label:
          "Corrective Action Plan → Specify required actions, responsible persons, and deadlines",
      },
      {
        id: "rf1-status",
        type: "checkbox",
        label:
          "Verification Status → Verified / Needs Clarification / Non-Compliant",
      },
      {
        id: "rf1-full",
        type: "checkbox",
        label:
          "Full Detailed Report → Complete Comprehensive Reports include all analysis, Gaps identifications, Action Plan and cross checks",
      },
    ],
  },
];
